export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Hex: { input: any; output: any; }
  Json: { input: any; output: any; }
  Long: { input: any; output: any; }
  RGBAHue: { input: any; output: any; }
  RGBATransparency: { input: any; output: any; }
  RichTextAST: { input: any; output: any; }
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

export type Alert = Entity & {
  __typename?: 'Alert';
  alertMessage: Array<AlertalertMessageUnion>;
  alertStatus?: Maybe<EdsStatus>;
  /** Title for Alert Inline Variant */
  alertTitle?: Maybe<Text>;
  alertVariant: EdsAlertVariant;
  /** Handled client side */
  hide?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AlertAlertMessageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type AlertAlertTitleArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AlertConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AlertWhereUniqueInput;
};

/** A connection to a list of items. */
export type AlertConnection = {
  __typename?: 'AlertConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AlertEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AlertCreateInput = {
  alertMessage?: InputMaybe<AlertalertMessageUnionCreateManyInlineInput>;
  alertStatus?: InputMaybe<EdsStatus>;
  alertTitle?: InputMaybe<TextCreateOneInlineInput>;
  alertVariant: EdsAlertVariant;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlertCreateManyInlineInput = {
  /** Create and connect multiple existing Alert documents */
  create?: InputMaybe<Array<AlertCreateInput>>;
};

export type AlertCreateOneInlineInput = {
  /** Create and connect one Alert document */
  create?: InputMaybe<AlertCreateInput>;
};

export type AlertCreateWithPositionInput = {
  /** Document to create */
  data: AlertCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type AlertEdge = {
  __typename?: 'AlertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Alert;
};

/** Identifies documents */
export type AlertManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlertWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlertWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlertWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  alertMessage_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  alertMessage_some?: InputMaybe<AlertalertMessageUnionWhereInput>;
  alertStatus?: InputMaybe<EdsStatus>;
  /** All values that are contained in given list. */
  alertStatus_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  alertStatus_not?: InputMaybe<EdsStatus>;
  /** All values that are not contained in given list. */
  alertStatus_not_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  alertTitle?: InputMaybe<TextWhereInput>;
  alertVariant?: InputMaybe<EdsAlertVariant>;
  /** All values that are contained in given list. */
  alertVariant_in?: InputMaybe<Array<InputMaybe<EdsAlertVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  alertVariant_not?: InputMaybe<EdsAlertVariant>;
  /** All values that are not contained in given list. */
  alertVariant_not_in?: InputMaybe<Array<InputMaybe<EdsAlertVariant>>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hide_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum AlertOrderByInput {
  AlertStatusAsc = 'alertStatus_ASC',
  AlertStatusDesc = 'alertStatus_DESC',
  AlertVariantAsc = 'alertVariant_ASC',
  AlertVariantDesc = 'alertVariant_DESC',
  HideAsc = 'hide_ASC',
  HideDesc = 'hide_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type AlertParent = ProductDisclaimer | SectionContent;

export type AlertParentConnectInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type AlertParentCreateInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type AlertParentCreateManyInlineInput = {
  /** Create and connect multiple existing AlertParent documents */
  create?: InputMaybe<Array<AlertParentCreateInput>>;
};

export type AlertParentCreateOneInlineInput = {
  /** Create and connect one AlertParent document */
  create?: InputMaybe<AlertParentCreateInput>;
};

export type AlertParentCreateWithPositionInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerCreateWithPositionInput>;
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type AlertParentUpdateInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type AlertParentUpdateManyInlineInput = {
  /** Create and connect multiple AlertParent component instances */
  create?: InputMaybe<Array<AlertParentCreateWithPositionInput>>;
  /** Delete multiple AlertParent documents */
  delete?: InputMaybe<Array<AlertParentWhereUniqueInput>>;
  /** Update multiple AlertParent component instances */
  update?: InputMaybe<Array<AlertParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple AlertParent component instances */
  upsert?: InputMaybe<Array<AlertParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AlertParentUpdateManyWithNestedWhereInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type AlertParentUpdateOneInlineInput = {
  /** Create and connect one AlertParent document */
  create?: InputMaybe<AlertParentCreateInput>;
  /** Delete currently connected AlertParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AlertParent document */
  update?: InputMaybe<AlertParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AlertParent document */
  upsert?: InputMaybe<AlertParentUpsertWithNestedWhereUniqueInput>;
};

export type AlertParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type AlertParentUpdateWithNestedWhereUniqueInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type AlertParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type AlertParentUpsertWithNestedWhereUniqueInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type AlertParentWhereInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type AlertParentWhereUniqueInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type AlertUpdateInput = {
  alertMessage?: InputMaybe<AlertalertMessageUnionUpdateManyInlineInput>;
  alertStatus?: InputMaybe<EdsStatus>;
  alertTitle?: InputMaybe<TextUpdateOneInlineInput>;
  alertVariant?: InputMaybe<EdsAlertVariant>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
};

export type AlertUpdateManyInlineInput = {
  /** Create and connect multiple Alert component instances */
  create?: InputMaybe<Array<AlertCreateWithPositionInput>>;
  /** Delete multiple Alert documents */
  delete?: InputMaybe<Array<AlertWhereUniqueInput>>;
  /** Update multiple Alert component instances */
  update?: InputMaybe<Array<AlertUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Alert component instances */
  upsert?: InputMaybe<Array<AlertUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AlertUpdateManyInput = {
  alertStatus?: InputMaybe<EdsStatus>;
  alertVariant?: InputMaybe<EdsAlertVariant>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
};

export type AlertUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AlertUpdateManyInput;
  /** Document search */
  where: AlertWhereInput;
};

export type AlertUpdateOneInlineInput = {
  /** Create and connect one Alert document */
  create?: InputMaybe<AlertCreateInput>;
  /** Delete currently connected Alert document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Alert document */
  update?: InputMaybe<AlertUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Alert document */
  upsert?: InputMaybe<AlertUpsertWithNestedWhereUniqueInput>;
};

export type AlertUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<AlertUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AlertWhereUniqueInput;
};

export type AlertUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AlertUpdateInput;
  /** Unique document search */
  where: AlertWhereUniqueInput;
};

export type AlertUpsertInput = {
  /** Create document if it didn't exist */
  create: AlertCreateInput;
  /** Update document if it exists */
  update: AlertUpdateInput;
};

export type AlertUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<AlertUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: AlertWhereUniqueInput;
};

export type AlertUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AlertUpsertInput;
  /** Unique document search */
  where: AlertWhereUniqueInput;
};

/** Identifies documents */
export type AlertWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlertWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlertWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlertWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  alertMessage_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  alertMessage_some?: InputMaybe<AlertalertMessageUnionWhereInput>;
  alertStatus?: InputMaybe<EdsStatus>;
  /** All values that are contained in given list. */
  alertStatus_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  alertStatus_not?: InputMaybe<EdsStatus>;
  /** All values that are not contained in given list. */
  alertStatus_not_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  alertTitle?: InputMaybe<TextWhereInput>;
  alertVariant?: InputMaybe<EdsAlertVariant>;
  /** All values that are contained in given list. */
  alertVariant_in?: InputMaybe<Array<InputMaybe<EdsAlertVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  alertVariant_not?: InputMaybe<EdsAlertVariant>;
  /** All values that are not contained in given list. */
  alertVariant_not_in?: InputMaybe<Array<InputMaybe<EdsAlertVariant>>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hide_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Alert record uniquely */
export type AlertWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AlertalertMessageUnion = Text;

export type AlertalertMessageUnionConnectInput = {
  Text?: InputMaybe<TextConnectInput>;
};

export type AlertalertMessageUnionCreateInput = {
  Text?: InputMaybe<TextCreateInput>;
};

export type AlertalertMessageUnionCreateManyInlineInput = {
  /** Create and connect multiple existing AlertalertMessageUnion documents */
  create?: InputMaybe<Array<AlertalertMessageUnionCreateInput>>;
};

export type AlertalertMessageUnionCreateOneInlineInput = {
  /** Create and connect one AlertalertMessageUnion document */
  create?: InputMaybe<AlertalertMessageUnionCreateInput>;
};

export type AlertalertMessageUnionCreateWithPositionInput = {
  Text?: InputMaybe<TextCreateWithPositionInput>;
};

export type AlertalertMessageUnionUpdateInput = {
  Text?: InputMaybe<TextUpdateInput>;
};

export type AlertalertMessageUnionUpdateManyInlineInput = {
  /** Create and connect multiple AlertalertMessageUnion component instances */
  create?: InputMaybe<Array<AlertalertMessageUnionCreateWithPositionInput>>;
  /** Delete multiple AlertalertMessageUnion documents */
  delete?: InputMaybe<Array<AlertalertMessageUnionWhereUniqueInput>>;
  /** Update multiple AlertalertMessageUnion component instances */
  update?: InputMaybe<Array<AlertalertMessageUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple AlertalertMessageUnion component instances */
  upsert?: InputMaybe<Array<AlertalertMessageUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type AlertalertMessageUnionUpdateManyWithNestedWhereInput = {
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
};

export type AlertalertMessageUnionUpdateOneInlineInput = {
  /** Create and connect one AlertalertMessageUnion document */
  create?: InputMaybe<AlertalertMessageUnionCreateInput>;
  /** Delete currently connected AlertalertMessageUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AlertalertMessageUnion document */
  update?: InputMaybe<AlertalertMessageUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AlertalertMessageUnion document */
  upsert?: InputMaybe<AlertalertMessageUnionUpsertWithNestedWhereUniqueInput>;
};

export type AlertalertMessageUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type AlertalertMessageUnionUpdateWithNestedWhereUniqueInput = {
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
};

export type AlertalertMessageUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type AlertalertMessageUnionUpsertWithNestedWhereUniqueInput = {
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type AlertalertMessageUnionWhereInput = {
  Text?: InputMaybe<TextWhereInput>;
};

export type AlertalertMessageUnionWhereUniqueInput = {
  Text?: InputMaybe<TextWhereUniqueInput>;
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  altText?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  fallbackImage?: Maybe<Asset>;
  fallbackImageAsset: Array<Asset>;
  /** The file name */
  fileName: Scalars['String']['output'];
  /** The file handle */
  handle: Scalars['String']['output'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  /** List of Asset versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  mobileImage?: Maybe<Asset>;
  mobileImageAsset: Array<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetFallbackImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Asset system model */
export type AssetFallbackImageAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Asset system model */
export type AssetMobileImageAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  assetCardLink?: InputMaybe<CardLinkCreateManyInlineInput>;
  backgroundImageConfigSection?: InputMaybe<ConfigContentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fallbackImage?: InputMaybe<AssetCreateOneInlineInput>;
  fallbackImageAsset?: InputMaybe<AssetCreateManyInlineInput>;
  fallbackImageVideo?: InputMaybe<VideoCreateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  imageEdsTooltip?: InputMaybe<TooltipCreateManyInlineInput>;
  imageImageTag?: InputMaybe<ImageTagCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  mediaVideo?: InputMaybe<VideoCreateManyInlineInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  mobileImageAsset?: InputMaybe<AssetCreateManyInlineInput>;
  openGraphImageSeo?: InputMaybe<ConfigSeoMetaTagsCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fallbackImage?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_every?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_none?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_some?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  mobileImageAsset_every?: InputMaybe<AssetWhereInput>;
  mobileImageAsset_none?: InputMaybe<AssetWhereInput>;
  mobileImageAsset_some?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  assetCardLink?: InputMaybe<CardLinkUpdateManyInlineInput>;
  backgroundImageConfigSection?: InputMaybe<ConfigContentUpdateManyInlineInput>;
  fallbackImage?: InputMaybe<AssetUpdateOneInlineInput>;
  fallbackImageAsset?: InputMaybe<AssetUpdateManyInlineInput>;
  fallbackImageVideo?: InputMaybe<VideoUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  imageEdsTooltip?: InputMaybe<TooltipUpdateManyInlineInput>;
  imageImageTag?: InputMaybe<ImageTagUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  mediaVideo?: InputMaybe<VideoUpdateManyInlineInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  mobileImageAsset?: InputMaybe<AssetUpdateManyInlineInput>;
  openGraphImageSeo?: InputMaybe<ConfigSeoMetaTagsUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  /** altText input for default locale (en) */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>;
};

export type AssetUpdateManyLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  AssetCreatePending = 'ASSET_CREATE_PENDING',
  AssetErrorUpload = 'ASSET_ERROR_UPLOAD',
  AssetUpdatePending = 'ASSET_UPDATE_PENDING',
  AssetUploadComplete = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  altText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  altText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  altText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  altText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  altText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fallbackImage?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_every?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_none?: InputMaybe<AssetWhereInput>;
  fallbackImageAsset_some?: InputMaybe<AssetWhereInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  mobileImageAsset_every?: InputMaybe<AssetWhereInput>;
  mobileImageAsset_none?: InputMaybe<AssetWhereInput>;
  mobileImageAsset_some?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

export type Button = Entity & {
  __typename?: 'Button';
  /** Optional. Setting this will make the Button into as="a" anchor link. */
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<EdsIcon>;
  iconPosition?: Maybe<EdsIconPosition>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Button>;
  size?: Maybe<EdsSize>;
  /** System stage field */
  stage: Stage;
  /** ID used to map correct attributes. DO NOT CHANGE without confirmation. */
  ukey: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Defaults to "cta" */
  variant?: Maybe<EdsButtonVariant>;
};


export type ButtonLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type ButtonUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type ButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type ButtonConnection = {
  __typename?: 'ButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ButtonCreateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  iconPosition?: InputMaybe<EdsIconPosition>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ButtonCreateLocalizationsInput>;
  size?: InputMaybe<EdsSize>;
  ukey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<EdsButtonVariant>;
};

export type ButtonCreateLocalizationDataInput = {
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ButtonCreateLocalizationInput = {
  /** Localization input */
  data: ButtonCreateLocalizationDataInput;
  locale: Locale;
};

export type ButtonCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ButtonCreateLocalizationInput>>;
};

export type ButtonCreateManyInlineInput = {
  /** Create and connect multiple existing Button documents */
  create?: InputMaybe<Array<ButtonCreateInput>>;
};

export type ButtonCreateOneInlineInput = {
  /** Create and connect one Button document */
  create?: InputMaybe<ButtonCreateInput>;
};

export type ButtonCreateWithPositionInput = {
  /** Document to create */
  data: ButtonCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ButtonEdge = {
  __typename?: 'ButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Button;
};

/** Identifies documents */
export type ButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  iconPosition?: InputMaybe<EdsIconPosition>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<EdsIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<EdsIconPosition>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<EdsIconPosition>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<EdsSize>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<EdsSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<EdsSize>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<EdsSize>>>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<EdsButtonVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<EdsButtonVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<EdsButtonVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<EdsButtonVariant>>>;
};

export enum ButtonOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconPositionAsc = 'iconPosition_ASC',
  IconPositionDesc = 'iconPosition_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UkeyAsc = 'ukey_ASC',
  UkeyDesc = 'ukey_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type ButtonParent = ContentBlock | SectionContent;

export type ButtonParentConnectInput = {
  ContentBlock?: InputMaybe<ContentBlockConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type ButtonParentCreateInput = {
  ContentBlock?: InputMaybe<ContentBlockCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type ButtonParentCreateManyInlineInput = {
  /** Create and connect multiple existing ButtonParent documents */
  create?: InputMaybe<Array<ButtonParentCreateInput>>;
};

export type ButtonParentCreateOneInlineInput = {
  /** Create and connect one ButtonParent document */
  create?: InputMaybe<ButtonParentCreateInput>;
};

export type ButtonParentCreateWithPositionInput = {
  ContentBlock?: InputMaybe<ContentBlockCreateWithPositionInput>;
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type ButtonParentUpdateInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type ButtonParentUpdateManyInlineInput = {
  /** Create and connect multiple ButtonParent component instances */
  create?: InputMaybe<Array<ButtonParentCreateWithPositionInput>>;
  /** Delete multiple ButtonParent documents */
  delete?: InputMaybe<Array<ButtonParentWhereUniqueInput>>;
  /** Update multiple ButtonParent component instances */
  update?: InputMaybe<Array<ButtonParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ButtonParent component instances */
  upsert?: InputMaybe<Array<ButtonParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ButtonParentUpdateManyWithNestedWhereInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type ButtonParentUpdateOneInlineInput = {
  /** Create and connect one ButtonParent document */
  create?: InputMaybe<ButtonParentCreateInput>;
  /** Delete currently connected ButtonParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ButtonParent document */
  update?: InputMaybe<ButtonParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ButtonParent document */
  upsert?: InputMaybe<ButtonParentUpsertWithNestedWhereUniqueInput>;
};

export type ButtonParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ButtonParentUpdateWithNestedWhereUniqueInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type ButtonParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ContentBlock?: InputMaybe<ContentBlockUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ButtonParentUpsertWithNestedWhereUniqueInput = {
  ContentBlock?: InputMaybe<ContentBlockUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type ButtonParentWhereInput = {
  ContentBlock?: InputMaybe<ContentBlockWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type ButtonParentWhereUniqueInput = {
  ContentBlock?: InputMaybe<ContentBlockWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type ButtonUpdateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  iconPosition?: InputMaybe<EdsIconPosition>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ButtonUpdateLocalizationsInput>;
  size?: InputMaybe<EdsSize>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<EdsButtonVariant>;
};

export type ButtonUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ButtonUpdateLocalizationInput = {
  data: ButtonUpdateLocalizationDataInput;
  locale: Locale;
};

export type ButtonUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ButtonCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ButtonUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ButtonUpsertLocalizationInput>>;
};

export type ButtonUpdateManyInlineInput = {
  /** Create and connect multiple Button component instances */
  create?: InputMaybe<Array<ButtonCreateWithPositionInput>>;
  /** Delete multiple Button documents */
  delete?: InputMaybe<Array<ButtonWhereUniqueInput>>;
  /** Update multiple Button component instances */
  update?: InputMaybe<Array<ButtonUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Button component instances */
  upsert?: InputMaybe<Array<ButtonUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ButtonUpdateManyInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  iconPosition?: InputMaybe<EdsIconPosition>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ButtonUpdateManyLocalizationsInput>;
  size?: InputMaybe<EdsSize>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<EdsButtonVariant>;
};

export type ButtonUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ButtonUpdateManyLocalizationInput = {
  data: ButtonUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ButtonUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ButtonUpdateManyLocalizationInput>>;
};

export type ButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ButtonUpdateManyInput;
  /** Document search */
  where: ButtonWhereInput;
};

export type ButtonUpdateOneInlineInput = {
  /** Create and connect one Button document */
  create?: InputMaybe<ButtonCreateInput>;
  /** Delete currently connected Button document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Button document */
  update?: InputMaybe<ButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Button document */
  upsert?: InputMaybe<ButtonUpsertWithNestedWhereUniqueInput>;
};

export type ButtonUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ButtonUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ButtonWhereUniqueInput;
};

export type ButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ButtonUpdateInput;
  /** Unique document search */
  where: ButtonWhereUniqueInput;
};

export type ButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: ButtonCreateInput;
  /** Update document if it exists */
  update: ButtonUpdateInput;
};

export type ButtonUpsertLocalizationInput = {
  create: ButtonCreateLocalizationDataInput;
  locale: Locale;
  update: ButtonUpdateLocalizationDataInput;
};

export type ButtonUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ButtonUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ButtonWhereUniqueInput;
};

export type ButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ButtonUpsertInput;
  /** Unique document search */
  where: ButtonWhereUniqueInput;
};

/** Identifies documents */
export type ButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  iconPosition?: InputMaybe<EdsIconPosition>;
  /** All values that are contained in given list. */
  iconPosition_in?: InputMaybe<Array<InputMaybe<EdsIconPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  iconPosition_not?: InputMaybe<EdsIconPosition>;
  /** All values that are not contained in given list. */
  iconPosition_not_in?: InputMaybe<Array<InputMaybe<EdsIconPosition>>>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<EdsSize>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<EdsSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<EdsSize>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<EdsSize>>>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<EdsButtonVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<EdsButtonVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<EdsButtonVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<EdsButtonVariant>>>;
};

/** References Button record uniquely */
export type ButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CardLink = Entity & {
  __typename?: 'CardLink';
  /** Card Image */
  asset: Asset;
  description: Scalars['String']['output'];
  href: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CardLink>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CardLinkAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CardLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CardLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CardLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CardLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type CardLinkConnection = {
  __typename?: 'CardLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CardLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CardLinkCreateInput = {
  asset: AssetCreateOneInlineInput;
  /** description input for default locale (en) */
  description: Scalars['String']['input'];
  href: Scalars['String']['input'];
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CardLinkCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CardLinkCreateLocalizationDataInput = {
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CardLinkCreateLocalizationInput = {
  /** Localization input */
  data: CardLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type CardLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CardLinkCreateLocalizationInput>>;
};

export type CardLinkCreateManyInlineInput = {
  /** Create and connect multiple existing CardLink documents */
  create?: InputMaybe<Array<CardLinkCreateInput>>;
};

export type CardLinkCreateOneInlineInput = {
  /** Create and connect one CardLink document */
  create?: InputMaybe<CardLinkCreateInput>;
};

export type CardLinkCreateWithPositionInput = {
  /** Document to create */
  data: CardLinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CardLinkEdge = {
  __typename?: 'CardLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CardLink;
};

/** Identifies documents */
export type CardLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CardLinkOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CardLinkParent = CardLinks | SectionContent;

export type CardLinkParentConnectInput = {
  CardLinks?: InputMaybe<CardLinksConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type CardLinkParentCreateInput = {
  CardLinks?: InputMaybe<CardLinksCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type CardLinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing CardLinkParent documents */
  create?: InputMaybe<Array<CardLinkParentCreateInput>>;
};

export type CardLinkParentCreateOneInlineInput = {
  /** Create and connect one CardLinkParent document */
  create?: InputMaybe<CardLinkParentCreateInput>;
};

export type CardLinkParentCreateWithPositionInput = {
  CardLinks?: InputMaybe<CardLinksCreateWithPositionInput>;
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type CardLinkParentUpdateInput = {
  CardLinks?: InputMaybe<CardLinksUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type CardLinkParentUpdateManyInlineInput = {
  /** Create and connect multiple CardLinkParent component instances */
  create?: InputMaybe<Array<CardLinkParentCreateWithPositionInput>>;
  /** Delete multiple CardLinkParent documents */
  delete?: InputMaybe<Array<CardLinkParentWhereUniqueInput>>;
  /** Update multiple CardLinkParent component instances */
  update?: InputMaybe<Array<CardLinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CardLinkParent component instances */
  upsert?: InputMaybe<Array<CardLinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CardLinkParentUpdateManyWithNestedWhereInput = {
  CardLinks?: InputMaybe<CardLinksUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type CardLinkParentUpdateOneInlineInput = {
  /** Create and connect one CardLinkParent document */
  create?: InputMaybe<CardLinkParentCreateInput>;
  /** Delete currently connected CardLinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardLinkParent document */
  update?: InputMaybe<CardLinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardLinkParent document */
  upsert?: InputMaybe<CardLinkParentUpsertWithNestedWhereUniqueInput>;
};

export type CardLinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CardLinks?: InputMaybe<CardLinksUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CardLinkParentUpdateWithNestedWhereUniqueInput = {
  CardLinks?: InputMaybe<CardLinksUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type CardLinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CardLinks?: InputMaybe<CardLinksUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CardLinkParentUpsertWithNestedWhereUniqueInput = {
  CardLinks?: InputMaybe<CardLinksUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type CardLinkParentWhereInput = {
  CardLinks?: InputMaybe<CardLinksWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type CardLinkParentWhereUniqueInput = {
  CardLinks?: InputMaybe<CardLinksWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type CardLinkUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CardLinkUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardLinkUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardLinkUpdateLocalizationInput = {
  data: CardLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type CardLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CardLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CardLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CardLinkUpsertLocalizationInput>>;
};

export type CardLinkUpdateManyInlineInput = {
  /** Create and connect multiple CardLink component instances */
  create?: InputMaybe<Array<CardLinkCreateWithPositionInput>>;
  /** Delete multiple CardLink documents */
  delete?: InputMaybe<Array<CardLinkWhereUniqueInput>>;
  /** Update multiple CardLink component instances */
  update?: InputMaybe<Array<CardLinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CardLink component instances */
  upsert?: InputMaybe<Array<CardLinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CardLinkUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CardLinkUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardLinkUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardLinkUpdateManyLocalizationInput = {
  data: CardLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CardLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CardLinkUpdateManyLocalizationInput>>;
};

export type CardLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CardLinkUpdateManyInput;
  /** Document search */
  where: CardLinkWhereInput;
};

export type CardLinkUpdateOneInlineInput = {
  /** Create and connect one CardLink document */
  create?: InputMaybe<CardLinkCreateInput>;
  /** Delete currently connected CardLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardLink document */
  update?: InputMaybe<CardLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardLink document */
  upsert?: InputMaybe<CardLinkUpsertWithNestedWhereUniqueInput>;
};

export type CardLinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CardLinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardLinkWhereUniqueInput;
};

export type CardLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CardLinkUpdateInput;
  /** Unique document search */
  where: CardLinkWhereUniqueInput;
};

export type CardLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: CardLinkCreateInput;
  /** Update document if it exists */
  update: CardLinkUpdateInput;
};

export type CardLinkUpsertLocalizationInput = {
  create: CardLinkCreateLocalizationDataInput;
  locale: Locale;
  update: CardLinkUpdateLocalizationDataInput;
};

export type CardLinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CardLinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardLinkWhereUniqueInput;
};

export type CardLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CardLinkUpsertInput;
  /** Unique document search */
  where: CardLinkWhereUniqueInput;
};

/** Identifies documents */
export type CardLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CardLink record uniquely */
export type CardLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CardLinks = Entity & {
  __typename?: 'CardLinks';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  items: Array<CardLink>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CardLinksItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CardLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardLinkWhereInput>;
};

export type CardLinksConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CardLinksWhereUniqueInput;
};

/** A connection to a list of items. */
export type CardLinksConnection = {
  __typename?: 'CardLinksConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CardLinksEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CardLinksCreateInput = {
  items?: InputMaybe<CardLinkCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CardLinksCreateManyInlineInput = {
  /** Create and connect multiple existing CardLinks documents */
  create?: InputMaybe<Array<CardLinksCreateInput>>;
};

export type CardLinksCreateOneInlineInput = {
  /** Create and connect one CardLinks document */
  create?: InputMaybe<CardLinksCreateInput>;
};

export type CardLinksCreateWithPositionInput = {
  /** Document to create */
  data: CardLinksCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CardLinksEdge = {
  __typename?: 'CardLinksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CardLinks;
};

/** Identifies documents */
export type CardLinksManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardLinksWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardLinksWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardLinksWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CardLinkWhereInput>;
  items_none?: InputMaybe<CardLinkWhereInput>;
  items_some?: InputMaybe<CardLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CardLinksOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CardLinksParent = SectionContent;

export type CardLinksParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type CardLinksParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type CardLinksParentCreateManyInlineInput = {
  /** Create and connect multiple existing CardLinksParent documents */
  create?: InputMaybe<Array<CardLinksParentCreateInput>>;
};

export type CardLinksParentCreateOneInlineInput = {
  /** Create and connect one CardLinksParent document */
  create?: InputMaybe<CardLinksParentCreateInput>;
};

export type CardLinksParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type CardLinksParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type CardLinksParentUpdateManyInlineInput = {
  /** Create and connect multiple CardLinksParent component instances */
  create?: InputMaybe<Array<CardLinksParentCreateWithPositionInput>>;
  /** Delete multiple CardLinksParent documents */
  delete?: InputMaybe<Array<CardLinksParentWhereUniqueInput>>;
  /** Update multiple CardLinksParent component instances */
  update?: InputMaybe<Array<CardLinksParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CardLinksParent component instances */
  upsert?: InputMaybe<Array<CardLinksParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CardLinksParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type CardLinksParentUpdateOneInlineInput = {
  /** Create and connect one CardLinksParent document */
  create?: InputMaybe<CardLinksParentCreateInput>;
  /** Delete currently connected CardLinksParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardLinksParent document */
  update?: InputMaybe<CardLinksParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardLinksParent document */
  upsert?: InputMaybe<CardLinksParentUpsertWithNestedWhereUniqueInput>;
};

export type CardLinksParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CardLinksParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type CardLinksParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CardLinksParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type CardLinksParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type CardLinksParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type CardLinksUpdateInput = {
  items?: InputMaybe<CardLinkUpdateManyInlineInput>;
};

export type CardLinksUpdateManyInlineInput = {
  /** Create and connect multiple CardLinks component instances */
  create?: InputMaybe<Array<CardLinksCreateWithPositionInput>>;
  /** Delete multiple CardLinks documents */
  delete?: InputMaybe<Array<CardLinksWhereUniqueInput>>;
  /** Update multiple CardLinks component instances */
  update?: InputMaybe<Array<CardLinksUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CardLinks component instances */
  upsert?: InputMaybe<Array<CardLinksUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CardLinksUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CardLinksUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CardLinksUpdateManyInput;
  /** Document search */
  where: CardLinksWhereInput;
};

export type CardLinksUpdateOneInlineInput = {
  /** Create and connect one CardLinks document */
  create?: InputMaybe<CardLinksCreateInput>;
  /** Delete currently connected CardLinks document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardLinks document */
  update?: InputMaybe<CardLinksUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardLinks document */
  upsert?: InputMaybe<CardLinksUpsertWithNestedWhereUniqueInput>;
};

export type CardLinksUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CardLinksUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardLinksWhereUniqueInput;
};

export type CardLinksUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CardLinksUpdateInput;
  /** Unique document search */
  where: CardLinksWhereUniqueInput;
};

export type CardLinksUpsertInput = {
  /** Create document if it didn't exist */
  create: CardLinksCreateInput;
  /** Update document if it exists */
  update: CardLinksUpdateInput;
};

export type CardLinksUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CardLinksUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CardLinksWhereUniqueInput;
};

export type CardLinksUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CardLinksUpsertInput;
  /** Unique document search */
  where: CardLinksWhereUniqueInput;
};

/** Identifies documents */
export type CardLinksWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardLinksWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardLinksWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardLinksWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  items_every?: InputMaybe<CardLinkWhereInput>;
  items_none?: InputMaybe<CardLinkWhereInput>;
  items_some?: InputMaybe<CardLinkWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CardLinks record uniquely */
export type CardLinksWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CatalogOfferCardVariant {
  Inline = 'inline',
  Outline = 'outline',
  Subscribe = 'subscribe'
}

export type CatalogOfferCards = Entity & {
  __typename?: 'CatalogOfferCards';
  /** True = prompt checkout flow | False = link to EGS pdp  */
  checkout?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** Using the offer ID provided, frontend will display offers from Catalog Service and autofill content. See product framework portal for reference. */
  offers: Array<ConfigCatalogOffer>;
  /** All offers require a sandbox Id to fetch the proper offer Ids within that namespace. Please note, sandboxid and namespace mean the same thing. */
  sandboxId: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  ukey: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant?: Maybe<CatalogOfferCardVariant>;
};


export type CatalogOfferCardsOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ConfigCatalogOfferOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ConfigCatalogOfferWhereInput>;
};

export type CatalogOfferCardsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CatalogOfferCardsWhereUniqueInput;
};

/** A connection to a list of items. */
export type CatalogOfferCardsConnection = {
  __typename?: 'CatalogOfferCardsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CatalogOfferCardsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CatalogOfferCardsCreateInput = {
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<ConfigCatalogOfferCreateManyInlineInput>;
  sandboxId: Scalars['String']['input'];
  ukey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant?: InputMaybe<CatalogOfferCardVariant>;
};

export type CatalogOfferCardsCreateManyInlineInput = {
  /** Create and connect multiple existing CatalogOfferCards documents */
  create?: InputMaybe<Array<CatalogOfferCardsCreateInput>>;
};

export type CatalogOfferCardsCreateOneInlineInput = {
  /** Create and connect one CatalogOfferCards document */
  create?: InputMaybe<CatalogOfferCardsCreateInput>;
};

export type CatalogOfferCardsCreateWithPositionInput = {
  /** Document to create */
  data: CatalogOfferCardsCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CatalogOfferCardsEdge = {
  __typename?: 'CatalogOfferCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CatalogOfferCards;
};

/** Identifies documents */
export type CatalogOfferCardsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CatalogOfferCardsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CatalogOfferCardsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CatalogOfferCardsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  checkout_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  offers_every?: InputMaybe<ConfigCatalogOfferWhereInput>;
  offers_none?: InputMaybe<ConfigCatalogOfferWhereInput>;
  offers_some?: InputMaybe<ConfigCatalogOfferWhereInput>;
  sandboxId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sandboxId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sandboxId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sandboxId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sandboxId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sandboxId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sandboxId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sandboxId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sandboxId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sandboxId_starts_with?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CatalogOfferCardVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CatalogOfferCardVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CatalogOfferCardVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CatalogOfferCardVariant>>>;
};

export enum CatalogOfferCardsOrderByInput {
  CheckoutAsc = 'checkout_ASC',
  CheckoutDesc = 'checkout_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SandboxIdAsc = 'sandboxId_ASC',
  SandboxIdDesc = 'sandboxId_DESC',
  UkeyAsc = 'ukey_ASC',
  UkeyDesc = 'ukey_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type CatalogOfferCardsParent = SectionContent;

export type CatalogOfferCardsParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type CatalogOfferCardsParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type CatalogOfferCardsParentCreateManyInlineInput = {
  /** Create and connect multiple existing CatalogOfferCardsParent documents */
  create?: InputMaybe<Array<CatalogOfferCardsParentCreateInput>>;
};

export type CatalogOfferCardsParentCreateOneInlineInput = {
  /** Create and connect one CatalogOfferCardsParent document */
  create?: InputMaybe<CatalogOfferCardsParentCreateInput>;
};

export type CatalogOfferCardsParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type CatalogOfferCardsParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type CatalogOfferCardsParentUpdateManyInlineInput = {
  /** Create and connect multiple CatalogOfferCardsParent component instances */
  create?: InputMaybe<Array<CatalogOfferCardsParentCreateWithPositionInput>>;
  /** Delete multiple CatalogOfferCardsParent documents */
  delete?: InputMaybe<Array<CatalogOfferCardsParentWhereUniqueInput>>;
  /** Update multiple CatalogOfferCardsParent component instances */
  update?: InputMaybe<Array<CatalogOfferCardsParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CatalogOfferCardsParent component instances */
  upsert?: InputMaybe<Array<CatalogOfferCardsParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CatalogOfferCardsParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type CatalogOfferCardsParentUpdateOneInlineInput = {
  /** Create and connect one CatalogOfferCardsParent document */
  create?: InputMaybe<CatalogOfferCardsParentCreateInput>;
  /** Delete currently connected CatalogOfferCardsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CatalogOfferCardsParent document */
  update?: InputMaybe<CatalogOfferCardsParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CatalogOfferCardsParent document */
  upsert?: InputMaybe<CatalogOfferCardsParentUpsertWithNestedWhereUniqueInput>;
};

export type CatalogOfferCardsParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CatalogOfferCardsParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type CatalogOfferCardsParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CatalogOfferCardsParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type CatalogOfferCardsParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type CatalogOfferCardsParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type CatalogOfferCardsUpdateInput = {
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<ConfigCatalogOfferUpdateManyInlineInput>;
  sandboxId?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CatalogOfferCardVariant>;
};

export type CatalogOfferCardsUpdateManyInlineInput = {
  /** Create and connect multiple CatalogOfferCards component instances */
  create?: InputMaybe<Array<CatalogOfferCardsCreateWithPositionInput>>;
  /** Delete multiple CatalogOfferCards documents */
  delete?: InputMaybe<Array<CatalogOfferCardsWhereUniqueInput>>;
  /** Update multiple CatalogOfferCards component instances */
  update?: InputMaybe<Array<CatalogOfferCardsUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CatalogOfferCards component instances */
  upsert?: InputMaybe<Array<CatalogOfferCardsUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CatalogOfferCardsUpdateManyInput = {
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  sandboxId?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<CatalogOfferCardVariant>;
};

export type CatalogOfferCardsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CatalogOfferCardsUpdateManyInput;
  /** Document search */
  where: CatalogOfferCardsWhereInput;
};

export type CatalogOfferCardsUpdateOneInlineInput = {
  /** Create and connect one CatalogOfferCards document */
  create?: InputMaybe<CatalogOfferCardsCreateInput>;
  /** Delete currently connected CatalogOfferCards document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CatalogOfferCards document */
  update?: InputMaybe<CatalogOfferCardsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CatalogOfferCards document */
  upsert?: InputMaybe<CatalogOfferCardsUpsertWithNestedWhereUniqueInput>;
};

export type CatalogOfferCardsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CatalogOfferCardsUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CatalogOfferCardsWhereUniqueInput;
};

export type CatalogOfferCardsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CatalogOfferCardsUpdateInput;
  /** Unique document search */
  where: CatalogOfferCardsWhereUniqueInput;
};

export type CatalogOfferCardsUpsertInput = {
  /** Create document if it didn't exist */
  create: CatalogOfferCardsCreateInput;
  /** Update document if it exists */
  update: CatalogOfferCardsUpdateInput;
};

export type CatalogOfferCardsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CatalogOfferCardsUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CatalogOfferCardsWhereUniqueInput;
};

export type CatalogOfferCardsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CatalogOfferCardsUpsertInput;
  /** Unique document search */
  where: CatalogOfferCardsWhereUniqueInput;
};

/** Identifies documents */
export type CatalogOfferCardsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CatalogOfferCardsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CatalogOfferCardsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CatalogOfferCardsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checkout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  checkout_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  offers_every?: InputMaybe<ConfigCatalogOfferWhereInput>;
  offers_none?: InputMaybe<ConfigCatalogOfferWhereInput>;
  offers_some?: InputMaybe<ConfigCatalogOfferWhereInput>;
  sandboxId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sandboxId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sandboxId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sandboxId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sandboxId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sandboxId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sandboxId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sandboxId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sandboxId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sandboxId_starts_with?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<CatalogOfferCardVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<CatalogOfferCardVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<CatalogOfferCardVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<CatalogOfferCardVariant>>>;
};

/** References CatalogOfferCards record uniquely */
export type CatalogOfferCardsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
};

export type CkeditorText = Entity & {
  __typename?: 'CkeditorText';
  ckText?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CkeditorText>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CkeditorTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CkeditorTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

/** A connection to a list of items. */
export type CkeditorTextConnection = {
  __typename?: 'CkeditorTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CkeditorTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CkeditorTextCreateInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CkeditorTextCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CkeditorTextCreateLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CkeditorTextCreateLocalizationInput = {
  /** Localization input */
  data: CkeditorTextCreateLocalizationDataInput;
  locale: Locale;
};

export type CkeditorTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CkeditorTextCreateLocalizationInput>>;
};

export type CkeditorTextCreateWithPositionInput = {
  /** Document to create */
  data: CkeditorTextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CkeditorTextEdge = {
  __typename?: 'CkeditorTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CkeditorText;
};

/** Identifies documents */
export type CkeditorTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CkeditorTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CkeditorTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CkeditorTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CkeditorTextOrderByInput {
  CkTextAsc = 'ckText_ASC',
  CkTextDesc = 'ckText_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CkeditorTextUpdateInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CkeditorTextUpdateLocalizationsInput>;
};

export type CkeditorTextUpdateLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
};

export type CkeditorTextUpdateLocalizationInput = {
  data: CkeditorTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type CkeditorTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CkeditorTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CkeditorTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CkeditorTextUpsertLocalizationInput>>;
};

export type CkeditorTextUpdateManyInput = {
  /** ckText input for default locale (en) */
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CkeditorTextUpdateManyLocalizationsInput>;
};

export type CkeditorTextUpdateManyLocalizationDataInput = {
  ckText?: InputMaybe<Scalars['String']['input']>;
};

export type CkeditorTextUpdateManyLocalizationInput = {
  data: CkeditorTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CkeditorTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CkeditorTextUpdateManyLocalizationInput>>;
};

export type CkeditorTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CkeditorTextUpdateManyInput;
  /** Document search */
  where: CkeditorTextWhereInput;
};

export type CkeditorTextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CkeditorTextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CkeditorTextWhereUniqueInput;
};

export type CkeditorTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CkeditorTextUpdateInput;
  /** Unique document search */
  where: CkeditorTextWhereUniqueInput;
};

export type CkeditorTextUpsertInput = {
  /** Create document if it didn't exist */
  create: CkeditorTextCreateInput;
  /** Update document if it exists */
  update: CkeditorTextUpdateInput;
};

export type CkeditorTextUpsertLocalizationInput = {
  create: CkeditorTextCreateLocalizationDataInput;
  locale: Locale;
  update: CkeditorTextUpdateLocalizationDataInput;
};

export type CkeditorTextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CkeditorTextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CkeditorTextWhereUniqueInput;
};

export type CkeditorTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CkeditorTextUpsertInput;
  /** Unique document search */
  where: CkeditorTextWhereUniqueInput;
};

/** Identifies documents */
export type CkeditorTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CkeditorTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CkeditorTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CkeditorTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ckText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ckText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ckText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ckText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ckText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ckText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ckText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ckText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ckText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ckText_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References CkeditorText record uniquely */
export type CkeditorTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

export type CommonEulaKey = Entity & Node & {
  __typename?: 'CommonEulaKey';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CommonEulaKey>;
  /** List of CommonEulaKey versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CommonEulaKeyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonEulaKeyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CommonEulaKeyHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CommonEulaKeyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonEulaKeyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CommonEulaKeyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CommonEulaKeyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommonEulaKeyWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommonEulaKeyConnection = {
  __typename?: 'CommonEulaKeyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommonEulaKeyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommonEulaKeyCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonEulaKeyCreateManyInlineInput = {
  /** Connect multiple existing CommonEulaKey documents */
  connect?: InputMaybe<Array<CommonEulaKeyWhereUniqueInput>>;
  /** Create and connect multiple existing CommonEulaKey documents */
  create?: InputMaybe<Array<CommonEulaKeyCreateInput>>;
};

export type CommonEulaKeyCreateOneInlineInput = {
  /** Connect one existing CommonEulaKey document */
  connect?: InputMaybe<CommonEulaKeyWhereUniqueInput>;
  /** Create and connect one CommonEulaKey document */
  create?: InputMaybe<CommonEulaKeyCreateInput>;
};

/** An edge in a connection. */
export type CommonEulaKeyEdge = {
  __typename?: 'CommonEulaKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommonEulaKey;
};

/** Identifies documents */
export type CommonEulaKeyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonEulaKeyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonEulaKeyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonEulaKeyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonEulaKeyWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonEulaKeyWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonEulaKeyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CommonEulaKeyOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CommonEulaKeyUpdateInput = {
  /** No fields in update input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CommonEulaKeyUpdateManyInlineInput = {
  /** Connect multiple existing CommonEulaKey documents */
  connect?: InputMaybe<Array<CommonEulaKeyConnectInput>>;
  /** Create and connect multiple CommonEulaKey documents */
  create?: InputMaybe<Array<CommonEulaKeyCreateInput>>;
  /** Delete multiple CommonEulaKey documents */
  delete?: InputMaybe<Array<CommonEulaKeyWhereUniqueInput>>;
  /** Disconnect multiple CommonEulaKey documents */
  disconnect?: InputMaybe<Array<CommonEulaKeyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CommonEulaKey documents */
  set?: InputMaybe<Array<CommonEulaKeyWhereUniqueInput>>;
  /** Update multiple CommonEulaKey documents */
  update?: InputMaybe<Array<CommonEulaKeyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CommonEulaKey documents */
  upsert?: InputMaybe<Array<CommonEulaKeyUpsertWithNestedWhereUniqueInput>>;
};

export type CommonEulaKeyUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CommonEulaKeyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommonEulaKeyUpdateManyInput;
  /** Document search */
  where: CommonEulaKeyWhereInput;
};

export type CommonEulaKeyUpdateOneInlineInput = {
  /** Connect existing CommonEulaKey document */
  connect?: InputMaybe<CommonEulaKeyWhereUniqueInput>;
  /** Create and connect one CommonEulaKey document */
  create?: InputMaybe<CommonEulaKeyCreateInput>;
  /** Delete currently connected CommonEulaKey document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CommonEulaKey document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommonEulaKey document */
  update?: InputMaybe<CommonEulaKeyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommonEulaKey document */
  upsert?: InputMaybe<CommonEulaKeyUpsertWithNestedWhereUniqueInput>;
};

export type CommonEulaKeyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommonEulaKeyUpdateInput;
  /** Unique document search */
  where: CommonEulaKeyWhereUniqueInput;
};

export type CommonEulaKeyUpsertInput = {
  /** Create document if it didn't exist */
  create: CommonEulaKeyCreateInput;
  /** Update document if it exists */
  update: CommonEulaKeyUpdateInput;
};

export type CommonEulaKeyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommonEulaKeyUpsertInput;
  /** Unique document search */
  where: CommonEulaKeyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CommonEulaKeyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CommonEulaKeyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonEulaKeyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonEulaKeyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonEulaKeyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonEulaKeyWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonEulaKeyWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonEulaKeyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CommonEulaKeyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonEulaKeyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonEulaKeyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonEulaKeyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CommonEulaKeyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CommonEulaKey record uniquely */
export type CommonEulaKeyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CommonFaq = Entity & Node & {
  __typename?: 'CommonFaq';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CommonFaq>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CommonFaq versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  inDevelopment: InDevelopmentStatus;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  items: Array<FaqItem>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CommonFaq>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refFaqSets: Array<FaqSet>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CommonFaqCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonFaqCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonFaqDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CommonFaqHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CommonFaqItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqItemWhereInput>;
};


export type CommonFaqLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CommonFaqPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonFaqPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonFaqRefFaqSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqSetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqSetWhereInput>;
};


export type CommonFaqScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CommonFaqUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonFaqUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CommonFaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommonFaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommonFaqConnection = {
  __typename?: 'CommonFaqConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommonFaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommonFaqCreateInput = {
  cmgg2o2ep029j07ok21gp8hpc?: InputMaybe<SectionFaqCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment: InDevelopmentStatus;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<FaqItemCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CommonFaqCreateLocalizationsInput>;
  refFaqSets?: InputMaybe<FaqSetCreateManyInlineInput>;
  /** title input for default locale (en) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonFaqCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonFaqCreateLocalizationInput = {
  /** Localization input */
  data: CommonFaqCreateLocalizationDataInput;
  locale: Locale;
};

export type CommonFaqCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CommonFaqCreateLocalizationInput>>;
};

export type CommonFaqCreateManyInlineInput = {
  /** Connect multiple existing CommonFaq documents */
  connect?: InputMaybe<Array<CommonFaqWhereUniqueInput>>;
  /** Create and connect multiple existing CommonFaq documents */
  create?: InputMaybe<Array<CommonFaqCreateInput>>;
};

export type CommonFaqCreateOneInlineInput = {
  /** Connect one existing CommonFaq document */
  connect?: InputMaybe<CommonFaqWhereUniqueInput>;
  /** Create and connect one CommonFaq document */
  create?: InputMaybe<CommonFaqCreateInput>;
};

/** An edge in a connection. */
export type CommonFaqEdge = {
  __typename?: 'CommonFaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommonFaq;
};

/** Identifies documents */
export type CommonFaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonFaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonFaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonFaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonFaqWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonFaqWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonFaqWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  items_every?: InputMaybe<FaqItemWhereInput>;
  items_none?: InputMaybe<FaqItemWhereInput>;
  items_some?: InputMaybe<FaqItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refFaqSets_every?: InputMaybe<FaqSetWhereInput>;
  refFaqSets_none?: InputMaybe<FaqSetWhereInput>;
  refFaqSets_some?: InputMaybe<FaqSetWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CommonFaqOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CommonFaqUpdateInput = {
  cmgg2o2ep029j07ok21gp8hpc?: InputMaybe<SectionFaqUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<FaqItemUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CommonFaqUpdateLocalizationsInput>;
  refFaqSets?: InputMaybe<FaqSetUpdateManyInlineInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommonFaqUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommonFaqUpdateLocalizationInput = {
  data: CommonFaqUpdateLocalizationDataInput;
  locale: Locale;
};

export type CommonFaqUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CommonFaqCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CommonFaqUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CommonFaqUpsertLocalizationInput>>;
};

export type CommonFaqUpdateManyInlineInput = {
  /** Connect multiple existing CommonFaq documents */
  connect?: InputMaybe<Array<CommonFaqConnectInput>>;
  /** Create and connect multiple CommonFaq documents */
  create?: InputMaybe<Array<CommonFaqCreateInput>>;
  /** Delete multiple CommonFaq documents */
  delete?: InputMaybe<Array<CommonFaqWhereUniqueInput>>;
  /** Disconnect multiple CommonFaq documents */
  disconnect?: InputMaybe<Array<CommonFaqWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CommonFaq documents */
  set?: InputMaybe<Array<CommonFaqWhereUniqueInput>>;
  /** Update multiple CommonFaq documents */
  update?: InputMaybe<Array<CommonFaqUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CommonFaq documents */
  upsert?: InputMaybe<Array<CommonFaqUpsertWithNestedWhereUniqueInput>>;
};

export type CommonFaqUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CommonFaqUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommonFaqUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CommonFaqUpdateManyLocalizationInput = {
  data: CommonFaqUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CommonFaqUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CommonFaqUpdateManyLocalizationInput>>;
};

export type CommonFaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommonFaqUpdateManyInput;
  /** Document search */
  where: CommonFaqWhereInput;
};

export type CommonFaqUpdateOneInlineInput = {
  /** Connect existing CommonFaq document */
  connect?: InputMaybe<CommonFaqWhereUniqueInput>;
  /** Create and connect one CommonFaq document */
  create?: InputMaybe<CommonFaqCreateInput>;
  /** Delete currently connected CommonFaq document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CommonFaq document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommonFaq document */
  update?: InputMaybe<CommonFaqUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommonFaq document */
  upsert?: InputMaybe<CommonFaqUpsertWithNestedWhereUniqueInput>;
};

export type CommonFaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommonFaqUpdateInput;
  /** Unique document search */
  where: CommonFaqWhereUniqueInput;
};

export type CommonFaqUpsertInput = {
  /** Create document if it didn't exist */
  create: CommonFaqCreateInput;
  /** Update document if it exists */
  update: CommonFaqUpdateInput;
};

export type CommonFaqUpsertLocalizationInput = {
  create: CommonFaqCreateLocalizationDataInput;
  locale: Locale;
  update: CommonFaqUpdateLocalizationDataInput;
};

export type CommonFaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommonFaqUpsertInput;
  /** Unique document search */
  where: CommonFaqWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CommonFaqWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CommonFaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonFaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonFaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonFaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonFaqWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonFaqWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonFaqWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  items_every?: InputMaybe<FaqItemWhereInput>;
  items_none?: InputMaybe<FaqItemWhereInput>;
  items_some?: InputMaybe<FaqItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refFaqSets_every?: InputMaybe<FaqSetWhereInput>;
  refFaqSets_none?: InputMaybe<FaqSetWhereInput>;
  refFaqSets_some?: InputMaybe<FaqSetWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CommonFaqWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonFaqWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonFaqWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonFaqWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CommonFaqWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CommonFaq record uniquely */
export type CommonFaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CommonPageHeroSection = Entity & Node & {
  __typename?: 'CommonPageHeroSection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CommonPageHeroSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CommonPageHeroSection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  inDevelopment: InDevelopmentStatus;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CommonPageHeroSection>;
  metaTags?: Maybe<ConfigSeoMetaTags>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refSections: Array<CommonSection>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CommonPageHeroSectionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonPageHeroSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonPageHeroSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CommonPageHeroSectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CommonPageHeroSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CommonPageHeroSectionMetaTagsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonPageHeroSectionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonPageHeroSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonPageHeroSectionRefSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CommonSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonSectionWhereInput>;
};


export type CommonPageHeroSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CommonPageHeroSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonPageHeroSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CommonPageHeroSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommonPageHeroSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommonPageHeroSectionConnection = {
  __typename?: 'CommonPageHeroSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommonPageHeroSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommonPageHeroSectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment: InDevelopmentStatus;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CommonPageHeroSectionCreateLocalizationsInput>;
  metaTags?: InputMaybe<ConfigSeoMetaTagsCreateOneInlineInput>;
  refSections?: InputMaybe<CommonSectionCreateManyInlineInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonPageHeroSectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonPageHeroSectionCreateLocalizationInput = {
  /** Localization input */
  data: CommonPageHeroSectionCreateLocalizationDataInput;
  locale: Locale;
};

export type CommonPageHeroSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CommonPageHeroSectionCreateLocalizationInput>>;
};

export type CommonPageHeroSectionCreateManyInlineInput = {
  /** Connect multiple existing CommonPageHeroSection documents */
  connect?: InputMaybe<Array<CommonPageHeroSectionWhereUniqueInput>>;
  /** Create and connect multiple existing CommonPageHeroSection documents */
  create?: InputMaybe<Array<CommonPageHeroSectionCreateInput>>;
};

export type CommonPageHeroSectionCreateOneInlineInput = {
  /** Connect one existing CommonPageHeroSection document */
  connect?: InputMaybe<CommonPageHeroSectionWhereUniqueInput>;
  /** Create and connect one CommonPageHeroSection document */
  create?: InputMaybe<CommonPageHeroSectionCreateInput>;
};

/** An edge in a connection. */
export type CommonPageHeroSectionEdge = {
  __typename?: 'CommonPageHeroSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommonPageHeroSection;
};

/** Identifies documents */
export type CommonPageHeroSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonPageHeroSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonPageHeroSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonPageHeroSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonPageHeroSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonPageHeroSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonPageHeroSectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  metaTags?: InputMaybe<ConfigSeoMetaTagsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CommonSectionWhereInput>;
  refSections_none?: InputMaybe<CommonSectionWhereInput>;
  refSections_some?: InputMaybe<CommonSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CommonPageHeroSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CommonPageHeroSectionUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** Manage document localizations */
  localizations?: InputMaybe<CommonPageHeroSectionUpdateLocalizationsInput>;
  metaTags?: InputMaybe<ConfigSeoMetaTagsUpdateOneInlineInput>;
  refSections?: InputMaybe<CommonSectionUpdateManyInlineInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CommonPageHeroSectionUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CommonPageHeroSectionUpdateLocalizationInput = {
  data: CommonPageHeroSectionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CommonPageHeroSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CommonPageHeroSectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CommonPageHeroSectionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CommonPageHeroSectionUpsertLocalizationInput>>;
};

export type CommonPageHeroSectionUpdateManyInlineInput = {
  /** Connect multiple existing CommonPageHeroSection documents */
  connect?: InputMaybe<Array<CommonPageHeroSectionConnectInput>>;
  /** Create and connect multiple CommonPageHeroSection documents */
  create?: InputMaybe<Array<CommonPageHeroSectionCreateInput>>;
  /** Delete multiple CommonPageHeroSection documents */
  delete?: InputMaybe<Array<CommonPageHeroSectionWhereUniqueInput>>;
  /** Disconnect multiple CommonPageHeroSection documents */
  disconnect?: InputMaybe<Array<CommonPageHeroSectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CommonPageHeroSection documents */
  set?: InputMaybe<Array<CommonPageHeroSectionWhereUniqueInput>>;
  /** Update multiple CommonPageHeroSection documents */
  update?: InputMaybe<Array<CommonPageHeroSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CommonPageHeroSection documents */
  upsert?: InputMaybe<Array<CommonPageHeroSectionUpsertWithNestedWhereUniqueInput>>;
};

export type CommonPageHeroSectionUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CommonPageHeroSectionUpdateManyLocalizationsInput>;
};

export type CommonPageHeroSectionUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CommonPageHeroSectionUpdateManyLocalizationInput = {
  data: CommonPageHeroSectionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CommonPageHeroSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CommonPageHeroSectionUpdateManyLocalizationInput>>;
};

export type CommonPageHeroSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommonPageHeroSectionUpdateManyInput;
  /** Document search */
  where: CommonPageHeroSectionWhereInput;
};

export type CommonPageHeroSectionUpdateOneInlineInput = {
  /** Connect existing CommonPageHeroSection document */
  connect?: InputMaybe<CommonPageHeroSectionWhereUniqueInput>;
  /** Create and connect one CommonPageHeroSection document */
  create?: InputMaybe<CommonPageHeroSectionCreateInput>;
  /** Delete currently connected CommonPageHeroSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CommonPageHeroSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommonPageHeroSection document */
  update?: InputMaybe<CommonPageHeroSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommonPageHeroSection document */
  upsert?: InputMaybe<CommonPageHeroSectionUpsertWithNestedWhereUniqueInput>;
};

export type CommonPageHeroSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommonPageHeroSectionUpdateInput;
  /** Unique document search */
  where: CommonPageHeroSectionWhereUniqueInput;
};

export type CommonPageHeroSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: CommonPageHeroSectionCreateInput;
  /** Update document if it exists */
  update: CommonPageHeroSectionUpdateInput;
};

export type CommonPageHeroSectionUpsertLocalizationInput = {
  create: CommonPageHeroSectionCreateLocalizationDataInput;
  locale: Locale;
  update: CommonPageHeroSectionUpdateLocalizationDataInput;
};

export type CommonPageHeroSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommonPageHeroSectionUpsertInput;
  /** Unique document search */
  where: CommonPageHeroSectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CommonPageHeroSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CommonPageHeroSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonPageHeroSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonPageHeroSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonPageHeroSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonPageHeroSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonPageHeroSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonPageHeroSectionWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  metaTags?: InputMaybe<ConfigSeoMetaTagsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refSections_every?: InputMaybe<CommonSectionWhereInput>;
  refSections_none?: InputMaybe<CommonSectionWhereInput>;
  refSections_some?: InputMaybe<CommonSectionWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CommonPageHeroSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonPageHeroSectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonPageHeroSectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonPageHeroSectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CommonPageHeroSectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CommonPageHeroSection record uniquely */
export type CommonPageHeroSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CommonSection = Entity & Node & {
  __typename?: 'CommonSection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CommonSection>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of CommonSection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  inDevelopment: InDevelopmentStatus;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CommonSection>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  section?: Maybe<CommonSectionsectionUnion>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CommonSectionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonSectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonSectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CommonSectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CommonSectionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CommonSectionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonSectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonSectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CommonSectionSectionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CommonSectionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CommonSectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CommonSectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CommonSectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CommonSectionConnection = {
  __typename?: 'CommonSectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CommonSectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CommonSectionCreateInput = {
  cmc17ubnp01h007o7df9v58sa?: InputMaybe<CommonPageHeroSectionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment: InDevelopmentStatus;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CommonSectionCreateLocalizationsInput>;
  section?: InputMaybe<CommonSectionsectionUnionCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonSectionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonSectionCreateLocalizationInput = {
  /** Localization input */
  data: CommonSectionCreateLocalizationDataInput;
  locale: Locale;
};

export type CommonSectionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CommonSectionCreateLocalizationInput>>;
};

export type CommonSectionCreateManyInlineInput = {
  /** Connect multiple existing CommonSection documents */
  connect?: InputMaybe<Array<CommonSectionWhereUniqueInput>>;
  /** Create and connect multiple existing CommonSection documents */
  create?: InputMaybe<Array<CommonSectionCreateInput>>;
};

export type CommonSectionCreateOneInlineInput = {
  /** Connect one existing CommonSection document */
  connect?: InputMaybe<CommonSectionWhereUniqueInput>;
  /** Create and connect one CommonSection document */
  create?: InputMaybe<CommonSectionCreateInput>;
};

/** An edge in a connection. */
export type CommonSectionEdge = {
  __typename?: 'CommonSectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CommonSection;
};

/** Identifies documents */
export type CommonSectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonSectionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the modular component is connected to the given models */
  section?: InputMaybe<CommonSectionsectionUnionWhereInput>;
  /** All values in which the union is empty. */
  section_empty?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CommonSectionOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CommonSectionUpdateInput = {
  cmc17ubnp01h007o7df9v58sa?: InputMaybe<CommonPageHeroSectionUpdateManyInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CommonSectionUpdateLocalizationsInput>;
  section?: InputMaybe<CommonSectionsectionUnionUpdateOneInlineInput>;
};

export type CommonSectionUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CommonSectionUpdateLocalizationInput = {
  data: CommonSectionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CommonSectionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CommonSectionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CommonSectionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CommonSectionUpsertLocalizationInput>>;
};

export type CommonSectionUpdateManyInlineInput = {
  /** Connect multiple existing CommonSection documents */
  connect?: InputMaybe<Array<CommonSectionConnectInput>>;
  /** Create and connect multiple CommonSection documents */
  create?: InputMaybe<Array<CommonSectionCreateInput>>;
  /** Delete multiple CommonSection documents */
  delete?: InputMaybe<Array<CommonSectionWhereUniqueInput>>;
  /** Disconnect multiple CommonSection documents */
  disconnect?: InputMaybe<Array<CommonSectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CommonSection documents */
  set?: InputMaybe<Array<CommonSectionWhereUniqueInput>>;
  /** Update multiple CommonSection documents */
  update?: InputMaybe<Array<CommonSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CommonSection documents */
  upsert?: InputMaybe<Array<CommonSectionUpsertWithNestedWhereUniqueInput>>;
};

export type CommonSectionUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CommonSectionUpdateManyLocalizationsInput>;
};

export type CommonSectionUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type CommonSectionUpdateManyLocalizationInput = {
  data: CommonSectionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CommonSectionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CommonSectionUpdateManyLocalizationInput>>;
};

export type CommonSectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CommonSectionUpdateManyInput;
  /** Document search */
  where: CommonSectionWhereInput;
};

export type CommonSectionUpdateOneInlineInput = {
  /** Connect existing CommonSection document */
  connect?: InputMaybe<CommonSectionWhereUniqueInput>;
  /** Create and connect one CommonSection document */
  create?: InputMaybe<CommonSectionCreateInput>;
  /** Delete currently connected CommonSection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CommonSection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommonSection document */
  update?: InputMaybe<CommonSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommonSection document */
  upsert?: InputMaybe<CommonSectionUpsertWithNestedWhereUniqueInput>;
};

export type CommonSectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CommonSectionUpdateInput;
  /** Unique document search */
  where: CommonSectionWhereUniqueInput;
};

export type CommonSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: CommonSectionCreateInput;
  /** Update document if it exists */
  update: CommonSectionUpdateInput;
};

export type CommonSectionUpsertLocalizationInput = {
  create: CommonSectionCreateLocalizationDataInput;
  locale: Locale;
  update: CommonSectionUpdateLocalizationDataInput;
};

export type CommonSectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CommonSectionUpsertInput;
  /** Unique document search */
  where: CommonSectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CommonSectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CommonSectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonSectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CommonSectionWhereStageInput>;
  documentInStages_none?: InputMaybe<CommonSectionWhereStageInput>;
  documentInStages_some?: InputMaybe<CommonSectionWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the modular component is connected to the given models */
  section?: InputMaybe<CommonSectionsectionUnionWhereInput>;
  /** All values in which the union is empty. */
  section_empty?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CommonSectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CommonSectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CommonSectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CommonSectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CommonSectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CommonSection record uniquely */
export type CommonSectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CommonSectionsectionUnion = SectionContent | SectionFaq | SectionSideBySide;

export type CommonSectionsectionUnionConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
  SectionFaq?: InputMaybe<SectionFaqConnectInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideConnectInput>;
};

export type CommonSectionsectionUnionCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
  SectionFaq?: InputMaybe<SectionFaqCreateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateInput>;
};

export type CommonSectionsectionUnionCreateManyInlineInput = {
  /** Create and connect multiple existing CommonSectionsectionUnion documents */
  create?: InputMaybe<Array<CommonSectionsectionUnionCreateInput>>;
};

export type CommonSectionsectionUnionCreateOneInlineInput = {
  /** Create and connect one CommonSectionsectionUnion document */
  create?: InputMaybe<CommonSectionsectionUnionCreateInput>;
};

export type CommonSectionsectionUnionCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
  SectionFaq?: InputMaybe<SectionFaqCreateWithPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateWithPositionInput>;
};

export type CommonSectionsectionUnionUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateInput>;
};

export type CommonSectionsectionUnionUpdateManyInlineInput = {
  /** Create and connect multiple CommonSectionsectionUnion component instances */
  create?: InputMaybe<Array<CommonSectionsectionUnionCreateWithPositionInput>>;
  /** Delete multiple CommonSectionsectionUnion documents */
  delete?: InputMaybe<Array<CommonSectionsectionUnionWhereUniqueInput>>;
  /** Update multiple CommonSectionsectionUnion component instances */
  update?: InputMaybe<Array<CommonSectionsectionUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CommonSectionsectionUnion component instances */
  upsert?: InputMaybe<Array<CommonSectionsectionUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CommonSectionsectionUnionUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateManyWithNestedWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateManyWithNestedWhereInput>;
};

export type CommonSectionsectionUnionUpdateOneInlineInput = {
  /** Create and connect one CommonSectionsectionUnion document */
  create?: InputMaybe<CommonSectionsectionUnionCreateInput>;
  /** Delete currently connected CommonSectionsectionUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CommonSectionsectionUnion document */
  update?: InputMaybe<CommonSectionsectionUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CommonSectionsectionUnion document */
  upsert?: InputMaybe<CommonSectionsectionUnionUpsertWithNestedWhereUniqueInput>;
};

export type CommonSectionsectionUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CommonSectionsectionUnionUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueInput>;
};

export type CommonSectionsectionUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionFaq?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CommonSectionsectionUnionUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
  SectionFaq?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueInput>;
};

export type CommonSectionsectionUnionWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
  SectionFaq?: InputMaybe<SectionFaqWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereInput>;
};

export type CommonSectionsectionUnionWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
  SectionFaq?: InputMaybe<SectionFaqWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereUniqueInput>;
};

export type ConfigAgeRating = Entity & {
  __typename?: 'ConfigAgeRating';
  catalogOffer?: Maybe<ConfigCatalogOffer>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** If applied, we'll try to locate age rating by item id. */
  itemId?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ConfigAgeRatingCatalogOfferArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ConfigAgeRatingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ConfigAgeRatingWhereUniqueInput;
};

/** A connection to a list of items. */
export type ConfigAgeRatingConnection = {
  __typename?: 'ConfigAgeRatingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ConfigAgeRatingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ConfigAgeRatingCreateInput = {
  catalogOffer?: InputMaybe<ConfigCatalogOfferCreateOneInlineInput>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigAgeRatingCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigAgeRating documents */
  create?: InputMaybe<Array<ConfigAgeRatingCreateInput>>;
};

export type ConfigAgeRatingCreateOneInlineInput = {
  /** Create and connect one ConfigAgeRating document */
  create?: InputMaybe<ConfigAgeRatingCreateInput>;
};

export type ConfigAgeRatingCreateWithPositionInput = {
  /** Document to create */
  data: ConfigAgeRatingCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ConfigAgeRatingEdge = {
  __typename?: 'ConfigAgeRatingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConfigAgeRating;
};

/** Identifies documents */
export type ConfigAgeRatingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigAgeRatingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigAgeRatingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigAgeRatingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  catalogOffer?: InputMaybe<ConfigCatalogOfferWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  itemId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  itemId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  itemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  itemId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  itemId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  itemId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  itemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  itemId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  itemId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ConfigAgeRatingOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ItemIdAsc = 'itemId_ASC',
  ItemIdDesc = 'itemId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ConfigAgeRatingParent = ProductDisclaimer;

export type ConfigAgeRatingParentConnectInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerConnectInput>;
};

export type ConfigAgeRatingParentCreateInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerCreateInput>;
};

export type ConfigAgeRatingParentCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigAgeRatingParent documents */
  create?: InputMaybe<Array<ConfigAgeRatingParentCreateInput>>;
};

export type ConfigAgeRatingParentCreateOneInlineInput = {
  /** Create and connect one ConfigAgeRatingParent document */
  create?: InputMaybe<ConfigAgeRatingParentCreateInput>;
};

export type ConfigAgeRatingParentCreateWithPositionInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerCreateWithPositionInput>;
};

export type ConfigAgeRatingParentUpdateInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateInput>;
};

export type ConfigAgeRatingParentUpdateManyInlineInput = {
  /** Create and connect multiple ConfigAgeRatingParent component instances */
  create?: InputMaybe<Array<ConfigAgeRatingParentCreateWithPositionInput>>;
  /** Delete multiple ConfigAgeRatingParent documents */
  delete?: InputMaybe<Array<ConfigAgeRatingParentWhereUniqueInput>>;
  /** Update multiple ConfigAgeRatingParent component instances */
  update?: InputMaybe<Array<ConfigAgeRatingParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigAgeRatingParent component instances */
  upsert?: InputMaybe<Array<ConfigAgeRatingParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigAgeRatingParentUpdateManyWithNestedWhereInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateManyWithNestedWhereInput>;
};

export type ConfigAgeRatingParentUpdateOneInlineInput = {
  /** Create and connect one ConfigAgeRatingParent document */
  create?: InputMaybe<ConfigAgeRatingParentCreateInput>;
  /** Delete currently connected ConfigAgeRatingParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigAgeRatingParent document */
  update?: InputMaybe<ConfigAgeRatingParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigAgeRatingParent document */
  upsert?: InputMaybe<ConfigAgeRatingParentUpsertWithNestedWhereUniqueInput>;
};

export type ConfigAgeRatingParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ConfigAgeRatingParentUpdateWithNestedWhereUniqueInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueInput>;
};

export type ConfigAgeRatingParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ConfigAgeRatingParentUpsertWithNestedWhereUniqueInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueInput>;
};

export type ConfigAgeRatingParentWhereInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerWhereInput>;
};

export type ConfigAgeRatingParentWhereUniqueInput = {
  ProductDisclaimer?: InputMaybe<ProductDisclaimerWhereUniqueInput>;
};

export type ConfigAgeRatingUpdateInput = {
  catalogOffer?: InputMaybe<ConfigCatalogOfferUpdateOneInlineInput>;
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigAgeRatingUpdateManyInlineInput = {
  /** Create and connect multiple ConfigAgeRating component instances */
  create?: InputMaybe<Array<ConfigAgeRatingCreateWithPositionInput>>;
  /** Delete multiple ConfigAgeRating documents */
  delete?: InputMaybe<Array<ConfigAgeRatingWhereUniqueInput>>;
  /** Update multiple ConfigAgeRating component instances */
  update?: InputMaybe<Array<ConfigAgeRatingUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigAgeRating component instances */
  upsert?: InputMaybe<Array<ConfigAgeRatingUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigAgeRatingUpdateManyInput = {
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigAgeRatingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ConfigAgeRatingUpdateManyInput;
  /** Document search */
  where: ConfigAgeRatingWhereInput;
};

export type ConfigAgeRatingUpdateOneInlineInput = {
  /** Create and connect one ConfigAgeRating document */
  create?: InputMaybe<ConfigAgeRatingCreateInput>;
  /** Delete currently connected ConfigAgeRating document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigAgeRating document */
  update?: InputMaybe<ConfigAgeRatingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigAgeRating document */
  upsert?: InputMaybe<ConfigAgeRatingUpsertWithNestedWhereUniqueInput>;
};

export type ConfigAgeRatingUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ConfigAgeRatingUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigAgeRatingWhereUniqueInput;
};

export type ConfigAgeRatingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ConfigAgeRatingUpdateInput;
  /** Unique document search */
  where: ConfigAgeRatingWhereUniqueInput;
};

export type ConfigAgeRatingUpsertInput = {
  /** Create document if it didn't exist */
  create: ConfigAgeRatingCreateInput;
  /** Update document if it exists */
  update: ConfigAgeRatingUpdateInput;
};

export type ConfigAgeRatingUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ConfigAgeRatingUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigAgeRatingWhereUniqueInput;
};

export type ConfigAgeRatingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ConfigAgeRatingUpsertInput;
  /** Unique document search */
  where: ConfigAgeRatingWhereUniqueInput;
};

/** Identifies documents */
export type ConfigAgeRatingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigAgeRatingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigAgeRatingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigAgeRatingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  catalogOffer?: InputMaybe<ConfigCatalogOfferWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  itemId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  itemId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  itemId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  itemId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  itemId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  itemId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  itemId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  itemId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  itemId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ConfigAgeRating record uniquely */
export type ConfigAgeRatingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ConfigCatalogOffer = Entity & {
  __typename?: 'ConfigCatalogOffer';
  /** Overrides the Catalog's own description in product framework */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ConfigCatalogOffer>;
  offerId: Scalars['String']['output'];
  /** If enabled, we can override default fields from Catalog Offer. For example: title, description. */
  overrideOfferFields?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  /** Overrides the Catalog's own title in product framework */
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ConfigCatalogOfferLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type ConfigCatalogOfferUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type ConfigCatalogOfferConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ConfigCatalogOfferWhereUniqueInput;
};

/** A connection to a list of items. */
export type ConfigCatalogOfferConnection = {
  __typename?: 'ConfigCatalogOfferConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ConfigCatalogOfferEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ConfigCatalogOfferCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ConfigCatalogOfferCreateLocalizationsInput>;
  offerId: Scalars['String']['input'];
  overrideOfferFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigCatalogOfferCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigCatalogOfferCreateLocalizationInput = {
  /** Localization input */
  data: ConfigCatalogOfferCreateLocalizationDataInput;
  locale: Locale;
};

export type ConfigCatalogOfferCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ConfigCatalogOfferCreateLocalizationInput>>;
};

export type ConfigCatalogOfferCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigCatalogOffer documents */
  create?: InputMaybe<Array<ConfigCatalogOfferCreateInput>>;
};

export type ConfigCatalogOfferCreateOneInlineInput = {
  /** Create and connect one ConfigCatalogOffer document */
  create?: InputMaybe<ConfigCatalogOfferCreateInput>;
};

export type ConfigCatalogOfferCreateWithPositionInput = {
  /** Document to create */
  data: ConfigCatalogOfferCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ConfigCatalogOfferEdge = {
  __typename?: 'ConfigCatalogOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConfigCatalogOffer;
};

/** Identifies documents */
export type ConfigCatalogOfferManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigCatalogOfferWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigCatalogOfferWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigCatalogOfferWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  offerId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  offerId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  offerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  offerId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  offerId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  offerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  offerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  offerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  offerId_starts_with?: InputMaybe<Scalars['String']['input']>;
  overrideOfferFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  overrideOfferFields_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ConfigCatalogOfferOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  OfferIdAsc = 'offerId_ASC',
  OfferIdDesc = 'offerId_DESC',
  OverrideOfferFieldsAsc = 'overrideOfferFields_ASC',
  OverrideOfferFieldsDesc = 'overrideOfferFields_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ConfigCatalogOfferParent = CatalogOfferCards | ConfigAgeRating | SectionContent;

export type ConfigCatalogOfferParentConnectInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsConnectInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type ConfigCatalogOfferParentCreateInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsCreateInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type ConfigCatalogOfferParentCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigCatalogOfferParent documents */
  create?: InputMaybe<Array<ConfigCatalogOfferParentCreateInput>>;
};

export type ConfigCatalogOfferParentCreateOneInlineInput = {
  /** Create and connect one ConfigCatalogOfferParent document */
  create?: InputMaybe<ConfigCatalogOfferParentCreateInput>;
};

export type ConfigCatalogOfferParentCreateWithPositionInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsCreateWithPositionInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingCreateWithPositionInput>;
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type ConfigCatalogOfferParentUpdateInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type ConfigCatalogOfferParentUpdateManyInlineInput = {
  /** Create and connect multiple ConfigCatalogOfferParent component instances */
  create?: InputMaybe<Array<ConfigCatalogOfferParentCreateWithPositionInput>>;
  /** Delete multiple ConfigCatalogOfferParent documents */
  delete?: InputMaybe<Array<ConfigCatalogOfferParentWhereUniqueInput>>;
  /** Update multiple ConfigCatalogOfferParent component instances */
  update?: InputMaybe<Array<ConfigCatalogOfferParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigCatalogOfferParent component instances */
  upsert?: InputMaybe<Array<ConfigCatalogOfferParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigCatalogOfferParentUpdateManyWithNestedWhereInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateManyWithNestedWhereInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type ConfigCatalogOfferParentUpdateOneInlineInput = {
  /** Create and connect one ConfigCatalogOfferParent document */
  create?: InputMaybe<ConfigCatalogOfferParentCreateInput>;
  /** Delete currently connected ConfigCatalogOfferParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigCatalogOfferParent document */
  update?: InputMaybe<ConfigCatalogOfferParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigCatalogOfferParent document */
  upsert?: InputMaybe<ConfigCatalogOfferParentUpsertWithNestedWhereUniqueInput>;
};

export type ConfigCatalogOfferParentUpdateWithNestedWhereUniqueAndPositionInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateWithNestedWhereUniqueAndPositionInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ConfigCatalogOfferParentUpdateWithNestedWhereUniqueInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateWithNestedWhereUniqueInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type ConfigCatalogOfferParentUpsertWithNestedWhereUniqueAndPositionInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpsertWithNestedWhereUniqueAndPositionInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ConfigCatalogOfferParentUpsertWithNestedWhereUniqueInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpsertWithNestedWhereUniqueInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type ConfigCatalogOfferParentWhereInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsWhereInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type ConfigCatalogOfferParentWhereUniqueInput = {
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsWhereUniqueInput>;
  ConfigAgeRating?: InputMaybe<ConfigAgeRatingWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type ConfigCatalogOfferUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ConfigCatalogOfferUpdateLocalizationsInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  overrideOfferFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigCatalogOfferUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigCatalogOfferUpdateLocalizationInput = {
  data: ConfigCatalogOfferUpdateLocalizationDataInput;
  locale: Locale;
};

export type ConfigCatalogOfferUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ConfigCatalogOfferCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ConfigCatalogOfferUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ConfigCatalogOfferUpsertLocalizationInput>>;
};

export type ConfigCatalogOfferUpdateManyInlineInput = {
  /** Create and connect multiple ConfigCatalogOffer component instances */
  create?: InputMaybe<Array<ConfigCatalogOfferCreateWithPositionInput>>;
  /** Delete multiple ConfigCatalogOffer documents */
  delete?: InputMaybe<Array<ConfigCatalogOfferWhereUniqueInput>>;
  /** Update multiple ConfigCatalogOffer component instances */
  update?: InputMaybe<Array<ConfigCatalogOfferUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigCatalogOffer component instances */
  upsert?: InputMaybe<Array<ConfigCatalogOfferUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigCatalogOfferUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ConfigCatalogOfferUpdateManyLocalizationsInput>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  overrideOfferFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigCatalogOfferUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigCatalogOfferUpdateManyLocalizationInput = {
  data: ConfigCatalogOfferUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ConfigCatalogOfferUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ConfigCatalogOfferUpdateManyLocalizationInput>>;
};

export type ConfigCatalogOfferUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ConfigCatalogOfferUpdateManyInput;
  /** Document search */
  where: ConfigCatalogOfferWhereInput;
};

export type ConfigCatalogOfferUpdateOneInlineInput = {
  /** Create and connect one ConfigCatalogOffer document */
  create?: InputMaybe<ConfigCatalogOfferCreateInput>;
  /** Delete currently connected ConfigCatalogOffer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigCatalogOffer document */
  update?: InputMaybe<ConfigCatalogOfferUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigCatalogOffer document */
  upsert?: InputMaybe<ConfigCatalogOfferUpsertWithNestedWhereUniqueInput>;
};

export type ConfigCatalogOfferUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ConfigCatalogOfferUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigCatalogOfferWhereUniqueInput;
};

export type ConfigCatalogOfferUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ConfigCatalogOfferUpdateInput;
  /** Unique document search */
  where: ConfigCatalogOfferWhereUniqueInput;
};

export type ConfigCatalogOfferUpsertInput = {
  /** Create document if it didn't exist */
  create: ConfigCatalogOfferCreateInput;
  /** Update document if it exists */
  update: ConfigCatalogOfferUpdateInput;
};

export type ConfigCatalogOfferUpsertLocalizationInput = {
  create: ConfigCatalogOfferCreateLocalizationDataInput;
  locale: Locale;
  update: ConfigCatalogOfferUpdateLocalizationDataInput;
};

export type ConfigCatalogOfferUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ConfigCatalogOfferUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigCatalogOfferWhereUniqueInput;
};

export type ConfigCatalogOfferUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ConfigCatalogOfferUpsertInput;
  /** Unique document search */
  where: ConfigCatalogOfferWhereUniqueInput;
};

/** Identifies documents */
export type ConfigCatalogOfferWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigCatalogOfferWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigCatalogOfferWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigCatalogOfferWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  offerId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  offerId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  offerId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  offerId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  offerId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  offerId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  offerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  offerId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  offerId_starts_with?: InputMaybe<Scalars['String']['input']>;
  overrideOfferFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  overrideOfferFields_not?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ConfigCatalogOffer record uniquely */
export type ConfigCatalogOfferWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ConfigContent = Entity & {
  __typename?: 'ConfigContent';
  backgroundColor?: Maybe<Color>;
  backgroundImage?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  sectionId?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ConfigContentBackgroundImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ConfigContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ConfigContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ConfigContentConnection = {
  __typename?: 'ConfigContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ConfigContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ConfigContentCreateInput = {
  backgroundColor?: InputMaybe<ColorInput>;
  backgroundImage?: InputMaybe<AssetCreateOneInlineInput>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigContentCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigContent documents */
  create?: InputMaybe<Array<ConfigContentCreateInput>>;
};

export type ConfigContentCreateOneInlineInput = {
  /** Create and connect one ConfigContent document */
  create?: InputMaybe<ConfigContentCreateInput>;
};

export type ConfigContentCreateWithPositionInput = {
  /** Document to create */
  data: ConfigContentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ConfigContentEdge = {
  __typename?: 'ConfigContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConfigContent;
};

/** Identifies documents */
export type ConfigContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sectionId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sectionId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sectionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sectionId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ConfigContentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SectionIdAsc = 'sectionId_ASC',
  SectionIdDesc = 'sectionId_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ConfigContentParent = SectionContent | SectionFaq | SectionSideBySide;

export type ConfigContentParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
  SectionFaq?: InputMaybe<SectionFaqConnectInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideConnectInput>;
};

export type ConfigContentParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
  SectionFaq?: InputMaybe<SectionFaqCreateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateInput>;
};

export type ConfigContentParentCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigContentParent documents */
  create?: InputMaybe<Array<ConfigContentParentCreateInput>>;
};

export type ConfigContentParentCreateOneInlineInput = {
  /** Create and connect one ConfigContentParent document */
  create?: InputMaybe<ConfigContentParentCreateInput>;
};

export type ConfigContentParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
  SectionFaq?: InputMaybe<SectionFaqCreateWithPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateWithPositionInput>;
};

export type ConfigContentParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateInput>;
};

export type ConfigContentParentUpdateManyInlineInput = {
  /** Create and connect multiple ConfigContentParent component instances */
  create?: InputMaybe<Array<ConfigContentParentCreateWithPositionInput>>;
  /** Delete multiple ConfigContentParent documents */
  delete?: InputMaybe<Array<ConfigContentParentWhereUniqueInput>>;
  /** Update multiple ConfigContentParent component instances */
  update?: InputMaybe<Array<ConfigContentParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigContentParent component instances */
  upsert?: InputMaybe<Array<ConfigContentParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigContentParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateManyWithNestedWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateManyWithNestedWhereInput>;
};

export type ConfigContentParentUpdateOneInlineInput = {
  /** Create and connect one ConfigContentParent document */
  create?: InputMaybe<ConfigContentParentCreateInput>;
  /** Delete currently connected ConfigContentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigContentParent document */
  update?: InputMaybe<ConfigContentParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigContentParent document */
  upsert?: InputMaybe<ConfigContentParentUpsertWithNestedWhereUniqueInput>;
};

export type ConfigContentParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ConfigContentParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
  SectionFaq?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueInput>;
};

export type ConfigContentParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionFaq?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ConfigContentParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
  SectionFaq?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueInput>;
};

export type ConfigContentParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
  SectionFaq?: InputMaybe<SectionFaqWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereInput>;
};

export type ConfigContentParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
  SectionFaq?: InputMaybe<SectionFaqWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereUniqueInput>;
};

export type ConfigContentUpdateInput = {
  backgroundColor?: InputMaybe<ColorInput>;
  backgroundImage?: InputMaybe<AssetUpdateOneInlineInput>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigContentUpdateManyInlineInput = {
  /** Create and connect multiple ConfigContent component instances */
  create?: InputMaybe<Array<ConfigContentCreateWithPositionInput>>;
  /** Delete multiple ConfigContent documents */
  delete?: InputMaybe<Array<ConfigContentWhereUniqueInput>>;
  /** Update multiple ConfigContent component instances */
  update?: InputMaybe<Array<ConfigContentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigContent component instances */
  upsert?: InputMaybe<Array<ConfigContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigContentUpdateManyInput = {
  backgroundColor?: InputMaybe<ColorInput>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ConfigContentUpdateManyInput;
  /** Document search */
  where: ConfigContentWhereInput;
};

export type ConfigContentUpdateOneInlineInput = {
  /** Create and connect one ConfigContent document */
  create?: InputMaybe<ConfigContentCreateInput>;
  /** Delete currently connected ConfigContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigContent document */
  update?: InputMaybe<ConfigContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigContent document */
  upsert?: InputMaybe<ConfigContentUpsertWithNestedWhereUniqueInput>;
};

export type ConfigContentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ConfigContentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigContentWhereUniqueInput;
};

export type ConfigContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ConfigContentUpdateInput;
  /** Unique document search */
  where: ConfigContentWhereUniqueInput;
};

export type ConfigContentUpsertInput = {
  /** Create document if it didn't exist */
  create: ConfigContentCreateInput;
  /** Update document if it exists */
  update: ConfigContentUpdateInput;
};

export type ConfigContentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ConfigContentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigContentWhereUniqueInput;
};

export type ConfigContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ConfigContentUpsertInput;
  /** Unique document search */
  where: ConfigContentWhereUniqueInput;
};

/** Identifies documents */
export type ConfigContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sectionId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sectionId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sectionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sectionId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionId_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ConfigContent record uniquely */
export type ConfigContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Fields which declare SEO related meta tags on the page. */
export type ConfigSeoMetaTags = Entity & {
  __typename?: 'ConfigSeoMetaTags';
  description?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ConfigSeoMetaTags>;
  noFollow?: Maybe<Scalars['Boolean']['output']>;
  /** Do not index page. */
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  openGraphImage?: Maybe<Asset>;
  socialDescription?: Maybe<Scalars['String']['output']>;
  socialTitle?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Fields which declare SEO related meta tags on the page. */
export type ConfigSeoMetaTagsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Fields which declare SEO related meta tags on the page. */
export type ConfigSeoMetaTagsOpenGraphImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Fields which declare SEO related meta tags on the page. */
export type ConfigSeoMetaTagsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type ConfigSeoMetaTagsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ConfigSeoMetaTagsWhereUniqueInput;
};

/** A connection to a list of items. */
export type ConfigSeoMetaTagsConnection = {
  __typename?: 'ConfigSeoMetaTagsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ConfigSeoMetaTagsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ConfigSeoMetaTagsCreateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ConfigSeoMetaTagsCreateLocalizationsInput>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** socialDescription input for default locale (en) */
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** socialTitle input for default locale (en) */
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigSeoMetaTagsCreateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfigSeoMetaTagsCreateLocalizationInput = {
  /** Localization input */
  data: ConfigSeoMetaTagsCreateLocalizationDataInput;
  locale: Locale;
};

export type ConfigSeoMetaTagsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ConfigSeoMetaTagsCreateLocalizationInput>>;
};

export type ConfigSeoMetaTagsCreateManyInlineInput = {
  /** Create and connect multiple existing ConfigSeoMetaTags documents */
  create?: InputMaybe<Array<ConfigSeoMetaTagsCreateInput>>;
};

export type ConfigSeoMetaTagsCreateOneInlineInput = {
  /** Create and connect one ConfigSeoMetaTags document */
  create?: InputMaybe<ConfigSeoMetaTagsCreateInput>;
};

export type ConfigSeoMetaTagsCreateWithPositionInput = {
  /** Document to create */
  data: ConfigSeoMetaTagsCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ConfigSeoMetaTagsEdge = {
  __typename?: 'ConfigSeoMetaTagsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConfigSeoMetaTags;
};

/** Identifies documents */
export type ConfigSeoMetaTagsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigSeoMetaTagsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigSeoMetaTagsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigSeoMetaTagsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noFollow_not?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ConfigSeoMetaTagsOrderByInput {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  NoFollowAsc = 'noFollow_ASC',
  NoFollowDesc = 'noFollow_DESC',
  NoIndexAsc = 'noIndex_ASC',
  NoIndexDesc = 'noIndex_DESC',
  SocialDescriptionAsc = 'socialDescription_ASC',
  SocialDescriptionDesc = 'socialDescription_DESC',
  SocialTitleAsc = 'socialTitle_ASC',
  SocialTitleDesc = 'socialTitle_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ConfigSeoMetaTagsParent = CommonPageHeroSection;

export type ConfigSeoMetaTagsParentConnectInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionConnectInput>;
};

export type ConfigSeoMetaTagsParentCreateInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionCreateInput>;
};

export type ConfigSeoMetaTagsParentCreateManyInlineInput = {
  /** Connect multiple existing ConfigSeoMetaTagsParent documents */
  connect?: InputMaybe<Array<ConfigSeoMetaTagsParentWhereUniqueInput>>;
  /** Create and connect multiple existing ConfigSeoMetaTagsParent documents */
  create?: InputMaybe<Array<ConfigSeoMetaTagsParentCreateInput>>;
};

export type ConfigSeoMetaTagsParentCreateOneInlineInput = {
  /** Connect one existing ConfigSeoMetaTagsParent document */
  connect?: InputMaybe<ConfigSeoMetaTagsParentWhereUniqueInput>;
  /** Create and connect one ConfigSeoMetaTagsParent document */
  create?: InputMaybe<ConfigSeoMetaTagsParentCreateInput>;
};

export type ConfigSeoMetaTagsParentUpdateInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionUpdateInput>;
};

export type ConfigSeoMetaTagsParentUpdateManyInlineInput = {
  /** Connect multiple existing ConfigSeoMetaTagsParent documents */
  connect?: InputMaybe<Array<ConfigSeoMetaTagsParentConnectInput>>;
  /** Create and connect multiple ConfigSeoMetaTagsParent documents */
  create?: InputMaybe<Array<ConfigSeoMetaTagsParentCreateInput>>;
  /** Delete multiple ConfigSeoMetaTagsParent documents */
  delete?: InputMaybe<Array<ConfigSeoMetaTagsParentWhereUniqueInput>>;
  /** Disconnect multiple ConfigSeoMetaTagsParent documents */
  disconnect?: InputMaybe<Array<ConfigSeoMetaTagsParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ConfigSeoMetaTagsParent documents */
  set?: InputMaybe<Array<ConfigSeoMetaTagsParentWhereUniqueInput>>;
  /** Update multiple ConfigSeoMetaTagsParent documents */
  update?: InputMaybe<Array<ConfigSeoMetaTagsParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ConfigSeoMetaTagsParent documents */
  upsert?: InputMaybe<Array<ConfigSeoMetaTagsParentUpsertWithNestedWhereUniqueInput>>;
};

export type ConfigSeoMetaTagsParentUpdateManyWithNestedWhereInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionUpdateManyWithNestedWhereInput>;
};

export type ConfigSeoMetaTagsParentUpdateOneInlineInput = {
  /** Connect existing ConfigSeoMetaTagsParent document */
  connect?: InputMaybe<ConfigSeoMetaTagsParentWhereUniqueInput>;
  /** Create and connect one ConfigSeoMetaTagsParent document */
  create?: InputMaybe<ConfigSeoMetaTagsParentCreateInput>;
  /** Delete currently connected ConfigSeoMetaTagsParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ConfigSeoMetaTagsParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigSeoMetaTagsParent document */
  update?: InputMaybe<ConfigSeoMetaTagsParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigSeoMetaTagsParent document */
  upsert?: InputMaybe<ConfigSeoMetaTagsParentUpsertWithNestedWhereUniqueInput>;
};

export type ConfigSeoMetaTagsParentUpdateWithNestedWhereUniqueInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionUpdateWithNestedWhereUniqueInput>;
};

export type ConfigSeoMetaTagsParentUpsertWithNestedWhereUniqueInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionUpsertWithNestedWhereUniqueInput>;
};

export type ConfigSeoMetaTagsParentWhereInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionWhereInput>;
};

export type ConfigSeoMetaTagsParentWhereUniqueInput = {
  CommonPageHeroSection?: InputMaybe<CommonPageHeroSectionWhereUniqueInput>;
};

export type ConfigSeoMetaTagsUpdateInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ConfigSeoMetaTagsUpdateLocalizationsInput>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** socialDescription input for default locale (en) */
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** socialTitle input for default locale (en) */
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigSeoMetaTagsUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigSeoMetaTagsUpdateLocalizationInput = {
  data: ConfigSeoMetaTagsUpdateLocalizationDataInput;
  locale: Locale;
};

export type ConfigSeoMetaTagsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ConfigSeoMetaTagsCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ConfigSeoMetaTagsUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ConfigSeoMetaTagsUpsertLocalizationInput>>;
};

export type ConfigSeoMetaTagsUpdateManyInlineInput = {
  /** Create and connect multiple ConfigSeoMetaTags component instances */
  create?: InputMaybe<Array<ConfigSeoMetaTagsCreateWithPositionInput>>;
  /** Delete multiple ConfigSeoMetaTags documents */
  delete?: InputMaybe<Array<ConfigSeoMetaTagsWhereUniqueInput>>;
  /** Update multiple ConfigSeoMetaTags component instances */
  update?: InputMaybe<Array<ConfigSeoMetaTagsUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ConfigSeoMetaTags component instances */
  upsert?: InputMaybe<Array<ConfigSeoMetaTagsUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ConfigSeoMetaTagsUpdateManyInput = {
  /** description input for default locale (en) */
  description?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ConfigSeoMetaTagsUpdateManyLocalizationsInput>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** socialDescription input for default locale (en) */
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** socialTitle input for default locale (en) */
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigSeoMetaTagsUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigSeoMetaTagsUpdateManyLocalizationInput = {
  data: ConfigSeoMetaTagsUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ConfigSeoMetaTagsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ConfigSeoMetaTagsUpdateManyLocalizationInput>>;
};

export type ConfigSeoMetaTagsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ConfigSeoMetaTagsUpdateManyInput;
  /** Document search */
  where: ConfigSeoMetaTagsWhereInput;
};

export type ConfigSeoMetaTagsUpdateOneInlineInput = {
  /** Create and connect one ConfigSeoMetaTags document */
  create?: InputMaybe<ConfigSeoMetaTagsCreateInput>;
  /** Delete currently connected ConfigSeoMetaTags document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ConfigSeoMetaTags document */
  update?: InputMaybe<ConfigSeoMetaTagsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ConfigSeoMetaTags document */
  upsert?: InputMaybe<ConfigSeoMetaTagsUpsertWithNestedWhereUniqueInput>;
};

export type ConfigSeoMetaTagsUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ConfigSeoMetaTagsUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigSeoMetaTagsWhereUniqueInput;
};

export type ConfigSeoMetaTagsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ConfigSeoMetaTagsUpdateInput;
  /** Unique document search */
  where: ConfigSeoMetaTagsWhereUniqueInput;
};

export type ConfigSeoMetaTagsUpsertInput = {
  /** Create document if it didn't exist */
  create: ConfigSeoMetaTagsCreateInput;
  /** Update document if it exists */
  update: ConfigSeoMetaTagsUpdateInput;
};

export type ConfigSeoMetaTagsUpsertLocalizationInput = {
  create: ConfigSeoMetaTagsCreateLocalizationDataInput;
  locale: Locale;
  update: ConfigSeoMetaTagsUpdateLocalizationDataInput;
};

export type ConfigSeoMetaTagsUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ConfigSeoMetaTagsUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ConfigSeoMetaTagsWhereUniqueInput;
};

export type ConfigSeoMetaTagsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ConfigSeoMetaTagsUpsertInput;
  /** Unique document search */
  where: ConfigSeoMetaTagsWhereUniqueInput;
};

/** Identifies documents */
export type ConfigSeoMetaTagsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ConfigSeoMetaTagsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ConfigSeoMetaTagsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ConfigSeoMetaTagsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noFollow_not?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  noIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  openGraphImage?: InputMaybe<AssetWhereInput>;
  socialDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  socialDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  socialDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  socialDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  socialDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  socialDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  socialDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  socialDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  socialDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  socialTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  socialTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  socialTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  socialTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  socialTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  socialTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  socialTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  socialTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ConfigSeoMetaTags record uniquely */
export type ConfigSeoMetaTagsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentBlock = Entity & {
  __typename?: 'ContentBlock';
  button?: Maybe<Button>;
  cta?: Maybe<Cta>;
  heading?: Maybe<Text>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  subheading?: Maybe<Text>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ContentBlockButtonArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentBlockCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentBlockHeadingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ContentBlockSubheadingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContentBlockConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContentBlockWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContentBlockConnection = {
  __typename?: 'ContentBlockConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContentBlockEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContentBlockCreateInput = {
  button?: InputMaybe<ButtonCreateOneInlineInput>;
  cta?: InputMaybe<CtaCreateOneInlineInput>;
  heading?: InputMaybe<TextCreateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<TextCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContentBlockCreateManyInlineInput = {
  /** Create and connect multiple existing ContentBlock documents */
  create?: InputMaybe<Array<ContentBlockCreateInput>>;
};

export type ContentBlockCreateOneInlineInput = {
  /** Create and connect one ContentBlock document */
  create?: InputMaybe<ContentBlockCreateInput>;
};

export type ContentBlockCreateWithPositionInput = {
  /** Document to create */
  data: ContentBlockCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ContentBlockEdge = {
  __typename?: 'ContentBlockEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContentBlock;
};

/** Identifies documents */
export type ContentBlockManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<ButtonWhereInput>;
  cta?: InputMaybe<CtaWhereInput>;
  heading?: InputMaybe<TextWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<TextWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ContentBlockOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ContentBlockParent = SectionContent | SectionSideBySide;

export type ContentBlockParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideConnectInput>;
};

export type ContentBlockParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateInput>;
};

export type ContentBlockParentCreateManyInlineInput = {
  /** Create and connect multiple existing ContentBlockParent documents */
  create?: InputMaybe<Array<ContentBlockParentCreateInput>>;
};

export type ContentBlockParentCreateOneInlineInput = {
  /** Create and connect one ContentBlockParent document */
  create?: InputMaybe<ContentBlockParentCreateInput>;
};

export type ContentBlockParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateWithPositionInput>;
};

export type ContentBlockParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateInput>;
};

export type ContentBlockParentUpdateManyInlineInput = {
  /** Create and connect multiple ContentBlockParent component instances */
  create?: InputMaybe<Array<ContentBlockParentCreateWithPositionInput>>;
  /** Delete multiple ContentBlockParent documents */
  delete?: InputMaybe<Array<ContentBlockParentWhereUniqueInput>>;
  /** Update multiple ContentBlockParent component instances */
  update?: InputMaybe<Array<ContentBlockParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentBlockParent component instances */
  upsert?: InputMaybe<Array<ContentBlockParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentBlockParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateManyWithNestedWhereInput>;
};

export type ContentBlockParentUpdateOneInlineInput = {
  /** Create and connect one ContentBlockParent document */
  create?: InputMaybe<ContentBlockParentCreateInput>;
  /** Delete currently connected ContentBlockParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentBlockParent document */
  update?: InputMaybe<ContentBlockParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentBlockParent document */
  upsert?: InputMaybe<ContentBlockParentUpsertWithNestedWhereUniqueInput>;
};

export type ContentBlockParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ContentBlockParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueInput>;
};

export type ContentBlockParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ContentBlockParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueInput>;
};

export type ContentBlockParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereInput>;
};

export type ContentBlockParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereUniqueInput>;
};

export type ContentBlockUpdateInput = {
  button?: InputMaybe<ButtonUpdateOneInlineInput>;
  cta?: InputMaybe<CtaUpdateOneInlineInput>;
  heading?: InputMaybe<TextUpdateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<TextUpdateOneInlineInput>;
};

export type ContentBlockUpdateManyInlineInput = {
  /** Create and connect multiple ContentBlock component instances */
  create?: InputMaybe<Array<ContentBlockCreateWithPositionInput>>;
  /** Delete multiple ContentBlock documents */
  delete?: InputMaybe<Array<ContentBlockWhereUniqueInput>>;
  /** Update multiple ContentBlock component instances */
  update?: InputMaybe<Array<ContentBlockUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ContentBlock component instances */
  upsert?: InputMaybe<Array<ContentBlockUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ContentBlockUpdateManyInput = {
  internalDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ContentBlockUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContentBlockUpdateManyInput;
  /** Document search */
  where: ContentBlockWhereInput;
};

export type ContentBlockUpdateOneInlineInput = {
  /** Create and connect one ContentBlock document */
  create?: InputMaybe<ContentBlockCreateInput>;
  /** Delete currently connected ContentBlock document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContentBlock document */
  update?: InputMaybe<ContentBlockUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContentBlock document */
  upsert?: InputMaybe<ContentBlockUpsertWithNestedWhereUniqueInput>;
};

export type ContentBlockUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ContentBlockUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentBlockWhereUniqueInput;
};

export type ContentBlockUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContentBlockUpdateInput;
  /** Unique document search */
  where: ContentBlockWhereUniqueInput;
};

export type ContentBlockUpsertInput = {
  /** Create document if it didn't exist */
  create: ContentBlockCreateInput;
  /** Update document if it exists */
  update: ContentBlockUpdateInput;
};

export type ContentBlockUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ContentBlockUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ContentBlockWhereUniqueInput;
};

export type ContentBlockUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContentBlockUpsertInput;
  /** Unique document search */
  where: ContentBlockWhereUniqueInput;
};

/** Identifies documents */
export type ContentBlockWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContentBlockWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContentBlockWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContentBlockWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<ButtonWhereInput>;
  cta?: InputMaybe<CtaWhereInput>;
  heading?: InputMaybe<TextWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<TextWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ContentBlock record uniquely */
export type ContentBlockWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Cta = Entity & {
  __typename?: 'Cta';
  /** Text to render under the CTA to inform users of possibly unexpected behaviors. */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** This is subject to change as SVS work introduces more culture support. */
  href: Scalars['String']['output'];
  icon?: Maybe<EdsIcon>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Cta>;
  /** System stage field */
  stage: Stage;
  subLabel?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CtaLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CtaUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type CtaConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CtaWhereUniqueInput;
};

/** A connection to a list of items. */
export type CtaConnection = {
  __typename?: 'CtaConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CtaEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CtaCreateInput = {
  /** disclaimer input for default locale (en) */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  href: Scalars['String']['input'];
  icon?: InputMaybe<EdsIcon>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CtaCreateLocalizationsInput>;
  /** subLabel input for default locale (en) */
  subLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CtaCreateLocalizationDataInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  subLabel?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CtaCreateLocalizationInput = {
  /** Localization input */
  data: CtaCreateLocalizationDataInput;
  locale: Locale;
};

export type CtaCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CtaCreateLocalizationInput>>;
};

export type CtaCreateManyInlineInput = {
  /** Create and connect multiple existing Cta documents */
  create?: InputMaybe<Array<CtaCreateInput>>;
};

export type CtaCreateOneInlineInput = {
  /** Create and connect one Cta document */
  create?: InputMaybe<CtaCreateInput>;
};

export type CtaCreateWithPositionInput = {
  /** Document to create */
  data: CtaCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CtaEdge = {
  __typename?: 'CtaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Cta;
};

/** Identifies documents */
export type CtaManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum CtaOrderByInput {
  DisclaimerAsc = 'disclaimer_ASC',
  DisclaimerDesc = 'disclaimer_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  SubLabelAsc = 'subLabel_ASC',
  SubLabelDesc = 'subLabel_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type CtaParent = ContentBlock;

export type CtaParentConnectInput = {
  ContentBlock?: InputMaybe<ContentBlockConnectInput>;
};

export type CtaParentCreateInput = {
  ContentBlock?: InputMaybe<ContentBlockCreateInput>;
};

export type CtaParentCreateManyInlineInput = {
  /** Create and connect multiple existing CtaParent documents */
  create?: InputMaybe<Array<CtaParentCreateInput>>;
};

export type CtaParentCreateOneInlineInput = {
  /** Create and connect one CtaParent document */
  create?: InputMaybe<CtaParentCreateInput>;
};

export type CtaParentCreateWithPositionInput = {
  ContentBlock?: InputMaybe<ContentBlockCreateWithPositionInput>;
};

export type CtaParentUpdateInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateInput>;
};

export type CtaParentUpdateManyInlineInput = {
  /** Create and connect multiple CtaParent component instances */
  create?: InputMaybe<Array<CtaParentCreateWithPositionInput>>;
  /** Delete multiple CtaParent documents */
  delete?: InputMaybe<Array<CtaParentWhereUniqueInput>>;
  /** Update multiple CtaParent component instances */
  update?: InputMaybe<Array<CtaParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple CtaParent component instances */
  upsert?: InputMaybe<Array<CtaParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CtaParentUpdateManyWithNestedWhereInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateManyWithNestedWhereInput>;
};

export type CtaParentUpdateOneInlineInput = {
  /** Create and connect one CtaParent document */
  create?: InputMaybe<CtaParentCreateInput>;
  /** Delete currently connected CtaParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CtaParent document */
  update?: InputMaybe<CtaParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CtaParent document */
  upsert?: InputMaybe<CtaParentUpsertWithNestedWhereUniqueInput>;
};

export type CtaParentUpdateWithNestedWhereUniqueAndPositionInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type CtaParentUpdateWithNestedWhereUniqueInput = {
  ContentBlock?: InputMaybe<ContentBlockUpdateWithNestedWhereUniqueInput>;
};

export type CtaParentUpsertWithNestedWhereUniqueAndPositionInput = {
  ContentBlock?: InputMaybe<ContentBlockUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type CtaParentUpsertWithNestedWhereUniqueInput = {
  ContentBlock?: InputMaybe<ContentBlockUpsertWithNestedWhereUniqueInput>;
};

export type CtaParentWhereInput = {
  ContentBlock?: InputMaybe<ContentBlockWhereInput>;
};

export type CtaParentWhereUniqueInput = {
  ContentBlock?: InputMaybe<ContentBlockWhereUniqueInput>;
};

export type CtaUpdateInput = {
  /** disclaimer input for default locale (en) */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CtaUpdateLocalizationsInput>;
  /** subLabel input for default locale (en) */
  subLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CtaUpdateLocalizationDataInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  subLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CtaUpdateLocalizationInput = {
  data: CtaUpdateLocalizationDataInput;
  locale: Locale;
};

export type CtaUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CtaCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CtaUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CtaUpsertLocalizationInput>>;
};

export type CtaUpdateManyInlineInput = {
  /** Create and connect multiple Cta component instances */
  create?: InputMaybe<Array<CtaCreateWithPositionInput>>;
  /** Delete multiple Cta documents */
  delete?: InputMaybe<Array<CtaWhereUniqueInput>>;
  /** Update multiple Cta component instances */
  update?: InputMaybe<Array<CtaUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Cta component instances */
  upsert?: InputMaybe<Array<CtaUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type CtaUpdateManyInput = {
  /** disclaimer input for default locale (en) */
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CtaUpdateManyLocalizationsInput>;
  /** subLabel input for default locale (en) */
  subLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CtaUpdateManyLocalizationDataInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  subLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CtaUpdateManyLocalizationInput = {
  data: CtaUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CtaUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CtaUpdateManyLocalizationInput>>;
};

export type CtaUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CtaUpdateManyInput;
  /** Document search */
  where: CtaWhereInput;
};

export type CtaUpdateOneInlineInput = {
  /** Create and connect one Cta document */
  create?: InputMaybe<CtaCreateInput>;
  /** Delete currently connected Cta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Cta document */
  update?: InputMaybe<CtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Cta document */
  upsert?: InputMaybe<CtaUpsertWithNestedWhereUniqueInput>;
};

export type CtaUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CtaUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CtaWhereUniqueInput;
};

export type CtaUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CtaUpdateInput;
  /** Unique document search */
  where: CtaWhereUniqueInput;
};

export type CtaUpsertInput = {
  /** Create document if it didn't exist */
  create: CtaCreateInput;
  /** Update document if it exists */
  update: CtaUpdateInput;
};

export type CtaUpsertLocalizationInput = {
  create: CtaCreateLocalizationDataInput;
  locale: Locale;
  update: CtaUpdateLocalizationDataInput;
};

export type CtaUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CtaUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CtaWhereUniqueInput;
};

export type CtaUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CtaUpsertInput;
  /** Unique document search */
  where: CtaWhereUniqueInput;
};

/** Identifies documents */
export type CtaWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CtaWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CtaWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  disclaimer_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  disclaimer_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  disclaimer_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  disclaimer_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  disclaimer_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  disclaimer_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  disclaimer_starts_with?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  subLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Cta record uniquely */
export type CtaWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  AutoImage = 'autoImage',
  Avif = 'avif',
  Bmp = 'bmp',
  Gif = 'gif',
  Heic = 'heic',
  Jpg = 'jpg',
  Png = 'png',
  Svg = 'svg',
  Tiff = 'tiff',
  Webp = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export enum EdsAlertVariant {
  Banner = 'banner',
  Inline = 'inline'
}

/** Defaults to "cta" */
export enum EdsButtonVariant {
  Contrast = 'contrast',
  Critical = 'critical',
  Cta = 'cta',
  Ghost = 'ghost',
  Outline = 'outline',
  Solid = 'solid'
}

export enum EdsCardVariant {
  Ghost = 'ghost',
  Outline = 'outline',
  Solid = 'solid'
}

/** EDS Color Type (i.e. Text, Icon) */
export enum EdsColor {
  Critical = 'critical',
  OnAccent = 'onAccent',
  Primary = 'primary',
  Secondary = 'secondary',
  Select = 'select',
  Success = 'success',
  Warning = 'warning'
}

export enum EdsIcon {
  CheckCircleFilledIcon = 'checkCircleFilledIcon',
  CouponIcon = 'couponIcon',
  ExclamationCircleFilledIcon = 'exclamationCircleFilledIcon',
  ExclamationTriangleFilledIcon = 'exclamationTriangleFilledIcon',
  GiftCardIcon = 'giftCardIcon',
  InfoCircleFilledIcon = 'infoCircleFilledIcon',
  SparkleIcon = 'sparkleIcon'
}

export enum EdsIconPosition {
  End = 'end',
  Start = 'start'
}

export enum EdsSize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xl = 'xl'
}

export enum EdsStatus {
  Critical = 'critical',
  Informational = 'informational',
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning'
}

/** EDS Text Component Variant */
export enum EdsTextVariant {
  EyebrowLg = 'eyebrowLG',
  EyebrowMd = 'eyebrowMD',
  EyebrowSm = 'eyebrowSM',
  Heading2Xl = 'heading2XL',
  Heading3Xl = 'heading3XL',
  Heading4Xl = 'heading4XL',
  HeadingLg = 'headingLG',
  HeadingMd = 'headingMD',
  HeadingSm = 'headingSM',
  HeadingXl = 'headingXL',
  Inherit = 'inherit',
  List2Xl = 'list2XL',
  ListLg = 'listLG',
  ListMd = 'listMD',
  ListSm = 'listSM',
  ListXl = 'listXL',
  ListXs = 'listXS',
  Paragraph2Xl = 'paragraph2XL',
  ParagraphLg = 'paragraphLG',
  ParagraphMd = 'paragraphMD',
  ParagraphSm = 'paragraphSM',
  ParagraphXl = 'paragraphXL',
  ParagraphXs = 'paragraphXS',
  UiLg = 'uiLG',
  UiLgBold = 'uiLGBold',
  UiLgMedium = 'uiLGMedium',
  UiMd = 'uiMD',
  UiMdBold = 'uiMDBold',
  UiMdMedium = 'uiMDMedium',
  UiSm = 'uiSM',
  UiSmBold = 'uiSMBold',
  UiSmMedium = 'uiSMMedium',
  UiXs = 'uiXS',
  UiXsBold = 'uiXSBold'
}

/** Defaults to "top" */
export enum EdsTooltipSide {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  Alert = 'Alert',
  /** Asset system model */
  Asset = 'Asset',
  Button = 'Button',
  CardLink = 'CardLink',
  CardLinks = 'CardLinks',
  CatalogOfferCards = 'CatalogOfferCards',
  CkeditorText = 'CkeditorText',
  CommonEulaKey = 'CommonEulaKey',
  CommonFaq = 'CommonFaq',
  CommonPageHeroSection = 'CommonPageHeroSection',
  CommonSection = 'CommonSection',
  ConfigAgeRating = 'ConfigAgeRating',
  ConfigCatalogOffer = 'ConfigCatalogOffer',
  ConfigContent = 'ConfigContent',
  /** Fields which declare SEO related meta tags on the page. */
  ConfigSeoMetaTags = 'ConfigSeoMetaTags',
  ContentBlock = 'ContentBlock',
  Cta = 'Cta',
  /** i.e. How To Video */
  FaqAsset = 'FaqAsset',
  FaqItem = 'FaqItem',
  FaqSet = 'FaqSet',
  FaqSetItem = 'FaqSetItem',
  /** Image tag or badge component which includes an Image and a corresponding label with an href. */
  ImageTag = 'ImageTag',
  Link = 'Link',
  ProductDisclaimer = 'ProductDisclaimer',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  SectionContent = 'SectionContent',
  SectionFaq = 'SectionFaq',
  SectionSideBySide = 'SectionSideBySide',
  /** Global site settings. */
  SiteSetting = 'SiteSetting',
  Text = 'Text',
  Tooltip = 'Tooltip',
  /** User system model */
  User = 'User',
  Video = 'Video'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

/** i.e. How To Video */
export type FaqAsset = Entity & {
  __typename?: 'FaqAsset';
  asset?: Maybe<Video>;
  desc?: Maybe<RichText>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FaqAsset>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** i.e. How To Video */
export type FaqAssetAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** i.e. How To Video */
export type FaqAssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** i.e. How To Video */
export type FaqAssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type FaqAssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqAssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqAssetConnection = {
  __typename?: 'FaqAssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqAssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqAssetCreateInput = {
  asset?: InputMaybe<VideoCreateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FaqAssetCreateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqAssetCreateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['RichTextAST']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqAssetCreateLocalizationInput = {
  /** Localization input */
  data: FaqAssetCreateLocalizationDataInput;
  locale: Locale;
};

export type FaqAssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FaqAssetCreateLocalizationInput>>;
};

export type FaqAssetCreateManyInlineInput = {
  /** Create and connect multiple existing FaqAsset documents */
  create?: InputMaybe<Array<FaqAssetCreateInput>>;
};

export type FaqAssetCreateOneInlineInput = {
  /** Create and connect one FaqAsset document */
  create?: InputMaybe<FaqAssetCreateInput>;
};

export type FaqAssetCreateWithPositionInput = {
  /** Document to create */
  data: FaqAssetCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FaqAssetEdge = {
  __typename?: 'FaqAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqAsset;
};

/** Identifies documents */
export type FaqAssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<VideoWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum FaqAssetOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqAssetParent = SectionFaq;

export type FaqAssetParentConnectInput = {
  SectionFaq?: InputMaybe<SectionFaqConnectInput>;
};

export type FaqAssetParentCreateInput = {
  SectionFaq?: InputMaybe<SectionFaqCreateInput>;
};

export type FaqAssetParentCreateManyInlineInput = {
  /** Create and connect multiple existing FaqAssetParent documents */
  create?: InputMaybe<Array<FaqAssetParentCreateInput>>;
};

export type FaqAssetParentCreateOneInlineInput = {
  /** Create and connect one FaqAssetParent document */
  create?: InputMaybe<FaqAssetParentCreateInput>;
};

export type FaqAssetParentCreateWithPositionInput = {
  SectionFaq?: InputMaybe<SectionFaqCreateWithPositionInput>;
};

export type FaqAssetParentUpdateInput = {
  SectionFaq?: InputMaybe<SectionFaqUpdateInput>;
};

export type FaqAssetParentUpdateManyInlineInput = {
  /** Create and connect multiple FaqAssetParent component instances */
  create?: InputMaybe<Array<FaqAssetParentCreateWithPositionInput>>;
  /** Delete multiple FaqAssetParent documents */
  delete?: InputMaybe<Array<FaqAssetParentWhereUniqueInput>>;
  /** Update multiple FaqAssetParent component instances */
  update?: InputMaybe<Array<FaqAssetParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqAssetParent component instances */
  upsert?: InputMaybe<Array<FaqAssetParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqAssetParentUpdateManyWithNestedWhereInput = {
  SectionFaq?: InputMaybe<SectionFaqUpdateManyWithNestedWhereInput>;
};

export type FaqAssetParentUpdateOneInlineInput = {
  /** Create and connect one FaqAssetParent document */
  create?: InputMaybe<FaqAssetParentCreateInput>;
  /** Delete currently connected FaqAssetParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqAssetParent document */
  update?: InputMaybe<FaqAssetParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqAssetParent document */
  upsert?: InputMaybe<FaqAssetParentUpsertWithNestedWhereUniqueInput>;
};

export type FaqAssetParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionFaq?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type FaqAssetParentUpdateWithNestedWhereUniqueInput = {
  SectionFaq?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueInput>;
};

export type FaqAssetParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionFaq?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type FaqAssetParentUpsertWithNestedWhereUniqueInput = {
  SectionFaq?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueInput>;
};

export type FaqAssetParentWhereInput = {
  SectionFaq?: InputMaybe<SectionFaqWhereInput>;
};

export type FaqAssetParentWhereUniqueInput = {
  SectionFaq?: InputMaybe<SectionFaqWhereUniqueInput>;
};

export type FaqAssetUpdateInput = {
  asset?: InputMaybe<VideoUpdateOneInlineInput>;
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FaqAssetUpdateLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqAssetUpdateLocalizationDataInput = {
  desc?: InputMaybe<Scalars['RichTextAST']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqAssetUpdateLocalizationInput = {
  data: FaqAssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type FaqAssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FaqAssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FaqAssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FaqAssetUpsertLocalizationInput>>;
};

export type FaqAssetUpdateManyInlineInput = {
  /** Create and connect multiple FaqAsset component instances */
  create?: InputMaybe<Array<FaqAssetCreateWithPositionInput>>;
  /** Delete multiple FaqAsset documents */
  delete?: InputMaybe<Array<FaqAssetWhereUniqueInput>>;
  /** Update multiple FaqAsset component instances */
  update?: InputMaybe<Array<FaqAssetUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqAsset component instances */
  upsert?: InputMaybe<Array<FaqAssetUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqAssetUpdateManyInput = {
  /** desc input for default locale (en) */
  desc?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FaqAssetUpdateManyLocalizationsInput>;
  /** title input for default locale (en) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqAssetUpdateManyLocalizationDataInput = {
  desc?: InputMaybe<Scalars['RichTextAST']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FaqAssetUpdateManyLocalizationInput = {
  data: FaqAssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FaqAssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FaqAssetUpdateManyLocalizationInput>>;
};

export type FaqAssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqAssetUpdateManyInput;
  /** Document search */
  where: FaqAssetWhereInput;
};

export type FaqAssetUpdateOneInlineInput = {
  /** Create and connect one FaqAsset document */
  create?: InputMaybe<FaqAssetCreateInput>;
  /** Delete currently connected FaqAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqAsset document */
  update?: InputMaybe<FaqAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqAsset document */
  upsert?: InputMaybe<FaqAssetUpsertWithNestedWhereUniqueInput>;
};

export type FaqAssetUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FaqAssetUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqAssetWhereUniqueInput;
};

export type FaqAssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqAssetUpdateInput;
  /** Unique document search */
  where: FaqAssetWhereUniqueInput;
};

export type FaqAssetUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqAssetCreateInput;
  /** Update document if it exists */
  update: FaqAssetUpdateInput;
};

export type FaqAssetUpsertLocalizationInput = {
  create: FaqAssetCreateLocalizationDataInput;
  locale: Locale;
  update: FaqAssetUpdateLocalizationDataInput;
};

export type FaqAssetUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FaqAssetUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqAssetWhereUniqueInput;
};

export type FaqAssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqAssetUpsertInput;
  /** Unique document search */
  where: FaqAssetWhereUniqueInput;
};

/** Identifies documents */
export type FaqAssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqAssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqAssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqAssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<VideoWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References FaqAsset record uniquely */
export type FaqAssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FaqItem = Entity & {
  __typename?: 'FaqItem';
  answer?: Maybe<Text>;
  /** Question and answer will not be collapsed if this is true. */
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FaqItem>;
  question: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FaqItemAnswerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FaqItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type FaqItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqItemConnection = {
  __typename?: 'FaqItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqItemCreateInput = {
  answer?: InputMaybe<TextCreateOneInlineInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FaqItemCreateLocalizationsInput>;
  /** question input for default locale (en) */
  question: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqItemCreateLocalizationDataInput = {
  question: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqItemCreateLocalizationInput = {
  /** Localization input */
  data: FaqItemCreateLocalizationDataInput;
  locale: Locale;
};

export type FaqItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FaqItemCreateLocalizationInput>>;
};

export type FaqItemCreateManyInlineInput = {
  /** Create and connect multiple existing FaqItem documents */
  create?: InputMaybe<Array<FaqItemCreateInput>>;
};

export type FaqItemCreateOneInlineInput = {
  /** Create and connect one FaqItem document */
  create?: InputMaybe<FaqItemCreateInput>;
};

export type FaqItemCreateWithPositionInput = {
  /** Document to create */
  data: FaqItemCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type FaqItemEdge = {
  __typename?: 'FaqItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqItem;
};

/** Identifies documents */
export type FaqItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<TextWhereInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum FaqItemOrderByInput {
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  HiddenAsc = 'hidden_ASC',
  HiddenDesc = 'hidden_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqItemParent = CommonFaq;

export type FaqItemParentConnectInput = {
  CommonFaq?: InputMaybe<CommonFaqConnectInput>;
};

export type FaqItemParentCreateInput = {
  CommonFaq?: InputMaybe<CommonFaqCreateInput>;
};

export type FaqItemParentCreateManyInlineInput = {
  /** Connect multiple existing FaqItemParent documents */
  connect?: InputMaybe<Array<FaqItemParentWhereUniqueInput>>;
  /** Create and connect multiple existing FaqItemParent documents */
  create?: InputMaybe<Array<FaqItemParentCreateInput>>;
};

export type FaqItemParentCreateOneInlineInput = {
  /** Connect one existing FaqItemParent document */
  connect?: InputMaybe<FaqItemParentWhereUniqueInput>;
  /** Create and connect one FaqItemParent document */
  create?: InputMaybe<FaqItemParentCreateInput>;
};

export type FaqItemParentUpdateInput = {
  CommonFaq?: InputMaybe<CommonFaqUpdateInput>;
};

export type FaqItemParentUpdateManyInlineInput = {
  /** Connect multiple existing FaqItemParent documents */
  connect?: InputMaybe<Array<FaqItemParentConnectInput>>;
  /** Create and connect multiple FaqItemParent documents */
  create?: InputMaybe<Array<FaqItemParentCreateInput>>;
  /** Delete multiple FaqItemParent documents */
  delete?: InputMaybe<Array<FaqItemParentWhereUniqueInput>>;
  /** Disconnect multiple FaqItemParent documents */
  disconnect?: InputMaybe<Array<FaqItemParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqItemParent documents */
  set?: InputMaybe<Array<FaqItemParentWhereUniqueInput>>;
  /** Update multiple FaqItemParent documents */
  update?: InputMaybe<Array<FaqItemParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqItemParent documents */
  upsert?: InputMaybe<Array<FaqItemParentUpsertWithNestedWhereUniqueInput>>;
};

export type FaqItemParentUpdateManyWithNestedWhereInput = {
  CommonFaq?: InputMaybe<CommonFaqUpdateManyWithNestedWhereInput>;
};

export type FaqItemParentUpdateOneInlineInput = {
  /** Connect existing FaqItemParent document */
  connect?: InputMaybe<FaqItemParentWhereUniqueInput>;
  /** Create and connect one FaqItemParent document */
  create?: InputMaybe<FaqItemParentCreateInput>;
  /** Delete currently connected FaqItemParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqItemParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqItemParent document */
  update?: InputMaybe<FaqItemParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqItemParent document */
  upsert?: InputMaybe<FaqItemParentUpsertWithNestedWhereUniqueInput>;
};

export type FaqItemParentUpdateWithNestedWhereUniqueInput = {
  CommonFaq?: InputMaybe<CommonFaqUpdateWithNestedWhereUniqueInput>;
};

export type FaqItemParentUpsertWithNestedWhereUniqueInput = {
  CommonFaq?: InputMaybe<CommonFaqUpsertWithNestedWhereUniqueInput>;
};

export type FaqItemParentWhereInput = {
  CommonFaq?: InputMaybe<CommonFaqWhereInput>;
};

export type FaqItemParentWhereUniqueInput = {
  CommonFaq?: InputMaybe<CommonFaqWhereUniqueInput>;
};

export type FaqItemUpdateInput = {
  answer?: InputMaybe<TextUpdateOneInlineInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FaqItemUpdateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqItemUpdateLocalizationDataInput = {
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqItemUpdateLocalizationInput = {
  data: FaqItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type FaqItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FaqItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FaqItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FaqItemUpsertLocalizationInput>>;
};

export type FaqItemUpdateManyInlineInput = {
  /** Create and connect multiple FaqItem component instances */
  create?: InputMaybe<Array<FaqItemCreateWithPositionInput>>;
  /** Delete multiple FaqItem documents */
  delete?: InputMaybe<Array<FaqItemWhereUniqueInput>>;
  /** Update multiple FaqItem component instances */
  update?: InputMaybe<Array<FaqItemUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple FaqItem component instances */
  upsert?: InputMaybe<Array<FaqItemUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type FaqItemUpdateManyInput = {
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FaqItemUpdateManyLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqItemUpdateManyLocalizationDataInput = {
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqItemUpdateManyLocalizationInput = {
  data: FaqItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FaqItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FaqItemUpdateManyLocalizationInput>>;
};

export type FaqItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqItemUpdateManyInput;
  /** Document search */
  where: FaqItemWhereInput;
};

export type FaqItemUpdateOneInlineInput = {
  /** Create and connect one FaqItem document */
  create?: InputMaybe<FaqItemCreateInput>;
  /** Delete currently connected FaqItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqItem document */
  update?: InputMaybe<FaqItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqItem document */
  upsert?: InputMaybe<FaqItemUpsertWithNestedWhereUniqueInput>;
};

export type FaqItemUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<FaqItemUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqItemWhereUniqueInput;
};

export type FaqItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqItemUpdateInput;
  /** Unique document search */
  where: FaqItemWhereUniqueInput;
};

export type FaqItemUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqItemCreateInput;
  /** Update document if it exists */
  update: FaqItemUpdateInput;
};

export type FaqItemUpsertLocalizationInput = {
  create: FaqItemCreateLocalizationDataInput;
  locale: Locale;
  update: FaqItemUpdateLocalizationDataInput;
};

export type FaqItemUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<FaqItemUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: FaqItemWhereUniqueInput;
};

export type FaqItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqItemUpsertInput;
  /** Unique document search */
  where: FaqItemWhereUniqueInput;
};

/** Identifies documents */
export type FaqItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<TextWhereInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References FaqItem record uniquely */
export type FaqItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FaqSet = Entity & Node & {
  __typename?: 'FaqSet';
  /** When multiple FAQ Sets exist within an FAQ section, the control label distinguishes between the sets via the segmented control UI. */
  controlLabel?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FaqSet>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** List of FaqSet versions */
  history: Array<Version>;
  /** Icon to display on the segmented toggle ui */
  icon?: Maybe<EdsIcon>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  inDevelopment: InDevelopmentStatus;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FaqSet>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  refFaqSetItems: Array<FaqSetItem>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FaqSetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FaqSetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqSetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FaqSetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FaqSetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FaqSetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FaqSetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqSetRefFaqSetItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FaqSetItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqSetItemWhereInput>;
};


export type FaqSetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FaqSetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FaqSetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqSetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqSetWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqSetConnection = {
  __typename?: 'FaqSetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqSetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqSetCreateInput = {
  cmtluxjm700y906oie2cqcrf9?: InputMaybe<CommonFaqCreateManyInlineInput>;
  /** controlLabel input for default locale (en) */
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  inDevelopment: InDevelopmentStatus;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FaqSetCreateLocalizationsInput>;
  refFaqSetItems?: InputMaybe<FaqSetItemCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqSetCreateLocalizationDataInput = {
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqSetCreateLocalizationInput = {
  /** Localization input */
  data: FaqSetCreateLocalizationDataInput;
  locale: Locale;
};

export type FaqSetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FaqSetCreateLocalizationInput>>;
};

export type FaqSetCreateManyInlineInput = {
  /** Connect multiple existing FaqSet documents */
  connect?: InputMaybe<Array<FaqSetWhereUniqueInput>>;
  /** Create and connect multiple existing FaqSet documents */
  create?: InputMaybe<Array<FaqSetCreateInput>>;
};

export type FaqSetCreateOneInlineInput = {
  /** Connect one existing FaqSet document */
  connect?: InputMaybe<FaqSetWhereUniqueInput>;
  /** Create and connect one FaqSet document */
  create?: InputMaybe<FaqSetCreateInput>;
};

/** An edge in a connection. */
export type FaqSetEdge = {
  __typename?: 'FaqSetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqSet;
};

export type FaqSetItem = Entity & Node & {
  __typename?: 'FaqSetItem';
  answer?: Maybe<Text>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Question and answer will not be collapsed if this is true. */
  defaultOpen?: Maybe<Scalars['Boolean']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<FaqSetItem>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work. */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  /** List of FaqSetItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FaqSetItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  question: Scalars['String']['output'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FaqSetItemAnswerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqSetItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FaqSetItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqSetItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FaqSetItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FaqSetItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FaqSetItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FaqSetItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqSetItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FaqSetItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FaqSetItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FaqSetItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FaqSetItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type FaqSetItemConnection = {
  __typename?: 'FaqSetItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqSetItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqSetItemCreateInput = {
  answer?: InputMaybe<TextCreateOneInlineInput>;
  cmtnf3sk402ma06oi7tj93kg0?: InputMaybe<FaqSetCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FaqSetItemCreateLocalizationsInput>;
  /** question input for default locale (en) */
  question: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqSetItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqSetItemCreateLocalizationInput = {
  /** Localization input */
  data: FaqSetItemCreateLocalizationDataInput;
  locale: Locale;
};

export type FaqSetItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FaqSetItemCreateLocalizationInput>>;
};

export type FaqSetItemCreateManyInlineInput = {
  /** Connect multiple existing FaqSetItem documents */
  connect?: InputMaybe<Array<FaqSetItemWhereUniqueInput>>;
  /** Create and connect multiple existing FaqSetItem documents */
  create?: InputMaybe<Array<FaqSetItemCreateInput>>;
};

export type FaqSetItemCreateOneInlineInput = {
  /** Connect one existing FaqSetItem document */
  connect?: InputMaybe<FaqSetItemWhereUniqueInput>;
  /** Create and connect one FaqSetItem document */
  create?: InputMaybe<FaqSetItemCreateInput>;
};

/** An edge in a connection. */
export type FaqSetItemEdge = {
  __typename?: 'FaqSetItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FaqSetItem;
};

/** Identifies documents */
export type FaqSetItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqSetItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqSetItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqSetItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<TextWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<FaqSetItemWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqSetItemWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqSetItemWhereStageInput>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqSetItemOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DefaultOpenAsc = 'defaultOpen_ASC',
  DefaultOpenDesc = 'defaultOpen_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  HiddenAsc = 'hidden_ASC',
  HiddenDesc = 'hidden_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqSetItemUpdateInput = {
  answer?: InputMaybe<TextUpdateOneInlineInput>;
  cmtnf3sk402ma06oi7tj93kg0?: InputMaybe<FaqSetUpdateManyInlineInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FaqSetItemUpdateLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSetItemUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSetItemUpdateLocalizationInput = {
  data: FaqSetItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type FaqSetItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FaqSetItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FaqSetItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FaqSetItemUpsertLocalizationInput>>;
};

export type FaqSetItemUpdateManyInlineInput = {
  /** Connect multiple existing FaqSetItem documents */
  connect?: InputMaybe<Array<FaqSetItemConnectInput>>;
  /** Create and connect multiple FaqSetItem documents */
  create?: InputMaybe<Array<FaqSetItemCreateInput>>;
  /** Delete multiple FaqSetItem documents */
  delete?: InputMaybe<Array<FaqSetItemWhereUniqueInput>>;
  /** Disconnect multiple FaqSetItem documents */
  disconnect?: InputMaybe<Array<FaqSetItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqSetItem documents */
  set?: InputMaybe<Array<FaqSetItemWhereUniqueInput>>;
  /** Update multiple FaqSetItem documents */
  update?: InputMaybe<Array<FaqSetItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqSetItem documents */
  upsert?: InputMaybe<Array<FaqSetItemUpsertWithNestedWhereUniqueInput>>;
};

export type FaqSetItemUpdateManyInput = {
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FaqSetItemUpdateManyLocalizationsInput>;
  /** question input for default locale (en) */
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSetItemUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSetItemUpdateManyLocalizationInput = {
  data: FaqSetItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FaqSetItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FaqSetItemUpdateManyLocalizationInput>>;
};

export type FaqSetItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqSetItemUpdateManyInput;
  /** Document search */
  where: FaqSetItemWhereInput;
};

export type FaqSetItemUpdateOneInlineInput = {
  /** Connect existing FaqSetItem document */
  connect?: InputMaybe<FaqSetItemWhereUniqueInput>;
  /** Create and connect one FaqSetItem document */
  create?: InputMaybe<FaqSetItemCreateInput>;
  /** Delete currently connected FaqSetItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqSetItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqSetItem document */
  update?: InputMaybe<FaqSetItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqSetItem document */
  upsert?: InputMaybe<FaqSetItemUpsertWithNestedWhereUniqueInput>;
};

export type FaqSetItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqSetItemUpdateInput;
  /** Unique document search */
  where: FaqSetItemWhereUniqueInput;
};

export type FaqSetItemUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqSetItemCreateInput;
  /** Update document if it exists */
  update: FaqSetItemUpdateInput;
};

export type FaqSetItemUpsertLocalizationInput = {
  create: FaqSetItemCreateLocalizationDataInput;
  locale: Locale;
  update: FaqSetItemUpdateLocalizationDataInput;
};

export type FaqSetItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqSetItemUpsertInput;
  /** Unique document search */
  where: FaqSetItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqSetItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FaqSetItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqSetItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqSetItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqSetItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<TextWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  defaultOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  defaultOpen_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<FaqSetItemWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqSetItemWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqSetItemWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hidden_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqSetItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqSetItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqSetItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqSetItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqSetItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FaqSetItem record uniquely */
export type FaqSetItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type FaqSetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqSetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqSetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqSetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqSetWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqSetWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqSetWhereStageInput>;
  icon?: InputMaybe<EdsIcon>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refFaqSetItems_every?: InputMaybe<FaqSetItemWhereInput>;
  refFaqSetItems_none?: InputMaybe<FaqSetItemWhereInput>;
  refFaqSetItems_some?: InputMaybe<FaqSetItemWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqSetOrderByInput {
  ControlLabelAsc = 'controlLabel_ASC',
  ControlLabelDesc = 'controlLabel_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqSetUpdateInput = {
  cmtluxjm700y906oie2cqcrf9?: InputMaybe<CommonFaqUpdateManyInlineInput>;
  /** controlLabel input for default locale (en) */
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FaqSetUpdateLocalizationsInput>;
  refFaqSetItems?: InputMaybe<FaqSetItemUpdateManyInlineInput>;
};

export type FaqSetUpdateLocalizationDataInput = {
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSetUpdateLocalizationInput = {
  data: FaqSetUpdateLocalizationDataInput;
  locale: Locale;
};

export type FaqSetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FaqSetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FaqSetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FaqSetUpsertLocalizationInput>>;
};

export type FaqSetUpdateManyInlineInput = {
  /** Connect multiple existing FaqSet documents */
  connect?: InputMaybe<Array<FaqSetConnectInput>>;
  /** Create and connect multiple FaqSet documents */
  create?: InputMaybe<Array<FaqSetCreateInput>>;
  /** Delete multiple FaqSet documents */
  delete?: InputMaybe<Array<FaqSetWhereUniqueInput>>;
  /** Disconnect multiple FaqSet documents */
  disconnect?: InputMaybe<Array<FaqSetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FaqSet documents */
  set?: InputMaybe<Array<FaqSetWhereUniqueInput>>;
  /** Update multiple FaqSet documents */
  update?: InputMaybe<Array<FaqSetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FaqSet documents */
  upsert?: InputMaybe<Array<FaqSetUpsertWithNestedWhereUniqueInput>>;
};

export type FaqSetUpdateManyInput = {
  /** controlLabel input for default locale (en) */
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FaqSetUpdateManyLocalizationsInput>;
};

export type FaqSetUpdateManyLocalizationDataInput = {
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type FaqSetUpdateManyLocalizationInput = {
  data: FaqSetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FaqSetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FaqSetUpdateManyLocalizationInput>>;
};

export type FaqSetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FaqSetUpdateManyInput;
  /** Document search */
  where: FaqSetWhereInput;
};

export type FaqSetUpdateOneInlineInput = {
  /** Connect existing FaqSet document */
  connect?: InputMaybe<FaqSetWhereUniqueInput>;
  /** Create and connect one FaqSet document */
  create?: InputMaybe<FaqSetCreateInput>;
  /** Delete currently connected FaqSet document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FaqSet document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FaqSet document */
  update?: InputMaybe<FaqSetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FaqSet document */
  upsert?: InputMaybe<FaqSetUpsertWithNestedWhereUniqueInput>;
};

export type FaqSetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FaqSetUpdateInput;
  /** Unique document search */
  where: FaqSetWhereUniqueInput;
};

export type FaqSetUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqSetCreateInput;
  /** Update document if it exists */
  update: FaqSetUpdateInput;
};

export type FaqSetUpsertLocalizationInput = {
  create: FaqSetCreateLocalizationDataInput;
  locale: Locale;
  update: FaqSetUpdateLocalizationDataInput;
};

export type FaqSetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FaqSetUpsertInput;
  /** Unique document search */
  where: FaqSetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqSetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FaqSetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqSetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqSetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqSetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  controlLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  controlLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  controlLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  controlLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  controlLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  controlLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  controlLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  controlLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  controlLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  controlLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqSetWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqSetWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqSetWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<EdsIcon>;
  /** All values that are contained in given list. */
  icon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  icon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  icon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  refFaqSetItems_every?: InputMaybe<FaqSetItemWhereInput>;
  refFaqSetItems_none?: InputMaybe<FaqSetItemWhereInput>;
  refFaqSetItems_some?: InputMaybe<FaqSetItemWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqSetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqSetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqSetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqSetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqSetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FaqSet record uniquely */
export type FaqSetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Side By Side Section Form Variant */
export enum FormVariant {
  None = 'none',
  RedeemCode = 'redeemCode',
  VerifyCode = 'verifyCode'
}

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Image tag or badge component which includes an Image and a corresponding label with an href. */
export type ImageTag = Entity & {
  __typename?: 'ImageTag';
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ImageTag>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Image tag or badge component which includes an Image and a corresponding label with an href. */
export type ImageTagImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Image tag or badge component which includes an Image and a corresponding label with an href. */
export type ImageTagLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Image tag or badge component which includes an Image and a corresponding label with an href. */
export type ImageTagUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type ImageTagConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageTagWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageTagConnection = {
  __typename?: 'ImageTagConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageTagEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageTagCreateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ImageTagCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageTagCreateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageTagCreateLocalizationInput = {
  /** Localization input */
  data: ImageTagCreateLocalizationDataInput;
  locale: Locale;
};

export type ImageTagCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ImageTagCreateLocalizationInput>>;
};

export type ImageTagCreateManyInlineInput = {
  /** Create and connect multiple existing ImageTag documents */
  create?: InputMaybe<Array<ImageTagCreateInput>>;
};

export type ImageTagCreateOneInlineInput = {
  /** Create and connect one ImageTag document */
  create?: InputMaybe<ImageTagCreateInput>;
};

export type ImageTagCreateWithPositionInput = {
  /** Document to create */
  data: ImageTagCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ImageTagEdge = {
  __typename?: 'ImageTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageTag;
};

/** Identifies documents */
export type ImageTagManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ImageTagOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ImageTagParent = SectionContent | SectionSideBySide;

export type ImageTagParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideConnectInput>;
};

export type ImageTagParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateInput>;
};

export type ImageTagParentCreateManyInlineInput = {
  /** Create and connect multiple existing ImageTagParent documents */
  create?: InputMaybe<Array<ImageTagParentCreateInput>>;
};

export type ImageTagParentCreateOneInlineInput = {
  /** Create and connect one ImageTagParent document */
  create?: InputMaybe<ImageTagParentCreateInput>;
};

export type ImageTagParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateWithPositionInput>;
};

export type ImageTagParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateInput>;
};

export type ImageTagParentUpdateManyInlineInput = {
  /** Create and connect multiple ImageTagParent component instances */
  create?: InputMaybe<Array<ImageTagParentCreateWithPositionInput>>;
  /** Delete multiple ImageTagParent documents */
  delete?: InputMaybe<Array<ImageTagParentWhereUniqueInput>>;
  /** Update multiple ImageTagParent component instances */
  update?: InputMaybe<Array<ImageTagParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ImageTagParent component instances */
  upsert?: InputMaybe<Array<ImageTagParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ImageTagParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateManyWithNestedWhereInput>;
};

export type ImageTagParentUpdateOneInlineInput = {
  /** Create and connect one ImageTagParent document */
  create?: InputMaybe<ImageTagParentCreateInput>;
  /** Delete currently connected ImageTagParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageTagParent document */
  update?: InputMaybe<ImageTagParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageTagParent document */
  upsert?: InputMaybe<ImageTagParentUpsertWithNestedWhereUniqueInput>;
};

export type ImageTagParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ImageTagParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueInput>;
};

export type ImageTagParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ImageTagParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueInput>;
};

export type ImageTagParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereInput>;
};

export type ImageTagParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereUniqueInput>;
};

export type ImageTagUpdateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ImageTagUpdateLocalizationsInput>;
};

export type ImageTagUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ImageTagUpdateLocalizationInput = {
  data: ImageTagUpdateLocalizationDataInput;
  locale: Locale;
};

export type ImageTagUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ImageTagCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ImageTagUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ImageTagUpsertLocalizationInput>>;
};

export type ImageTagUpdateManyInlineInput = {
  /** Create and connect multiple ImageTag component instances */
  create?: InputMaybe<Array<ImageTagCreateWithPositionInput>>;
  /** Delete multiple ImageTag documents */
  delete?: InputMaybe<Array<ImageTagWhereUniqueInput>>;
  /** Update multiple ImageTag component instances */
  update?: InputMaybe<Array<ImageTagUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ImageTag component instances */
  upsert?: InputMaybe<Array<ImageTagUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ImageTagUpdateManyInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ImageTagUpdateManyLocalizationsInput>;
};

export type ImageTagUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ImageTagUpdateManyLocalizationInput = {
  data: ImageTagUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ImageTagUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ImageTagUpdateManyLocalizationInput>>;
};

export type ImageTagUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageTagUpdateManyInput;
  /** Document search */
  where: ImageTagWhereInput;
};

export type ImageTagUpdateOneInlineInput = {
  /** Create and connect one ImageTag document */
  create?: InputMaybe<ImageTagCreateInput>;
  /** Delete currently connected ImageTag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageTag document */
  update?: InputMaybe<ImageTagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageTag document */
  upsert?: InputMaybe<ImageTagUpsertWithNestedWhereUniqueInput>;
};

export type ImageTagUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ImageTagUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ImageTagWhereUniqueInput;
};

export type ImageTagUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageTagUpdateInput;
  /** Unique document search */
  where: ImageTagWhereUniqueInput;
};

export type ImageTagUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageTagCreateInput;
  /** Update document if it exists */
  update: ImageTagUpdateInput;
};

export type ImageTagUpsertLocalizationInput = {
  create: ImageTagCreateLocalizationDataInput;
  locale: Locale;
  update: ImageTagUpdateLocalizationDataInput;
};

export type ImageTagUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ImageTagUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ImageTagWhereUniqueInput;
};

export type ImageTagUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageTagUpsertInput;
  /** Unique document search */
  where: ImageTagWhereUniqueInput;
};

/** Identifies documents */
export type ImageTagWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageTagWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageTagWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageTagWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ImageTag record uniquely */
export type ImageTagWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Opt-in flag to prevent accidental production publishes */
export enum InDevelopmentStatus {
  AllowProdPublish = 'AllowProdPublish',
  DisableProdPublish = 'DisableProdPublish'
}

export type Link = Entity & {
  __typename?: 'Link';
  /** Full canonical URL. Will refresh the page instead of using local routing logic. */
  href?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Link>;
  /** Use local routing logic */
  relativePath?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Used to map the correct attributes to the component. */
  ukey: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  useRelativePath?: Maybe<Scalars['Boolean']['output']>;
};


export type LinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type LinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type LinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkCreateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LinkCreateLocalizationsInput>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
  ukey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  useRelativePath?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkCreateLocalizationDataInput = {
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LinkCreateLocalizationInput = {
  /** Localization input */
  data: LinkCreateLocalizationDataInput;
  locale: Locale;
};

export type LinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LinkCreateLocalizationInput>>;
};

export type LinkCreateManyInlineInput = {
  /** Create and connect multiple existing Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
};

export type LinkCreateWithPositionInput = {
  /** Document to create */
  data: LinkCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Link;
};

/** Identifies documents */
export type LinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relativePath_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relativePath_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relativePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relativePath_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relativePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relativePath_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relativePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relativePath_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relativePath_starts_with?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  useRelativePath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  useRelativePath_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LinkOrderByInput {
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  RelativePathAsc = 'relativePath_ASC',
  RelativePathDesc = 'relativePath_DESC',
  UkeyAsc = 'ukey_ASC',
  UkeyDesc = 'ukey_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  UseRelativePathAsc = 'useRelativePath_ASC',
  UseRelativePathDesc = 'useRelativePath_DESC'
}

export type LinkParent = SectionContent;

export type LinkParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type LinkParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type LinkParentCreateManyInlineInput = {
  /** Create and connect multiple existing LinkParent documents */
  create?: InputMaybe<Array<LinkParentCreateInput>>;
};

export type LinkParentCreateOneInlineInput = {
  /** Create and connect one LinkParent document */
  create?: InputMaybe<LinkParentCreateInput>;
};

export type LinkParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type LinkParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type LinkParentUpdateManyInlineInput = {
  /** Create and connect multiple LinkParent component instances */
  create?: InputMaybe<Array<LinkParentCreateWithPositionInput>>;
  /** Delete multiple LinkParent documents */
  delete?: InputMaybe<Array<LinkParentWhereUniqueInput>>;
  /** Update multiple LinkParent component instances */
  update?: InputMaybe<Array<LinkParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple LinkParent component instances */
  upsert?: InputMaybe<Array<LinkParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type LinkParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type LinkParentUpdateOneInlineInput = {
  /** Create and connect one LinkParent document */
  create?: InputMaybe<LinkParentCreateInput>;
  /** Delete currently connected LinkParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkParent document */
  update?: InputMaybe<LinkParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkParent document */
  upsert?: InputMaybe<LinkParentUpsertWithNestedWhereUniqueInput>;
};

export type LinkParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type LinkParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type LinkParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type LinkParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type LinkParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type LinkParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type LinkUpdateInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<LinkUpdateLocalizationsInput>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  useRelativePath?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateLocalizationInput = {
  data: LinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type LinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<LinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<LinkUpsertLocalizationInput>>;
};

export type LinkUpdateManyInlineInput = {
  /** Create and connect multiple Link component instances */
  create?: InputMaybe<Array<LinkCreateWithPositionInput>>;
  /** Delete multiple Link documents */
  delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Update multiple Link component instances */
  update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Link component instances */
  upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type LinkUpdateManyInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (en) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<LinkUpdateManyLocalizationsInput>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  useRelativePath?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyLocalizationInput = {
  data: LinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type LinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LinkUpdateManyLocalizationInput>>;
};

export type LinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkUpdateManyInput;
  /** Document search */
  where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
  /** Delete currently connected Link document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Link document */
  update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Link document */
  upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<LinkUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: LinkWhereUniqueInput;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkUpdateInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkCreateInput;
  /** Update document if it exists */
  update: LinkUpdateInput;
};

export type LinkUpsertLocalizationInput = {
  create: LinkCreateLocalizationDataInput;
  locale: Locale;
  update: LinkUpdateLocalizationDataInput;
};

export type LinkUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<LinkUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkUpsertInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

/** Identifies documents */
export type LinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  href_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  href_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  href_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  href_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  href_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  href_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  href_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  href_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  href_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  relativePath?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  relativePath_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  relativePath_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  relativePath_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  relativePath_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  relativePath_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  relativePath_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  relativePath_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  relativePath_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  relativePath_starts_with?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  useRelativePath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  useRelativePath_not?: InputMaybe<Scalars['Boolean']['input']>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Locale system enumeration */
export enum Locale {
  Ar = 'ar',
  Bg = 'bg',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  /** System locale */
  En = 'en',
  EsEs = 'es_ES',
  EsMx = 'es_MX',
  Fi = 'fi',
  Fil = 'fil',
  Fr = 'fr',
  Hi = 'hi',
  Hu = 'hu',
  Id = 'id',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Ms = 'ms',
  Nl = 'nl',
  No = 'no',
  Pl = 'pl',
  Pt = 'pt',
  PtBr = 'pt_BR',
  Ro = 'ro',
  Ru = 'ru',
  Sv = 'sv',
  Th = 'th',
  Tr = 'tr',
  Uk = 'uk',
  Vi = 'vi',
  ZhCn = 'zh_CN',
  ZhHant = 'zh_Hant'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one commonEulaKey */
  createCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Create one commonFaq */
  createCommonFaq?: Maybe<CommonFaq>;
  /** Create one commonPageHeroSection */
  createCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Create one commonSection */
  createCommonSection?: Maybe<CommonSection>;
  /** Create one faqSet */
  createFaqSet?: Maybe<FaqSet>;
  /** Create one faqSetItem */
  createFaqSetItem?: Maybe<FaqSetItem>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one siteSetting */
  createSiteSetting?: Maybe<SiteSetting>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one commonEulaKey from _all_ existing stages. Returns deleted document. */
  deleteCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Delete one commonFaq from _all_ existing stages. Returns deleted document. */
  deleteCommonFaq?: Maybe<CommonFaq>;
  /** Delete one commonPageHeroSection from _all_ existing stages. Returns deleted document. */
  deleteCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Delete one commonSection from _all_ existing stages. Returns deleted document. */
  deleteCommonSection?: Maybe<CommonSection>;
  /** Delete one faqSet from _all_ existing stages. Returns deleted document. */
  deleteFaqSet?: Maybe<FaqSet>;
  /** Delete one faqSetItem from _all_ existing stages. Returns deleted document. */
  deleteFaqSetItem?: Maybe<FaqSetItem>;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many CommonEulaKey documents
   * @deprecated Please use the new paginated many mutation (deleteManyCommonEulaKeysConnection)
   */
  deleteManyCommonEulaKeys: BatchPayload;
  /** Delete many CommonEulaKey documents, return deleted documents */
  deleteManyCommonEulaKeysConnection: CommonEulaKeyConnection;
  /**
   * Delete many CommonFaq documents
   * @deprecated Please use the new paginated many mutation (deleteManyCommonFaqsConnection)
   */
  deleteManyCommonFaqs: BatchPayload;
  /** Delete many CommonFaq documents, return deleted documents */
  deleteManyCommonFaqsConnection: CommonFaqConnection;
  /**
   * Delete many CommonPageHeroSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyCommonPageHeroSectionsConnection)
   */
  deleteManyCommonPageHeroSections: BatchPayload;
  /** Delete many CommonPageHeroSection documents, return deleted documents */
  deleteManyCommonPageHeroSectionsConnection: CommonPageHeroSectionConnection;
  /**
   * Delete many CommonSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyCommonSectionsConnection)
   */
  deleteManyCommonSections: BatchPayload;
  /** Delete many CommonSection documents, return deleted documents */
  deleteManyCommonSectionsConnection: CommonSectionConnection;
  /**
   * Delete many FaqSetItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqSetItemsConnection)
   */
  deleteManyFaqSetItems: BatchPayload;
  /** Delete many FaqSetItem documents, return deleted documents */
  deleteManyFaqSetItemsConnection: FaqSetItemConnection;
  /**
   * Delete many FaqSet documents
   * @deprecated Please use the new paginated many mutation (deleteManyFaqSetsConnection)
   */
  deleteManyFaqSets: BatchPayload;
  /** Delete many FaqSet documents, return deleted documents */
  deleteManyFaqSetsConnection: FaqSetConnection;
  /**
   * Delete many SiteSetting documents
   * @deprecated Please use the new paginated many mutation (deleteManySiteSettingsConnection)
   */
  deleteManySiteSettings: BatchPayload;
  /** Delete many SiteSetting documents, return deleted documents */
  deleteManySiteSettingsConnection: SiteSettingConnection;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one siteSetting from _all_ existing stages. Returns deleted document. */
  deleteSiteSetting?: Maybe<SiteSetting>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one commonEulaKey */
  publishCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Publish one commonFaq */
  publishCommonFaq?: Maybe<CommonFaq>;
  /** Publish one commonPageHeroSection */
  publishCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Publish one commonSection */
  publishCommonSection?: Maybe<CommonSection>;
  /** Publish one faqSet */
  publishFaqSet?: Maybe<FaqSet>;
  /** Publish one faqSetItem */
  publishFaqSetItem?: Maybe<FaqSetItem>;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many CommonEulaKey documents
   * @deprecated Please use the new paginated many mutation (publishManyCommonEulaKeysConnection)
   */
  publishManyCommonEulaKeys: BatchPayload;
  /** Publish many CommonEulaKey documents */
  publishManyCommonEulaKeysConnection: CommonEulaKeyConnection;
  /**
   * Publish many CommonFaq documents
   * @deprecated Please use the new paginated many mutation (publishManyCommonFaqsConnection)
   */
  publishManyCommonFaqs: BatchPayload;
  /** Publish many CommonFaq documents */
  publishManyCommonFaqsConnection: CommonFaqConnection;
  /**
   * Publish many CommonPageHeroSection documents
   * @deprecated Please use the new paginated many mutation (publishManyCommonPageHeroSectionsConnection)
   */
  publishManyCommonPageHeroSections: BatchPayload;
  /** Publish many CommonPageHeroSection documents */
  publishManyCommonPageHeroSectionsConnection: CommonPageHeroSectionConnection;
  /**
   * Publish many CommonSection documents
   * @deprecated Please use the new paginated many mutation (publishManyCommonSectionsConnection)
   */
  publishManyCommonSections: BatchPayload;
  /** Publish many CommonSection documents */
  publishManyCommonSectionsConnection: CommonSectionConnection;
  /**
   * Publish many FaqSetItem documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqSetItemsConnection)
   */
  publishManyFaqSetItems: BatchPayload;
  /** Publish many FaqSetItem documents */
  publishManyFaqSetItemsConnection: FaqSetItemConnection;
  /**
   * Publish many FaqSet documents
   * @deprecated Please use the new paginated many mutation (publishManyFaqSetsConnection)
   */
  publishManyFaqSets: BatchPayload;
  /** Publish many FaqSet documents */
  publishManyFaqSetsConnection: FaqSetConnection;
  /**
   * Publish many SiteSetting documents
   * @deprecated Please use the new paginated many mutation (publishManySiteSettingsConnection)
   */
  publishManySiteSettings: BatchPayload;
  /** Publish many SiteSetting documents */
  publishManySiteSettingsConnection: SiteSettingConnection;
  /** Publish one siteSetting */
  publishSiteSetting?: Maybe<SiteSetting>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one commonEulaKey */
  schedulePublishCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Schedule to publish one commonFaq */
  schedulePublishCommonFaq?: Maybe<CommonFaq>;
  /** Schedule to publish one commonPageHeroSection */
  schedulePublishCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Schedule to publish one commonSection */
  schedulePublishCommonSection?: Maybe<CommonSection>;
  /** Schedule to publish one faqSet */
  schedulePublishFaqSet?: Maybe<FaqSet>;
  /** Schedule to publish one faqSetItem */
  schedulePublishFaqSetItem?: Maybe<FaqSetItem>;
  /** Schedule to publish one siteSetting */
  schedulePublishSiteSetting?: Maybe<SiteSetting>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one commonEulaKey from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Unpublish one commonFaq from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCommonFaq?: Maybe<CommonFaq>;
  /** Unpublish one commonPageHeroSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Unpublish one commonSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCommonSection?: Maybe<CommonSection>;
  /** Unpublish one faqSet from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqSet?: Maybe<FaqSet>;
  /** Unpublish one faqSetItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaqSetItem?: Maybe<FaqSetItem>;
  /** Unpublish one siteSetting from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSiteSetting?: Maybe<SiteSetting>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one commonEulaKey from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Unpublish one commonFaq from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCommonFaq?: Maybe<CommonFaq>;
  /** Unpublish one commonPageHeroSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Unpublish one commonSection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCommonSection?: Maybe<CommonSection>;
  /** Unpublish one faqSet from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqSet?: Maybe<FaqSet>;
  /** Unpublish one faqSetItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaqSetItem?: Maybe<FaqSetItem>;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many CommonEulaKey documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCommonEulaKeysConnection)
   */
  unpublishManyCommonEulaKeys: BatchPayload;
  /** Find many CommonEulaKey documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCommonEulaKeysConnection: CommonEulaKeyConnection;
  /**
   * Unpublish many CommonFaq documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCommonFaqsConnection)
   */
  unpublishManyCommonFaqs: BatchPayload;
  /** Find many CommonFaq documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCommonFaqsConnection: CommonFaqConnection;
  /**
   * Unpublish many CommonPageHeroSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCommonPageHeroSectionsConnection)
   */
  unpublishManyCommonPageHeroSections: BatchPayload;
  /** Find many CommonPageHeroSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCommonPageHeroSectionsConnection: CommonPageHeroSectionConnection;
  /**
   * Unpublish many CommonSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCommonSectionsConnection)
   */
  unpublishManyCommonSections: BatchPayload;
  /** Find many CommonSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCommonSectionsConnection: CommonSectionConnection;
  /**
   * Unpublish many FaqSetItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqSetItemsConnection)
   */
  unpublishManyFaqSetItems: BatchPayload;
  /** Find many FaqSetItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqSetItemsConnection: FaqSetItemConnection;
  /**
   * Unpublish many FaqSet documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFaqSetsConnection)
   */
  unpublishManyFaqSets: BatchPayload;
  /** Find many FaqSet documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqSetsConnection: FaqSetConnection;
  /**
   * Unpublish many SiteSetting documents
   * @deprecated Please use the new paginated many mutation (unpublishManySiteSettingsConnection)
   */
  unpublishManySiteSettings: BatchPayload;
  /** Find many SiteSetting documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySiteSettingsConnection: SiteSettingConnection;
  /** Unpublish one siteSetting from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSiteSetting?: Maybe<SiteSetting>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one commonEulaKey */
  updateCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Update one commonFaq */
  updateCommonFaq?: Maybe<CommonFaq>;
  /** Update one commonPageHeroSection */
  updateCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Update one commonSection */
  updateCommonSection?: Maybe<CommonSection>;
  /** Update one faqSet */
  updateFaqSet?: Maybe<FaqSet>;
  /** Update one faqSetItem */
  updateFaqSetItem?: Maybe<FaqSetItem>;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many commonEulaKeys
   * @deprecated Please use the new paginated many mutation (updateManyCommonEulaKeysConnection)
   */
  updateManyCommonEulaKeys: BatchPayload;
  /** Update many CommonEulaKey documents */
  updateManyCommonEulaKeysConnection: CommonEulaKeyConnection;
  /**
   * Update many commonFaqs
   * @deprecated Please use the new paginated many mutation (updateManyCommonFaqsConnection)
   */
  updateManyCommonFaqs: BatchPayload;
  /** Update many CommonFaq documents */
  updateManyCommonFaqsConnection: CommonFaqConnection;
  /**
   * Update many commonPageHeroSections
   * @deprecated Please use the new paginated many mutation (updateManyCommonPageHeroSectionsConnection)
   */
  updateManyCommonPageHeroSections: BatchPayload;
  /** Update many CommonPageHeroSection documents */
  updateManyCommonPageHeroSectionsConnection: CommonPageHeroSectionConnection;
  /**
   * Update many commonSections
   * @deprecated Please use the new paginated many mutation (updateManyCommonSectionsConnection)
   */
  updateManyCommonSections: BatchPayload;
  /** Update many CommonSection documents */
  updateManyCommonSectionsConnection: CommonSectionConnection;
  /**
   * Update many faqSetItems
   * @deprecated Please use the new paginated many mutation (updateManyFaqSetItemsConnection)
   */
  updateManyFaqSetItems: BatchPayload;
  /** Update many FaqSetItem documents */
  updateManyFaqSetItemsConnection: FaqSetItemConnection;
  /**
   * Update many faqSets
   * @deprecated Please use the new paginated many mutation (updateManyFaqSetsConnection)
   */
  updateManyFaqSets: BatchPayload;
  /** Update many FaqSet documents */
  updateManyFaqSetsConnection: FaqSetConnection;
  /**
   * Update many siteSettings
   * @deprecated Please use the new paginated many mutation (updateManySiteSettingsConnection)
   */
  updateManySiteSettings: BatchPayload;
  /** Update many SiteSetting documents */
  updateManySiteSettingsConnection: SiteSettingConnection;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one siteSetting */
  updateSiteSetting?: Maybe<SiteSetting>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one commonEulaKey */
  upsertCommonEulaKey?: Maybe<CommonEulaKey>;
  /** Upsert one commonFaq */
  upsertCommonFaq?: Maybe<CommonFaq>;
  /** Upsert one commonPageHeroSection */
  upsertCommonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Upsert one commonSection */
  upsertCommonSection?: Maybe<CommonSection>;
  /** Upsert one faqSet */
  upsertFaqSet?: Maybe<FaqSet>;
  /** Upsert one faqSetItem */
  upsertFaqSetItem?: Maybe<FaqSetItem>;
  /** Upsert one siteSetting */
  upsertSiteSetting?: Maybe<SiteSetting>;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateCommonEulaKeyArgs = {
  data: CommonEulaKeyCreateInput;
};


export type MutationCreateCommonFaqArgs = {
  data: CommonFaqCreateInput;
};


export type MutationCreateCommonPageHeroSectionArgs = {
  data: CommonPageHeroSectionCreateInput;
};


export type MutationCreateCommonSectionArgs = {
  data: CommonSectionCreateInput;
};


export type MutationCreateFaqSetArgs = {
  data: FaqSetCreateInput;
};


export type MutationCreateFaqSetItemArgs = {
  data: FaqSetItemCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateSiteSettingArgs = {
  data: SiteSettingCreateInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteCommonEulaKeyArgs = {
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationDeleteCommonFaqArgs = {
  where: CommonFaqWhereUniqueInput;
};


export type MutationDeleteCommonPageHeroSectionArgs = {
  where: CommonPageHeroSectionWhereUniqueInput;
};


export type MutationDeleteCommonSectionArgs = {
  where: CommonSectionWhereUniqueInput;
};


export type MutationDeleteFaqSetArgs = {
  where: FaqSetWhereUniqueInput;
};


export type MutationDeleteFaqSetItemArgs = {
  where: FaqSetItemWhereUniqueInput;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyCommonEulaKeysArgs = {
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationDeleteManyCommonEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationDeleteManyCommonFaqsArgs = {
  where?: InputMaybe<CommonFaqManyWhereInput>;
};


export type MutationDeleteManyCommonFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonFaqManyWhereInput>;
};


export type MutationDeleteManyCommonPageHeroSectionsArgs = {
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
};


export type MutationDeleteManyCommonPageHeroSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
};


export type MutationDeleteManyCommonSectionsArgs = {
  where?: InputMaybe<CommonSectionManyWhereInput>;
};


export type MutationDeleteManyCommonSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonSectionManyWhereInput>;
};


export type MutationDeleteManyFaqSetItemsArgs = {
  where?: InputMaybe<FaqSetItemManyWhereInput>;
};


export type MutationDeleteManyFaqSetItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
};


export type MutationDeleteManyFaqSetsArgs = {
  where?: InputMaybe<FaqSetManyWhereInput>;
};


export type MutationDeleteManyFaqSetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqSetManyWhereInput>;
};


export type MutationDeleteManySiteSettingsArgs = {
  where?: InputMaybe<SiteSettingManyWhereInput>;
};


export type MutationDeleteManySiteSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteSettingManyWhereInput>;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteSiteSettingArgs = {
  where: SiteSettingWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCommonEulaKeyArgs = {
  to?: Array<Stage>;
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationPublishCommonFaqArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CommonFaqWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCommonPageHeroSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CommonPageHeroSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCommonSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CommonSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFaqSetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FaqSetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFaqSetItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FaqSetItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCommonEulaKeysArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationPublishManyCommonEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationPublishManyCommonFaqsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonFaqManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCommonFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonFaqManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCommonPageHeroSectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCommonPageHeroSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCommonSectionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCommonSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CommonSectionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFaqSetItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFaqSetItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFaqSetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqSetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFaqSetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqSetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySiteSettingsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SiteSettingManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySiteSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SiteSettingManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishSiteSettingArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: SiteSettingWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCommonEulaKeyArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationSchedulePublishCommonFaqArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CommonFaqWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCommonPageHeroSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CommonPageHeroSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCommonSectionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CommonSectionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFaqSetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FaqSetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFaqSetItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FaqSetItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishSiteSettingArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SiteSettingWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishCommonEulaKeyArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationScheduleUnpublishCommonFaqArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CommonFaqWhereUniqueInput;
};


export type MutationScheduleUnpublishCommonPageHeroSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CommonPageHeroSectionWhereUniqueInput;
};


export type MutationScheduleUnpublishCommonSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CommonSectionWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqSetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FaqSetWhereUniqueInput;
};


export type MutationScheduleUnpublishFaqSetItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FaqSetItemWhereUniqueInput;
};


export type MutationScheduleUnpublishSiteSettingArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SiteSettingWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishCommonEulaKeyArgs = {
  from?: Array<Stage>;
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationUnpublishCommonFaqArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CommonFaqWhereUniqueInput;
};


export type MutationUnpublishCommonPageHeroSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CommonPageHeroSectionWhereUniqueInput;
};


export type MutationUnpublishCommonSectionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CommonSectionWhereUniqueInput;
};


export type MutationUnpublishFaqSetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FaqSetWhereUniqueInput;
};


export type MutationUnpublishFaqSetItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FaqSetItemWhereUniqueInput;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyCommonEulaKeysArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationUnpublishManyCommonEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationUnpublishManyCommonFaqsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonFaqManyWhereInput>;
};


export type MutationUnpublishManyCommonFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonFaqManyWhereInput>;
};


export type MutationUnpublishManyCommonPageHeroSectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
};


export type MutationUnpublishManyCommonPageHeroSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
};


export type MutationUnpublishManyCommonSectionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonSectionManyWhereInput>;
};


export type MutationUnpublishManyCommonSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonSectionManyWhereInput>;
};


export type MutationUnpublishManyFaqSetItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
};


export type MutationUnpublishManyFaqSetItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
};


export type MutationUnpublishManyFaqSetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FaqSetManyWhereInput>;
};


export type MutationUnpublishManyFaqSetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FaqSetManyWhereInput>;
};


export type MutationUnpublishManySiteSettingsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SiteSettingManyWhereInput>;
};


export type MutationUnpublishManySiteSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SiteSettingManyWhereInput>;
};


export type MutationUnpublishSiteSettingArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SiteSettingWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateCommonEulaKeyArgs = {
  data: CommonEulaKeyUpdateInput;
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationUpdateCommonFaqArgs = {
  data: CommonFaqUpdateInput;
  where: CommonFaqWhereUniqueInput;
};


export type MutationUpdateCommonPageHeroSectionArgs = {
  data: CommonPageHeroSectionUpdateInput;
  where: CommonPageHeroSectionWhereUniqueInput;
};


export type MutationUpdateCommonSectionArgs = {
  data: CommonSectionUpdateInput;
  where: CommonSectionWhereUniqueInput;
};


export type MutationUpdateFaqSetArgs = {
  data: FaqSetUpdateInput;
  where: FaqSetWhereUniqueInput;
};


export type MutationUpdateFaqSetItemArgs = {
  data: FaqSetItemUpdateInput;
  where: FaqSetItemWhereUniqueInput;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyCommonEulaKeysArgs = {
  data: CommonEulaKeyUpdateManyInput;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationUpdateManyCommonEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CommonEulaKeyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonEulaKeyManyWhereInput>;
};


export type MutationUpdateManyCommonFaqsArgs = {
  data: CommonFaqUpdateManyInput;
  where?: InputMaybe<CommonFaqManyWhereInput>;
};


export type MutationUpdateManyCommonFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CommonFaqUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonFaqManyWhereInput>;
};


export type MutationUpdateManyCommonPageHeroSectionsArgs = {
  data: CommonPageHeroSectionUpdateManyInput;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
};


export type MutationUpdateManyCommonPageHeroSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CommonPageHeroSectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonPageHeroSectionManyWhereInput>;
};


export type MutationUpdateManyCommonSectionsArgs = {
  data: CommonSectionUpdateManyInput;
  where?: InputMaybe<CommonSectionManyWhereInput>;
};


export type MutationUpdateManyCommonSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CommonSectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonSectionManyWhereInput>;
};


export type MutationUpdateManyFaqSetItemsArgs = {
  data: FaqSetItemUpdateManyInput;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
};


export type MutationUpdateManyFaqSetItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FaqSetItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqSetItemManyWhereInput>;
};


export type MutationUpdateManyFaqSetsArgs = {
  data: FaqSetUpdateManyInput;
  where?: InputMaybe<FaqSetManyWhereInput>;
};


export type MutationUpdateManyFaqSetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FaqSetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaqSetManyWhereInput>;
};


export type MutationUpdateManySiteSettingsArgs = {
  data: SiteSettingUpdateManyInput;
  where?: InputMaybe<SiteSettingManyWhereInput>;
};


export type MutationUpdateManySiteSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SiteSettingUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteSettingManyWhereInput>;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateSiteSettingArgs = {
  data: SiteSettingUpdateInput;
  where: SiteSettingWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertCommonEulaKeyArgs = {
  upsert: CommonEulaKeyUpsertInput;
  where: CommonEulaKeyWhereUniqueInput;
};


export type MutationUpsertCommonFaqArgs = {
  upsert: CommonFaqUpsertInput;
  where: CommonFaqWhereUniqueInput;
};


export type MutationUpsertCommonPageHeroSectionArgs = {
  upsert: CommonPageHeroSectionUpsertInput;
  where: CommonPageHeroSectionWhereUniqueInput;
};


export type MutationUpsertCommonSectionArgs = {
  upsert: CommonSectionUpsertInput;
  where: CommonSectionWhereUniqueInput;
};


export type MutationUpsertFaqSetArgs = {
  upsert: FaqSetUpsertInput;
  where: FaqSetWhereUniqueInput;
};


export type MutationUpsertFaqSetItemArgs = {
  upsert: FaqSetItemUpsertInput;
  where: FaqSetItemWhereUniqueInput;
};


export type MutationUpsertSiteSettingArgs = {
  upsert: SiteSettingUpsertInput;
  where: SiteSettingWhereUniqueInput;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ProductDisclaimer = Entity & {
  __typename?: 'ProductDisclaimer';
  ageRating?: Maybe<ConfigAgeRating>;
  disclaimer: Alert;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductDisclaimerAgeRatingArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProductDisclaimerDisclaimerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProductDisclaimerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProductDisclaimerWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProductDisclaimerConnection = {
  __typename?: 'ProductDisclaimerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProductDisclaimerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProductDisclaimerCreateInput = {
  ageRating?: InputMaybe<ConfigAgeRatingCreateOneInlineInput>;
  disclaimer: AlertCreateOneInlineInput;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductDisclaimerCreateManyInlineInput = {
  /** Create and connect multiple existing ProductDisclaimer documents */
  create?: InputMaybe<Array<ProductDisclaimerCreateInput>>;
};

export type ProductDisclaimerCreateOneInlineInput = {
  /** Create and connect one ProductDisclaimer document */
  create?: InputMaybe<ProductDisclaimerCreateInput>;
};

export type ProductDisclaimerCreateWithPositionInput = {
  /** Document to create */
  data: ProductDisclaimerCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type ProductDisclaimerEdge = {
  __typename?: 'ProductDisclaimerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductDisclaimer;
};

/** Identifies documents */
export type ProductDisclaimerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductDisclaimerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductDisclaimerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductDisclaimerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ageRating?: InputMaybe<ConfigAgeRatingWhereInput>;
  disclaimer?: InputMaybe<AlertWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum ProductDisclaimerOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ProductDisclaimerParent = SectionContent;

export type ProductDisclaimerParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type ProductDisclaimerParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type ProductDisclaimerParentCreateManyInlineInput = {
  /** Create and connect multiple existing ProductDisclaimerParent documents */
  create?: InputMaybe<Array<ProductDisclaimerParentCreateInput>>;
};

export type ProductDisclaimerParentCreateOneInlineInput = {
  /** Create and connect one ProductDisclaimerParent document */
  create?: InputMaybe<ProductDisclaimerParentCreateInput>;
};

export type ProductDisclaimerParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type ProductDisclaimerParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type ProductDisclaimerParentUpdateManyInlineInput = {
  /** Create and connect multiple ProductDisclaimerParent component instances */
  create?: InputMaybe<Array<ProductDisclaimerParentCreateWithPositionInput>>;
  /** Delete multiple ProductDisclaimerParent documents */
  delete?: InputMaybe<Array<ProductDisclaimerParentWhereUniqueInput>>;
  /** Update multiple ProductDisclaimerParent component instances */
  update?: InputMaybe<Array<ProductDisclaimerParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ProductDisclaimerParent component instances */
  upsert?: InputMaybe<Array<ProductDisclaimerParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ProductDisclaimerParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type ProductDisclaimerParentUpdateOneInlineInput = {
  /** Create and connect one ProductDisclaimerParent document */
  create?: InputMaybe<ProductDisclaimerParentCreateInput>;
  /** Delete currently connected ProductDisclaimerParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductDisclaimerParent document */
  update?: InputMaybe<ProductDisclaimerParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductDisclaimerParent document */
  upsert?: InputMaybe<ProductDisclaimerParentUpsertWithNestedWhereUniqueInput>;
};

export type ProductDisclaimerParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type ProductDisclaimerParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type ProductDisclaimerParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type ProductDisclaimerParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type ProductDisclaimerParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type ProductDisclaimerParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type ProductDisclaimerUpdateInput = {
  ageRating?: InputMaybe<ConfigAgeRatingUpdateOneInlineInput>;
  disclaimer?: InputMaybe<AlertUpdateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDisclaimerUpdateManyInlineInput = {
  /** Create and connect multiple ProductDisclaimer component instances */
  create?: InputMaybe<Array<ProductDisclaimerCreateWithPositionInput>>;
  /** Delete multiple ProductDisclaimer documents */
  delete?: InputMaybe<Array<ProductDisclaimerWhereUniqueInput>>;
  /** Update multiple ProductDisclaimer component instances */
  update?: InputMaybe<Array<ProductDisclaimerUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple ProductDisclaimer component instances */
  upsert?: InputMaybe<Array<ProductDisclaimerUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type ProductDisclaimerUpdateManyInput = {
  internalDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ProductDisclaimerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProductDisclaimerUpdateManyInput;
  /** Document search */
  where: ProductDisclaimerWhereInput;
};

export type ProductDisclaimerUpdateOneInlineInput = {
  /** Create and connect one ProductDisclaimer document */
  create?: InputMaybe<ProductDisclaimerCreateInput>;
  /** Delete currently connected ProductDisclaimer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProductDisclaimer document */
  update?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProductDisclaimer document */
  upsert?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueInput>;
};

export type ProductDisclaimerUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<ProductDisclaimerUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ProductDisclaimerWhereUniqueInput;
};

export type ProductDisclaimerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProductDisclaimerUpdateInput;
  /** Unique document search */
  where: ProductDisclaimerWhereUniqueInput;
};

export type ProductDisclaimerUpsertInput = {
  /** Create document if it didn't exist */
  create: ProductDisclaimerCreateInput;
  /** Update document if it exists */
  update: ProductDisclaimerUpdateInput;
};

export type ProductDisclaimerUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<ProductDisclaimerUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: ProductDisclaimerWhereUniqueInput;
};

export type ProductDisclaimerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProductDisclaimerUpsertInput;
  /** Unique document search */
  where: ProductDisclaimerWhereUniqueInput;
};

/** Identifies documents */
export type ProductDisclaimerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductDisclaimerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductDisclaimerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductDisclaimerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  ageRating?: InputMaybe<ConfigAgeRatingWhereInput>;
  disclaimer?: InputMaybe<AlertWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References ProductDisclaimer record uniquely */
export type ProductDisclaimerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single commonEulaKey */
  commonEulaKey?: Maybe<CommonEulaKey>;
  /** Retrieve document version */
  commonEulaKeyVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple commonEulaKeys */
  commonEulaKeys: Array<CommonEulaKey>;
  /** Retrieve multiple commonEulaKeys using the Relay connection interface */
  commonEulaKeysConnection: CommonEulaKeyConnection;
  /** Retrieve a single commonFaq */
  commonFaq?: Maybe<CommonFaq>;
  /** Retrieve document version */
  commonFaqVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple commonFaqs */
  commonFaqs: Array<CommonFaq>;
  /** Retrieve multiple commonFaqs using the Relay connection interface */
  commonFaqsConnection: CommonFaqConnection;
  /** Retrieve a single commonPageHeroSection */
  commonPageHeroSection?: Maybe<CommonPageHeroSection>;
  /** Retrieve document version */
  commonPageHeroSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple commonPageHeroSections */
  commonPageHeroSections: Array<CommonPageHeroSection>;
  /** Retrieve multiple commonPageHeroSections using the Relay connection interface */
  commonPageHeroSectionsConnection: CommonPageHeroSectionConnection;
  /** Retrieve a single commonSection */
  commonSection?: Maybe<CommonSection>;
  /** Retrieve document version */
  commonSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple commonSections */
  commonSections: Array<CommonSection>;
  /** Retrieve multiple commonSections using the Relay connection interface */
  commonSectionsConnection: CommonSectionConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single faqSet */
  faqSet?: Maybe<FaqSet>;
  /** Retrieve a single faqSetItem */
  faqSetItem?: Maybe<FaqSetItem>;
  /** Retrieve document version */
  faqSetItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple faqSetItems */
  faqSetItems: Array<FaqSetItem>;
  /** Retrieve multiple faqSetItems using the Relay connection interface */
  faqSetItemsConnection: FaqSetItemConnection;
  /** Retrieve document version */
  faqSetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple faqSets */
  faqSets: Array<FaqSet>;
  /** Retrieve multiple faqSets using the Relay connection interface */
  faqSetsConnection: FaqSetConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single siteSetting */
  siteSetting?: Maybe<SiteSetting>;
  /** Retrieve document version */
  siteSettingVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple siteSettings */
  siteSettings: Array<SiteSetting>;
  /** Retrieve multiple siteSettings using the Relay connection interface */
  siteSettingsConnection: SiteSettingConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryCommonEulaKeyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CommonEulaKeyWhereUniqueInput;
};


export type QueryCommonEulaKeyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCommonEulaKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonEulaKeyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonEulaKeyWhereInput>;
};


export type QueryCommonEulaKeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonEulaKeyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonEulaKeyWhereInput>;
};


export type QueryCommonFaqArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CommonFaqWhereUniqueInput;
};


export type QueryCommonFaqVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCommonFaqsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonFaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonFaqWhereInput>;
};


export type QueryCommonFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonFaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonFaqWhereInput>;
};


export type QueryCommonPageHeroSectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CommonPageHeroSectionWhereUniqueInput;
};


export type QueryCommonPageHeroSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCommonPageHeroSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonPageHeroSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonPageHeroSectionWhereInput>;
};


export type QueryCommonPageHeroSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonPageHeroSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonPageHeroSectionWhereInput>;
};


export type QueryCommonSectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CommonSectionWhereUniqueInput;
};


export type QueryCommonSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCommonSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonSectionWhereInput>;
};


export type QueryCommonSectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CommonSectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CommonSectionWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryFaqSetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqSetWhereUniqueInput;
};


export type QueryFaqSetItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqSetItemWhereUniqueInput;
};


export type QueryFaqSetItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFaqSetItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqSetItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqSetItemWhereInput>;
};


export type QueryFaqSetItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqSetItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqSetItemWhereInput>;
};


export type QueryFaqSetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFaqSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqSetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqSetWhereInput>;
};


export type QueryFaqSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqSetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FaqSetWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QuerySiteSettingArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SiteSettingWhereUniqueInput;
};


export type QuerySiteSettingVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySiteSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SiteSettingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SiteSettingWhereInput>;
};


export type QuerySiteSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SiteSettingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SiteSettingWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Asset | CommonEulaKey | CommonFaq | CommonPageHeroSection | CommonSection | FaqSet | FaqSetItem | SiteSetting;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SectionContent = Entity & {
  __typename?: 'SectionContent';
  components: Array<SectionContentcomponentsUnion>;
  config?: Maybe<ConfigContent>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SectionContent>;
  masthead?: Maybe<ContentBlock>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SectionContentComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SectionContentConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type SectionContentMastheadArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type SectionContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SectionContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SectionContentConnection = {
  __typename?: 'SectionContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SectionContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SectionContentCreateInput = {
  components?: InputMaybe<SectionContentcomponentsUnionCreateManyInlineInput>;
  config?: InputMaybe<ConfigContentCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionContentCreateLocalizationsInput>;
  masthead?: InputMaybe<ContentBlockCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionContentCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionContentCreateLocalizationInput = {
  /** Localization input */
  data: SectionContentCreateLocalizationDataInput;
  locale: Locale;
};

export type SectionContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionContentCreateLocalizationInput>>;
};

export type SectionContentCreateManyInlineInput = {
  /** Create and connect multiple existing SectionContent documents */
  create?: InputMaybe<Array<SectionContentCreateInput>>;
};

export type SectionContentCreateOneInlineInput = {
  /** Create and connect one SectionContent document */
  create?: InputMaybe<SectionContentCreateInput>;
};

export type SectionContentCreateWithPositionInput = {
  /** Document to create */
  data: SectionContentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SectionContentEdge = {
  __typename?: 'SectionContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SectionContent;
};

/** Identifies documents */
export type SectionContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  components_some?: InputMaybe<SectionContentcomponentsUnionWhereInput>;
  config?: InputMaybe<ConfigContentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  masthead?: InputMaybe<ContentBlockWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum SectionContentOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SectionContentParent = CommonSection;

export type SectionContentParentConnectInput = {
  CommonSection?: InputMaybe<CommonSectionConnectInput>;
};

export type SectionContentParentCreateInput = {
  CommonSection?: InputMaybe<CommonSectionCreateInput>;
};

export type SectionContentParentCreateManyInlineInput = {
  /** Connect multiple existing SectionContentParent documents */
  connect?: InputMaybe<Array<SectionContentParentWhereUniqueInput>>;
  /** Create and connect multiple existing SectionContentParent documents */
  create?: InputMaybe<Array<SectionContentParentCreateInput>>;
};

export type SectionContentParentCreateOneInlineInput = {
  /** Connect one existing SectionContentParent document */
  connect?: InputMaybe<SectionContentParentWhereUniqueInput>;
  /** Create and connect one SectionContentParent document */
  create?: InputMaybe<SectionContentParentCreateInput>;
};

export type SectionContentParentUpdateInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateInput>;
};

export type SectionContentParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionContentParent documents */
  connect?: InputMaybe<Array<SectionContentParentConnectInput>>;
  /** Create and connect multiple SectionContentParent documents */
  create?: InputMaybe<Array<SectionContentParentCreateInput>>;
  /** Delete multiple SectionContentParent documents */
  delete?: InputMaybe<Array<SectionContentParentWhereUniqueInput>>;
  /** Disconnect multiple SectionContentParent documents */
  disconnect?: InputMaybe<Array<SectionContentParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SectionContentParent documents */
  set?: InputMaybe<Array<SectionContentParentWhereUniqueInput>>;
  /** Update multiple SectionContentParent documents */
  update?: InputMaybe<Array<SectionContentParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SectionContentParent documents */
  upsert?: InputMaybe<Array<SectionContentParentUpsertWithNestedWhereUniqueInput>>;
};

export type SectionContentParentUpdateManyWithNestedWhereInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateManyWithNestedWhereInput>;
};

export type SectionContentParentUpdateOneInlineInput = {
  /** Connect existing SectionContentParent document */
  connect?: InputMaybe<SectionContentParentWhereUniqueInput>;
  /** Create and connect one SectionContentParent document */
  create?: InputMaybe<SectionContentParentCreateInput>;
  /** Delete currently connected SectionContentParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SectionContentParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionContentParent document */
  update?: InputMaybe<SectionContentParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionContentParent document */
  upsert?: InputMaybe<SectionContentParentUpsertWithNestedWhereUniqueInput>;
};

export type SectionContentParentUpdateWithNestedWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateWithNestedWhereUniqueInput>;
};

export type SectionContentParentUpsertWithNestedWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionUpsertWithNestedWhereUniqueInput>;
};

export type SectionContentParentWhereInput = {
  CommonSection?: InputMaybe<CommonSectionWhereInput>;
};

export type SectionContentParentWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionWhereUniqueInput>;
};

export type SectionContentUpdateInput = {
  components?: InputMaybe<SectionContentcomponentsUnionUpdateManyInlineInput>;
  config?: InputMaybe<ConfigContentUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<SectionContentUpdateLocalizationsInput>;
  masthead?: InputMaybe<ContentBlockUpdateOneInlineInput>;
};

export type SectionContentUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SectionContentUpdateLocalizationInput = {
  data: SectionContentUpdateLocalizationDataInput;
  locale: Locale;
};

export type SectionContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionContentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SectionContentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SectionContentUpsertLocalizationInput>>;
};

export type SectionContentUpdateManyInlineInput = {
  /** Create and connect multiple SectionContent component instances */
  create?: InputMaybe<Array<SectionContentCreateWithPositionInput>>;
  /** Delete multiple SectionContent documents */
  delete?: InputMaybe<Array<SectionContentWhereUniqueInput>>;
  /** Update multiple SectionContent component instances */
  update?: InputMaybe<Array<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SectionContent component instances */
  upsert?: InputMaybe<Array<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SectionContentUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionContentUpdateManyLocalizationsInput>;
};

export type SectionContentUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SectionContentUpdateManyLocalizationInput = {
  data: SectionContentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SectionContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionContentUpdateManyLocalizationInput>>;
};

export type SectionContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionContentUpdateManyInput;
  /** Document search */
  where: SectionContentWhereInput;
};

export type SectionContentUpdateOneInlineInput = {
  /** Create and connect one SectionContent document */
  create?: InputMaybe<SectionContentCreateInput>;
  /** Delete currently connected SectionContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionContent document */
  update?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionContent document */
  upsert?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type SectionContentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionContentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SectionContentWhereUniqueInput;
};

export type SectionContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionContentUpdateInput;
  /** Unique document search */
  where: SectionContentWhereUniqueInput;
};

export type SectionContentUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionContentCreateInput;
  /** Update document if it exists */
  update: SectionContentUpdateInput;
};

export type SectionContentUpsertLocalizationInput = {
  create: SectionContentCreateLocalizationDataInput;
  locale: Locale;
  update: SectionContentUpdateLocalizationDataInput;
};

export type SectionContentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionContentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SectionContentWhereUniqueInput;
};

export type SectionContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionContentUpsertInput;
  /** Unique document search */
  where: SectionContentWhereUniqueInput;
};

/** Identifies documents */
export type SectionContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty. */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the modular component contains at least one connection to the item provided to the filter */
  components_some?: InputMaybe<SectionContentcomponentsUnionWhereInput>;
  config?: InputMaybe<ConfigContentWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  masthead?: InputMaybe<ContentBlockWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References SectionContent record uniquely */
export type SectionContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SectionContentcomponentsUnion = Alert | Button | CardLink | CardLinks | CatalogOfferCards | ConfigCatalogOffer | ImageTag | Link | ProductDisclaimer | SectionSideBySide | Text | Tooltip | Video;

export type SectionContentcomponentsUnionConnectInput = {
  Alert?: InputMaybe<AlertConnectInput>;
  Button?: InputMaybe<ButtonConnectInput>;
  CardLink?: InputMaybe<CardLinkConnectInput>;
  CardLinks?: InputMaybe<CardLinksConnectInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsConnectInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferConnectInput>;
  ImageTag?: InputMaybe<ImageTagConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerConnectInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideConnectInput>;
  Text?: InputMaybe<TextConnectInput>;
  Tooltip?: InputMaybe<TooltipConnectInput>;
  Video?: InputMaybe<VideoConnectInput>;
};

export type SectionContentcomponentsUnionCreateInput = {
  Alert?: InputMaybe<AlertCreateInput>;
  Button?: InputMaybe<ButtonCreateInput>;
  CardLink?: InputMaybe<CardLinkCreateInput>;
  CardLinks?: InputMaybe<CardLinksCreateInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsCreateInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferCreateInput>;
  ImageTag?: InputMaybe<ImageTagCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerCreateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateInput>;
  Text?: InputMaybe<TextCreateInput>;
  Tooltip?: InputMaybe<TooltipCreateInput>;
  Video?: InputMaybe<VideoCreateInput>;
};

export type SectionContentcomponentsUnionCreateManyInlineInput = {
  /** Create and connect multiple existing SectionContentcomponentsUnion documents */
  create?: InputMaybe<Array<SectionContentcomponentsUnionCreateInput>>;
};

export type SectionContentcomponentsUnionCreateOneInlineInput = {
  /** Create and connect one SectionContentcomponentsUnion document */
  create?: InputMaybe<SectionContentcomponentsUnionCreateInput>;
};

export type SectionContentcomponentsUnionCreateWithPositionInput = {
  Alert?: InputMaybe<AlertCreateWithPositionInput>;
  Button?: InputMaybe<ButtonCreateWithPositionInput>;
  CardLink?: InputMaybe<CardLinkCreateWithPositionInput>;
  CardLinks?: InputMaybe<CardLinksCreateWithPositionInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsCreateWithPositionInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferCreateWithPositionInput>;
  ImageTag?: InputMaybe<ImageTagCreateWithPositionInput>;
  Link?: InputMaybe<LinkCreateWithPositionInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerCreateWithPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideCreateWithPositionInput>;
  Text?: InputMaybe<TextCreateWithPositionInput>;
  Tooltip?: InputMaybe<TooltipCreateWithPositionInput>;
  Video?: InputMaybe<VideoCreateWithPositionInput>;
};

export type SectionContentcomponentsUnionUpdateInput = {
  Alert?: InputMaybe<AlertUpdateInput>;
  Button?: InputMaybe<ButtonUpdateInput>;
  CardLink?: InputMaybe<CardLinkUpdateInput>;
  CardLinks?: InputMaybe<CardLinksUpdateInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferUpdateInput>;
  ImageTag?: InputMaybe<ImageTagUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateInput>;
  Text?: InputMaybe<TextUpdateInput>;
  Tooltip?: InputMaybe<TooltipUpdateInput>;
  Video?: InputMaybe<VideoUpdateInput>;
};

export type SectionContentcomponentsUnionUpdateManyInlineInput = {
  /** Create and connect multiple SectionContentcomponentsUnion component instances */
  create?: InputMaybe<Array<SectionContentcomponentsUnionCreateWithPositionInput>>;
  /** Delete multiple SectionContentcomponentsUnion documents */
  delete?: InputMaybe<Array<SectionContentcomponentsUnionWhereUniqueInput>>;
  /** Update multiple SectionContentcomponentsUnion component instances */
  update?: InputMaybe<Array<SectionContentcomponentsUnionUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SectionContentcomponentsUnion component instances */
  upsert?: InputMaybe<Array<SectionContentcomponentsUnionUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SectionContentcomponentsUnionUpdateManyWithNestedWhereInput = {
  Alert?: InputMaybe<AlertUpdateManyWithNestedWhereInput>;
  Button?: InputMaybe<ButtonUpdateManyWithNestedWhereInput>;
  CardLink?: InputMaybe<CardLinkUpdateManyWithNestedWhereInput>;
  CardLinks?: InputMaybe<CardLinksUpdateManyWithNestedWhereInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateManyWithNestedWhereInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferUpdateManyWithNestedWhereInput>;
  ImageTag?: InputMaybe<ImageTagUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateManyWithNestedWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateManyWithNestedWhereInput>;
  Text?: InputMaybe<TextUpdateManyWithNestedWhereInput>;
  Tooltip?: InputMaybe<TooltipUpdateManyWithNestedWhereInput>;
  Video?: InputMaybe<VideoUpdateManyWithNestedWhereInput>;
};

export type SectionContentcomponentsUnionUpdateOneInlineInput = {
  /** Create and connect one SectionContentcomponentsUnion document */
  create?: InputMaybe<SectionContentcomponentsUnionCreateInput>;
  /** Delete currently connected SectionContentcomponentsUnion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionContentcomponentsUnion document */
  update?: InputMaybe<SectionContentcomponentsUnionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionContentcomponentsUnion document */
  upsert?: InputMaybe<SectionContentcomponentsUnionUpsertWithNestedWhereUniqueInput>;
};

export type SectionContentcomponentsUnionUpdateWithNestedWhereUniqueAndPositionInput = {
  Alert?: InputMaybe<AlertUpdateWithNestedWhereUniqueAndPositionInput>;
  Button?: InputMaybe<ButtonUpdateWithNestedWhereUniqueAndPositionInput>;
  CardLink?: InputMaybe<CardLinkUpdateWithNestedWhereUniqueAndPositionInput>;
  CardLinks?: InputMaybe<CardLinksUpdateWithNestedWhereUniqueAndPositionInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateWithNestedWhereUniqueAndPositionInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferUpdateWithNestedWhereUniqueAndPositionInput>;
  ImageTag?: InputMaybe<ImageTagUpdateWithNestedWhereUniqueAndPositionInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueAndPositionInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueAndPositionInput>;
  Tooltip?: InputMaybe<TooltipUpdateWithNestedWhereUniqueAndPositionInput>;
  Video?: InputMaybe<VideoUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type SectionContentcomponentsUnionUpdateWithNestedWhereUniqueInput = {
  Alert?: InputMaybe<AlertUpdateWithNestedWhereUniqueInput>;
  Button?: InputMaybe<ButtonUpdateWithNestedWhereUniqueInput>;
  CardLink?: InputMaybe<CardLinkUpdateWithNestedWhereUniqueInput>;
  CardLinks?: InputMaybe<CardLinksUpdateWithNestedWhereUniqueInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpdateWithNestedWhereUniqueInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferUpdateWithNestedWhereUniqueInput>;
  ImageTag?: InputMaybe<ImageTagUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpdateWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
  Tooltip?: InputMaybe<TooltipUpdateWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
};

export type SectionContentcomponentsUnionUpsertWithNestedWhereUniqueAndPositionInput = {
  Alert?: InputMaybe<AlertUpsertWithNestedWhereUniqueAndPositionInput>;
  Button?: InputMaybe<ButtonUpsertWithNestedWhereUniqueAndPositionInput>;
  CardLink?: InputMaybe<CardLinkUpsertWithNestedWhereUniqueAndPositionInput>;
  CardLinks?: InputMaybe<CardLinksUpsertWithNestedWhereUniqueAndPositionInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpsertWithNestedWhereUniqueAndPositionInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferUpsertWithNestedWhereUniqueAndPositionInput>;
  ImageTag?: InputMaybe<ImageTagUpsertWithNestedWhereUniqueAndPositionInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueAndPositionInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueAndPositionInput>;
  Tooltip?: InputMaybe<TooltipUpsertWithNestedWhereUniqueAndPositionInput>;
  Video?: InputMaybe<VideoUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type SectionContentcomponentsUnionUpsertWithNestedWhereUniqueInput = {
  Alert?: InputMaybe<AlertUpsertWithNestedWhereUniqueInput>;
  Button?: InputMaybe<ButtonUpsertWithNestedWhereUniqueInput>;
  CardLink?: InputMaybe<CardLinkUpsertWithNestedWhereUniqueInput>;
  CardLinks?: InputMaybe<CardLinksUpsertWithNestedWhereUniqueInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsUpsertWithNestedWhereUniqueInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferUpsertWithNestedWhereUniqueInput>;
  ImageTag?: InputMaybe<ImageTagUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerUpsertWithNestedWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueInput>;
  Text?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
  Tooltip?: InputMaybe<TooltipUpsertWithNestedWhereUniqueInput>;
  Video?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type SectionContentcomponentsUnionWhereInput = {
  Alert?: InputMaybe<AlertWhereInput>;
  Button?: InputMaybe<ButtonWhereInput>;
  CardLink?: InputMaybe<CardLinkWhereInput>;
  CardLinks?: InputMaybe<CardLinksWhereInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsWhereInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferWhereInput>;
  ImageTag?: InputMaybe<ImageTagWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerWhereInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereInput>;
  Text?: InputMaybe<TextWhereInput>;
  Tooltip?: InputMaybe<TooltipWhereInput>;
  Video?: InputMaybe<VideoWhereInput>;
};

export type SectionContentcomponentsUnionWhereUniqueInput = {
  Alert?: InputMaybe<AlertWhereUniqueInput>;
  Button?: InputMaybe<ButtonWhereUniqueInput>;
  CardLink?: InputMaybe<CardLinkWhereUniqueInput>;
  CardLinks?: InputMaybe<CardLinksWhereUniqueInput>;
  CatalogOfferCards?: InputMaybe<CatalogOfferCardsWhereUniqueInput>;
  ConfigCatalogOffer?: InputMaybe<ConfigCatalogOfferWhereUniqueInput>;
  ImageTag?: InputMaybe<ImageTagWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  ProductDisclaimer?: InputMaybe<ProductDisclaimerWhereUniqueInput>;
  SectionSideBySide?: InputMaybe<SectionSideBySideWhereUniqueInput>;
  Text?: InputMaybe<TextWhereUniqueInput>;
  Tooltip?: InputMaybe<TooltipWhereUniqueInput>;
  Video?: InputMaybe<VideoWhereUniqueInput>;
};

export type SectionFaq = Entity & {
  __typename?: 'SectionFaq';
  asset?: Maybe<FaqAsset>;
  config?: Maybe<ConfigContent>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<CommonFaq>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SectionFaq>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SectionFaqAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionFaqConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionFaqFaqArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionFaqLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type SectionFaqUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type SectionFaqConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SectionFaqWhereUniqueInput;
};

/** A connection to a list of items. */
export type SectionFaqConnection = {
  __typename?: 'SectionFaqConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SectionFaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SectionFaqCreateInput = {
  asset?: InputMaybe<FaqAssetCreateOneInlineInput>;
  config?: InputMaybe<ConfigContentCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<CommonFaqCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionFaqCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionFaqCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionFaqCreateLocalizationInput = {
  /** Localization input */
  data: SectionFaqCreateLocalizationDataInput;
  locale: Locale;
};

export type SectionFaqCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionFaqCreateLocalizationInput>>;
};

export type SectionFaqCreateManyInlineInput = {
  /** Create and connect multiple existing SectionFaq documents */
  create?: InputMaybe<Array<SectionFaqCreateInput>>;
};

export type SectionFaqCreateOneInlineInput = {
  /** Create and connect one SectionFaq document */
  create?: InputMaybe<SectionFaqCreateInput>;
};

export type SectionFaqCreateWithPositionInput = {
  /** Document to create */
  data: SectionFaqCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SectionFaqEdge = {
  __typename?: 'SectionFaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SectionFaq;
};

/** Identifies documents */
export type SectionFaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<FaqAssetWhereInput>;
  config?: InputMaybe<ConfigContentWhereInput>;
  faq?: InputMaybe<CommonFaqWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum SectionFaqOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SectionFaqParent = CommonSection;

export type SectionFaqParentConnectInput = {
  CommonSection?: InputMaybe<CommonSectionConnectInput>;
};

export type SectionFaqParentCreateInput = {
  CommonSection?: InputMaybe<CommonSectionCreateInput>;
};

export type SectionFaqParentCreateManyInlineInput = {
  /** Connect multiple existing SectionFaqParent documents */
  connect?: InputMaybe<Array<SectionFaqParentWhereUniqueInput>>;
  /** Create and connect multiple existing SectionFaqParent documents */
  create?: InputMaybe<Array<SectionFaqParentCreateInput>>;
};

export type SectionFaqParentCreateOneInlineInput = {
  /** Connect one existing SectionFaqParent document */
  connect?: InputMaybe<SectionFaqParentWhereUniqueInput>;
  /** Create and connect one SectionFaqParent document */
  create?: InputMaybe<SectionFaqParentCreateInput>;
};

export type SectionFaqParentUpdateInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateInput>;
};

export type SectionFaqParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionFaqParent documents */
  connect?: InputMaybe<Array<SectionFaqParentConnectInput>>;
  /** Create and connect multiple SectionFaqParent documents */
  create?: InputMaybe<Array<SectionFaqParentCreateInput>>;
  /** Delete multiple SectionFaqParent documents */
  delete?: InputMaybe<Array<SectionFaqParentWhereUniqueInput>>;
  /** Disconnect multiple SectionFaqParent documents */
  disconnect?: InputMaybe<Array<SectionFaqParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SectionFaqParent documents */
  set?: InputMaybe<Array<SectionFaqParentWhereUniqueInput>>;
  /** Update multiple SectionFaqParent documents */
  update?: InputMaybe<Array<SectionFaqParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SectionFaqParent documents */
  upsert?: InputMaybe<Array<SectionFaqParentUpsertWithNestedWhereUniqueInput>>;
};

export type SectionFaqParentUpdateManyWithNestedWhereInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateManyWithNestedWhereInput>;
};

export type SectionFaqParentUpdateOneInlineInput = {
  /** Connect existing SectionFaqParent document */
  connect?: InputMaybe<SectionFaqParentWhereUniqueInput>;
  /** Create and connect one SectionFaqParent document */
  create?: InputMaybe<SectionFaqParentCreateInput>;
  /** Delete currently connected SectionFaqParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SectionFaqParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionFaqParent document */
  update?: InputMaybe<SectionFaqParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionFaqParent document */
  upsert?: InputMaybe<SectionFaqParentUpsertWithNestedWhereUniqueInput>;
};

export type SectionFaqParentUpdateWithNestedWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateWithNestedWhereUniqueInput>;
};

export type SectionFaqParentUpsertWithNestedWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionUpsertWithNestedWhereUniqueInput>;
};

export type SectionFaqParentWhereInput = {
  CommonSection?: InputMaybe<CommonSectionWhereInput>;
};

export type SectionFaqParentWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionWhereUniqueInput>;
};

export type SectionFaqUpdateInput = {
  asset?: InputMaybe<FaqAssetUpdateOneInlineInput>;
  config?: InputMaybe<ConfigContentUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<CommonFaqUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<SectionFaqUpdateLocalizationsInput>;
};

export type SectionFaqUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SectionFaqUpdateLocalizationInput = {
  data: SectionFaqUpdateLocalizationDataInput;
  locale: Locale;
};

export type SectionFaqUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionFaqCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFaqUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SectionFaqUpsertLocalizationInput>>;
};

export type SectionFaqUpdateManyInlineInput = {
  /** Create and connect multiple SectionFaq component instances */
  create?: InputMaybe<Array<SectionFaqCreateWithPositionInput>>;
  /** Delete multiple SectionFaq documents */
  delete?: InputMaybe<Array<SectionFaqWhereUniqueInput>>;
  /** Update multiple SectionFaq component instances */
  update?: InputMaybe<Array<SectionFaqUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SectionFaq component instances */
  upsert?: InputMaybe<Array<SectionFaqUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SectionFaqUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionFaqUpdateManyLocalizationsInput>;
};

export type SectionFaqUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SectionFaqUpdateManyLocalizationInput = {
  data: SectionFaqUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SectionFaqUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionFaqUpdateManyLocalizationInput>>;
};

export type SectionFaqUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionFaqUpdateManyInput;
  /** Document search */
  where: SectionFaqWhereInput;
};

export type SectionFaqUpdateOneInlineInput = {
  /** Create and connect one SectionFaq document */
  create?: InputMaybe<SectionFaqCreateInput>;
  /** Delete currently connected SectionFaq document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionFaq document */
  update?: InputMaybe<SectionFaqUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionFaq document */
  upsert?: InputMaybe<SectionFaqUpsertWithNestedWhereUniqueInput>;
};

export type SectionFaqUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionFaqUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SectionFaqWhereUniqueInput;
};

export type SectionFaqUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionFaqUpdateInput;
  /** Unique document search */
  where: SectionFaqWhereUniqueInput;
};

export type SectionFaqUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionFaqCreateInput;
  /** Update document if it exists */
  update: SectionFaqUpdateInput;
};

export type SectionFaqUpsertLocalizationInput = {
  create: SectionFaqCreateLocalizationDataInput;
  locale: Locale;
  update: SectionFaqUpdateLocalizationDataInput;
};

export type SectionFaqUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionFaqUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SectionFaqWhereUniqueInput;
};

export type SectionFaqUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionFaqUpsertInput;
  /** Unique document search */
  where: SectionFaqWhereUniqueInput;
};

/** Identifies documents */
export type SectionFaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionFaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionFaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionFaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<FaqAssetWhereInput>;
  config?: InputMaybe<ConfigContentWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  faq?: InputMaybe<CommonFaqWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References SectionFaq record uniquely */
export type SectionFaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SectionSideBySide = Entity & {
  __typename?: 'SectionSideBySide';
  config?: Maybe<ConfigContent>;
  content?: Maybe<ContentBlock>;
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** Determines which form type to use in side by side section. */
  formVariant: FormVariant;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<ImageTag>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SectionSideBySide>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type SectionSideBySideConfigArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionSideBySideContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionSideBySideImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SectionSideBySideLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type SectionSideBySideUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type SectionSideBySideConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SectionSideBySideWhereUniqueInput;
};

/** A connection to a list of items. */
export type SectionSideBySideConnection = {
  __typename?: 'SectionSideBySideConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SectionSideBySideEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SectionSideBySideCreateInput = {
  config?: InputMaybe<ConfigContentCreateOneInlineInput>;
  content?: InputMaybe<ContentBlockCreateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  formVariant: FormVariant;
  image?: InputMaybe<ImageTagCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SectionSideBySideCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionSideBySideCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SectionSideBySideCreateLocalizationInput = {
  /** Localization input */
  data: SectionSideBySideCreateLocalizationDataInput;
  locale: Locale;
};

export type SectionSideBySideCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SectionSideBySideCreateLocalizationInput>>;
};

export type SectionSideBySideCreateManyInlineInput = {
  /** Create and connect multiple existing SectionSideBySide documents */
  create?: InputMaybe<Array<SectionSideBySideCreateInput>>;
};

export type SectionSideBySideCreateOneInlineInput = {
  /** Create and connect one SectionSideBySide document */
  create?: InputMaybe<SectionSideBySideCreateInput>;
};

export type SectionSideBySideCreateWithPositionInput = {
  /** Document to create */
  data: SectionSideBySideCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type SectionSideBySideEdge = {
  __typename?: 'SectionSideBySideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SectionSideBySide;
};

/** Identifies documents */
export type SectionSideBySideManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionSideBySideWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionSideBySideWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionSideBySideWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<ConfigContentWhereInput>;
  content?: InputMaybe<ContentBlockWhereInput>;
  formVariant?: InputMaybe<FormVariant>;
  /** All values that are contained in given list. */
  formVariant_in?: InputMaybe<Array<InputMaybe<FormVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  formVariant_not?: InputMaybe<FormVariant>;
  /** All values that are not contained in given list. */
  formVariant_not_in?: InputMaybe<Array<InputMaybe<FormVariant>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<ImageTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum SectionSideBySideOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  FormVariantAsc = 'formVariant_ASC',
  FormVariantDesc = 'formVariant_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SectionSideBySideParent = CommonSection | SectionContent;

export type SectionSideBySideParentConnectInput = {
  CommonSection?: InputMaybe<CommonSectionConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type SectionSideBySideParentCreateInput = {
  CommonSection?: InputMaybe<CommonSectionCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type SectionSideBySideParentCreateManyInlineInput = {
  /** Connect multiple existing SectionSideBySideParent documents */
  connect?: InputMaybe<Array<SectionSideBySideParentWhereUniqueInput>>;
  /** Create and connect multiple existing SectionSideBySideParent documents */
  create?: InputMaybe<Array<SectionSideBySideParentCreateInput>>;
};

export type SectionSideBySideParentCreateOneInlineInput = {
  /** Connect one existing SectionSideBySideParent document */
  connect?: InputMaybe<SectionSideBySideParentWhereUniqueInput>;
  /** Create and connect one SectionSideBySideParent document */
  create?: InputMaybe<SectionSideBySideParentCreateInput>;
};

export type SectionSideBySideParentUpdateInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type SectionSideBySideParentUpdateManyInlineInput = {
  /** Connect multiple existing SectionSideBySideParent documents */
  connect?: InputMaybe<Array<SectionSideBySideParentConnectInput>>;
  /** Create and connect multiple SectionSideBySideParent documents */
  create?: InputMaybe<Array<SectionSideBySideParentCreateInput>>;
  /** Delete multiple SectionSideBySideParent documents */
  delete?: InputMaybe<Array<SectionSideBySideParentWhereUniqueInput>>;
  /** Disconnect multiple SectionSideBySideParent documents */
  disconnect?: InputMaybe<Array<SectionSideBySideParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SectionSideBySideParent documents */
  set?: InputMaybe<Array<SectionSideBySideParentWhereUniqueInput>>;
  /** Update multiple SectionSideBySideParent documents */
  update?: InputMaybe<Array<SectionSideBySideParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SectionSideBySideParent documents */
  upsert?: InputMaybe<Array<SectionSideBySideParentUpsertWithNestedWhereUniqueInput>>;
};

export type SectionSideBySideParentUpdateManyWithNestedWhereInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type SectionSideBySideParentUpdateOneInlineInput = {
  /** Connect existing SectionSideBySideParent document */
  connect?: InputMaybe<SectionSideBySideParentWhereUniqueInput>;
  /** Create and connect one SectionSideBySideParent document */
  create?: InputMaybe<SectionSideBySideParentCreateInput>;
  /** Delete currently connected SectionSideBySideParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SectionSideBySideParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionSideBySideParent document */
  update?: InputMaybe<SectionSideBySideParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionSideBySideParent document */
  upsert?: InputMaybe<SectionSideBySideParentUpsertWithNestedWhereUniqueInput>;
};

export type SectionSideBySideParentUpdateWithNestedWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type SectionSideBySideParentUpsertWithNestedWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type SectionSideBySideParentWhereInput = {
  CommonSection?: InputMaybe<CommonSectionWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type SectionSideBySideParentWhereUniqueInput = {
  CommonSection?: InputMaybe<CommonSectionWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type SectionSideBySideUpdateInput = {
  config?: InputMaybe<ConfigContentUpdateOneInlineInput>;
  content?: InputMaybe<ContentBlockUpdateOneInlineInput>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  formVariant?: InputMaybe<FormVariant>;
  image?: InputMaybe<ImageTagUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<SectionSideBySideUpdateLocalizationsInput>;
};

export type SectionSideBySideUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SectionSideBySideUpdateLocalizationInput = {
  data: SectionSideBySideUpdateLocalizationDataInput;
  locale: Locale;
};

export type SectionSideBySideUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SectionSideBySideCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SectionSideBySideUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SectionSideBySideUpsertLocalizationInput>>;
};

export type SectionSideBySideUpdateManyInlineInput = {
  /** Create and connect multiple SectionSideBySide component instances */
  create?: InputMaybe<Array<SectionSideBySideCreateWithPositionInput>>;
  /** Delete multiple SectionSideBySide documents */
  delete?: InputMaybe<Array<SectionSideBySideWhereUniqueInput>>;
  /** Update multiple SectionSideBySide component instances */
  update?: InputMaybe<Array<SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple SectionSideBySide component instances */
  upsert?: InputMaybe<Array<SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type SectionSideBySideUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  formVariant?: InputMaybe<FormVariant>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SectionSideBySideUpdateManyLocalizationsInput>;
};

export type SectionSideBySideUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SectionSideBySideUpdateManyLocalizationInput = {
  data: SectionSideBySideUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SectionSideBySideUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SectionSideBySideUpdateManyLocalizationInput>>;
};

export type SectionSideBySideUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SectionSideBySideUpdateManyInput;
  /** Document search */
  where: SectionSideBySideWhereInput;
};

export type SectionSideBySideUpdateOneInlineInput = {
  /** Create and connect one SectionSideBySide document */
  create?: InputMaybe<SectionSideBySideCreateInput>;
  /** Delete currently connected SectionSideBySide document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SectionSideBySide document */
  update?: InputMaybe<SectionSideBySideUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SectionSideBySide document */
  upsert?: InputMaybe<SectionSideBySideUpsertWithNestedWhereUniqueInput>;
};

export type SectionSideBySideUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<SectionSideBySideUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SectionSideBySideWhereUniqueInput;
};

export type SectionSideBySideUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SectionSideBySideUpdateInput;
  /** Unique document search */
  where: SectionSideBySideWhereUniqueInput;
};

export type SectionSideBySideUpsertInput = {
  /** Create document if it didn't exist */
  create: SectionSideBySideCreateInput;
  /** Update document if it exists */
  update: SectionSideBySideUpdateInput;
};

export type SectionSideBySideUpsertLocalizationInput = {
  create: SectionSideBySideCreateLocalizationDataInput;
  locale: Locale;
  update: SectionSideBySideUpdateLocalizationDataInput;
};

export type SectionSideBySideUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<SectionSideBySideUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: SectionSideBySideWhereUniqueInput;
};

export type SectionSideBySideUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SectionSideBySideUpsertInput;
  /** Unique document search */
  where: SectionSideBySideWhereUniqueInput;
};

/** Identifies documents */
export type SectionSideBySideWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SectionSideBySideWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SectionSideBySideWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SectionSideBySideWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<ConfigContentWhereInput>;
  content?: InputMaybe<ContentBlockWhereInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  formVariant?: InputMaybe<FormVariant>;
  /** All values that are contained in given list. */
  formVariant_in?: InputMaybe<Array<InputMaybe<FormVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  formVariant_not?: InputMaybe<FormVariant>;
  /** All values that are not contained in given list. */
  formVariant_not_in?: InputMaybe<Array<InputMaybe<FormVariant>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<ImageTagWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References SectionSideBySide record uniquely */
export type SectionSideBySideWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Global site settings. */
export type SiteSetting = Entity & Node & {
  __typename?: 'SiteSetting';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SiteSetting>;
  /** This root level localizable field is required for Hygraph Connector to Smartling to work */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  /** Enables geo-fenced users the UI that surfaces our SVS cta and FAQ section on the redeem landing page */
  enableSVS?: Maybe<Scalars['Boolean']['output']>;
  /** List of SiteSetting versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  inDevelopment: InDevelopmentStatus;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SiteSetting>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** This should only be enabled in tandem with a site banner displaying maintenance copy to prevent unwanted error messages surfacing to the user during redeem flow. */
  redeemDisabled?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  siteBannerEnabled: Scalars['Boolean']['output'];
  /** Used for neutral banners only. */
  siteBannerIcon?: Maybe<EdsIcon>;
  siteBannerMessage?: Maybe<Text>;
  siteBannerStatus?: Maybe<EdsStatus>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Global site settings. */
export type SiteSettingCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Global site settings. */
export type SiteSettingCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global site settings. */
export type SiteSettingDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Global site settings. */
export type SiteSettingHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Global site settings. */
export type SiteSettingLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Global site settings. */
export type SiteSettingPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Global site settings. */
export type SiteSettingPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global site settings. */
export type SiteSettingScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Global site settings. */
export type SiteSettingSiteBannerMessageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Global site settings. */
export type SiteSettingUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Global site settings. */
export type SiteSettingUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SiteSettingConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SiteSettingWhereUniqueInput;
};

/** A connection to a list of items. */
export type SiteSettingConnection = {
  __typename?: 'SiteSettingConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SiteSettingEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SiteSettingCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  enableSVS?: InputMaybe<Scalars['Boolean']['input']>;
  inDevelopment: InDevelopmentStatus;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SiteSettingCreateLocalizationsInput>;
  redeemDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerEnabled: Scalars['Boolean']['input'];
  siteBannerIcon?: InputMaybe<EdsIcon>;
  siteBannerMessage?: InputMaybe<TextCreateOneInlineInput>;
  siteBannerStatus?: InputMaybe<EdsStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SiteSettingCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SiteSettingCreateLocalizationInput = {
  /** Localization input */
  data: SiteSettingCreateLocalizationDataInput;
  locale: Locale;
};

export type SiteSettingCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SiteSettingCreateLocalizationInput>>;
};

export type SiteSettingCreateManyInlineInput = {
  /** Connect multiple existing SiteSetting documents */
  connect?: InputMaybe<Array<SiteSettingWhereUniqueInput>>;
  /** Create and connect multiple existing SiteSetting documents */
  create?: InputMaybe<Array<SiteSettingCreateInput>>;
};

export type SiteSettingCreateOneInlineInput = {
  /** Connect one existing SiteSetting document */
  connect?: InputMaybe<SiteSettingWhereUniqueInput>;
  /** Create and connect one SiteSetting document */
  create?: InputMaybe<SiteSettingCreateInput>;
};

/** An edge in a connection. */
export type SiteSettingEdge = {
  __typename?: 'SiteSettingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SiteSetting;
};

/** Identifies documents */
export type SiteSettingManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SiteSettingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SiteSettingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SiteSettingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SiteSettingWhereStageInput>;
  documentInStages_none?: InputMaybe<SiteSettingWhereStageInput>;
  documentInStages_some?: InputMaybe<SiteSettingWhereStageInput>;
  enableSVS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableSVS_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  redeemDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  redeemDisabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  siteBannerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  siteBannerEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerIcon?: InputMaybe<EdsIcon>;
  /** All values that are contained in given list. */
  siteBannerIcon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteBannerIcon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  siteBannerIcon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  siteBannerMessage?: InputMaybe<TextWhereInput>;
  siteBannerStatus?: InputMaybe<EdsStatus>;
  /** All values that are contained in given list. */
  siteBannerStatus_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteBannerStatus_not?: InputMaybe<EdsStatus>;
  /** All values that are not contained in given list. */
  siteBannerStatus_not_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SiteSettingOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  EnableSvsAsc = 'enableSVS_ASC',
  EnableSvsDesc = 'enableSVS_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InDevelopmentAsc = 'inDevelopment_ASC',
  InDevelopmentDesc = 'inDevelopment_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  RedeemDisabledAsc = 'redeemDisabled_ASC',
  RedeemDisabledDesc = 'redeemDisabled_DESC',
  SiteBannerEnabledAsc = 'siteBannerEnabled_ASC',
  SiteBannerEnabledDesc = 'siteBannerEnabled_DESC',
  SiteBannerIconAsc = 'siteBannerIcon_ASC',
  SiteBannerIconDesc = 'siteBannerIcon_DESC',
  SiteBannerStatusAsc = 'siteBannerStatus_ASC',
  SiteBannerStatusDesc = 'siteBannerStatus_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SiteSettingUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  enableSVS?: InputMaybe<Scalars['Boolean']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<SiteSettingUpdateLocalizationsInput>;
  redeemDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerIcon?: InputMaybe<EdsIcon>;
  siteBannerMessage?: InputMaybe<TextUpdateOneInlineInput>;
  siteBannerStatus?: InputMaybe<EdsStatus>;
};

export type SiteSettingUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSettingUpdateLocalizationInput = {
  data: SiteSettingUpdateLocalizationDataInput;
  locale: Locale;
};

export type SiteSettingUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SiteSettingCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SiteSettingUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SiteSettingUpsertLocalizationInput>>;
};

export type SiteSettingUpdateManyInlineInput = {
  /** Connect multiple existing SiteSetting documents */
  connect?: InputMaybe<Array<SiteSettingConnectInput>>;
  /** Create and connect multiple SiteSetting documents */
  create?: InputMaybe<Array<SiteSettingCreateInput>>;
  /** Delete multiple SiteSetting documents */
  delete?: InputMaybe<Array<SiteSettingWhereUniqueInput>>;
  /** Disconnect multiple SiteSetting documents */
  disconnect?: InputMaybe<Array<SiteSettingWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SiteSetting documents */
  set?: InputMaybe<Array<SiteSettingWhereUniqueInput>>;
  /** Update multiple SiteSetting documents */
  update?: InputMaybe<Array<SiteSettingUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SiteSetting documents */
  upsert?: InputMaybe<Array<SiteSettingUpsertWithNestedWhereUniqueInput>>;
};

export type SiteSettingUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  enableSVS?: InputMaybe<Scalars['Boolean']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SiteSettingUpdateManyLocalizationsInput>;
  redeemDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerIcon?: InputMaybe<EdsIcon>;
  siteBannerStatus?: InputMaybe<EdsStatus>;
};

export type SiteSettingUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type SiteSettingUpdateManyLocalizationInput = {
  data: SiteSettingUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SiteSettingUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SiteSettingUpdateManyLocalizationInput>>;
};

export type SiteSettingUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SiteSettingUpdateManyInput;
  /** Document search */
  where: SiteSettingWhereInput;
};

export type SiteSettingUpdateOneInlineInput = {
  /** Connect existing SiteSetting document */
  connect?: InputMaybe<SiteSettingWhereUniqueInput>;
  /** Create and connect one SiteSetting document */
  create?: InputMaybe<SiteSettingCreateInput>;
  /** Delete currently connected SiteSetting document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SiteSetting document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SiteSetting document */
  update?: InputMaybe<SiteSettingUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SiteSetting document */
  upsert?: InputMaybe<SiteSettingUpsertWithNestedWhereUniqueInput>;
};

export type SiteSettingUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SiteSettingUpdateInput;
  /** Unique document search */
  where: SiteSettingWhereUniqueInput;
};

export type SiteSettingUpsertInput = {
  /** Create document if it didn't exist */
  create: SiteSettingCreateInput;
  /** Update document if it exists */
  update: SiteSettingUpdateInput;
};

export type SiteSettingUpsertLocalizationInput = {
  create: SiteSettingCreateLocalizationDataInput;
  locale: Locale;
  update: SiteSettingUpdateLocalizationDataInput;
};

export type SiteSettingUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SiteSettingUpsertInput;
  /** Unique document search */
  where: SiteSettingWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SiteSettingWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SiteSettingWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SiteSettingWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SiteSettingWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SiteSettingWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SiteSettingWhereStageInput>;
  documentInStages_none?: InputMaybe<SiteSettingWhereStageInput>;
  documentInStages_some?: InputMaybe<SiteSettingWhereStageInput>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  enableSVS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableSVS_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inDevelopment?: InputMaybe<InDevelopmentStatus>;
  /** All values that are contained in given list. */
  inDevelopment_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  inDevelopment_not?: InputMaybe<InDevelopmentStatus>;
  /** All values that are not contained in given list. */
  inDevelopment_not_in?: InputMaybe<Array<InputMaybe<InDevelopmentStatus>>>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  redeemDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  redeemDisabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  siteBannerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  siteBannerEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  siteBannerIcon?: InputMaybe<EdsIcon>;
  /** All values that are contained in given list. */
  siteBannerIcon_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteBannerIcon_not?: InputMaybe<EdsIcon>;
  /** All values that are not contained in given list. */
  siteBannerIcon_not_in?: InputMaybe<Array<InputMaybe<EdsIcon>>>;
  siteBannerMessage?: InputMaybe<TextWhereInput>;
  siteBannerStatus?: InputMaybe<EdsStatus>;
  /** All values that are contained in given list. */
  siteBannerStatus_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteBannerStatus_not?: InputMaybe<EdsStatus>;
  /** All values that are not contained in given list. */
  siteBannerStatus_not_in?: InputMaybe<Array<InputMaybe<EdsStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SiteSettingWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SiteSettingWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SiteSettingWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SiteSettingWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SiteSettingWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SiteSetting record uniquely */
export type SiteSettingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  Gamedev = 'GAMEDEV',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED'
}

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION'
}

export type Text = Entity & {
  __typename?: 'Text';
  color: EdsColor;
  html: Scalars['String']['output'];
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Text>;
  /** System stage field */
  stage: Stage;
  /** Used to map conditional attributes to component. */
  ukey: Scalars['String']['output'];
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variant: EdsTextVariant;
};


export type TextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type TextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type TextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TextWhereUniqueInput;
};

/** A connection to a list of items. */
export type TextConnection = {
  __typename?: 'TextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TextCreateInput = {
  color: EdsColor;
  /** html input for default locale (en) */
  html: Scalars['String']['input'];
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TextCreateLocalizationsInput>;
  ukey: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variant: EdsTextVariant;
};

export type TextCreateLocalizationDataInput = {
  html: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TextCreateLocalizationInput = {
  /** Localization input */
  data: TextCreateLocalizationDataInput;
  locale: Locale;
};

export type TextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TextCreateLocalizationInput>>;
};

export type TextCreateManyInlineInput = {
  /** Create and connect multiple existing Text documents */
  create?: InputMaybe<Array<TextCreateInput>>;
};

export type TextCreateOneInlineInput = {
  /** Create and connect one Text document */
  create?: InputMaybe<TextCreateInput>;
};

export type TextCreateWithPositionInput = {
  /** Document to create */
  data: TextCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TextEdge = {
  __typename?: 'TextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Text;
};

/** Identifies documents */
export type TextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<EdsColor>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<EdsColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<EdsColor>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<EdsColor>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<EdsTextVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<EdsTextVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<EdsTextVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<EdsTextVariant>>>;
};

export enum TextOrderByInput {
  ColorAsc = 'color_ASC',
  ColorDesc = 'color_DESC',
  HtmlAsc = 'html_ASC',
  HtmlDesc = 'html_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  UkeyAsc = 'ukey_ASC',
  UkeyDesc = 'ukey_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VariantAsc = 'variant_ASC',
  VariantDesc = 'variant_DESC'
}

export type TextParent = Alert | ContentBlock | FaqItem | FaqSetItem | SectionContent | SiteSetting | Tooltip;

export type TextParentConnectInput = {
  Alert?: InputMaybe<AlertConnectInput>;
  ContentBlock?: InputMaybe<ContentBlockConnectInput>;
  FaqItem?: InputMaybe<FaqItemConnectInput>;
  FaqSetItem?: InputMaybe<FaqSetItemConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
  SiteSetting?: InputMaybe<SiteSettingConnectInput>;
  Tooltip?: InputMaybe<TooltipConnectInput>;
};

export type TextParentCreateInput = {
  Alert?: InputMaybe<AlertCreateInput>;
  ContentBlock?: InputMaybe<ContentBlockCreateInput>;
  FaqItem?: InputMaybe<FaqItemCreateInput>;
  FaqSetItem?: InputMaybe<FaqSetItemCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
  SiteSetting?: InputMaybe<SiteSettingCreateInput>;
  Tooltip?: InputMaybe<TooltipCreateInput>;
};

export type TextParentCreateManyInlineInput = {
  /** Connect multiple existing TextParent documents */
  connect?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Create and connect multiple existing TextParent documents */
  create?: InputMaybe<Array<TextParentCreateInput>>;
};

export type TextParentCreateOneInlineInput = {
  /** Connect one existing TextParent document */
  connect?: InputMaybe<TextParentWhereUniqueInput>;
  /** Create and connect one TextParent document */
  create?: InputMaybe<TextParentCreateInput>;
};

export type TextParentUpdateInput = {
  Alert?: InputMaybe<AlertUpdateInput>;
  ContentBlock?: InputMaybe<ContentBlockUpdateInput>;
  FaqItem?: InputMaybe<FaqItemUpdateInput>;
  FaqSetItem?: InputMaybe<FaqSetItemUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
  SiteSetting?: InputMaybe<SiteSettingUpdateInput>;
  Tooltip?: InputMaybe<TooltipUpdateInput>;
};

export type TextParentUpdateManyInlineInput = {
  /** Connect multiple existing TextParent documents */
  connect?: InputMaybe<Array<TextParentConnectInput>>;
  /** Create and connect multiple TextParent documents */
  create?: InputMaybe<Array<TextParentCreateInput>>;
  /** Delete multiple TextParent documents */
  delete?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Disconnect multiple TextParent documents */
  disconnect?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TextParent documents */
  set?: InputMaybe<Array<TextParentWhereUniqueInput>>;
  /** Update multiple TextParent documents */
  update?: InputMaybe<Array<TextParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TextParent documents */
  upsert?: InputMaybe<Array<TextParentUpsertWithNestedWhereUniqueInput>>;
};

export type TextParentUpdateManyWithNestedWhereInput = {
  Alert?: InputMaybe<AlertUpdateManyWithNestedWhereInput>;
  ContentBlock?: InputMaybe<ContentBlockUpdateManyWithNestedWhereInput>;
  FaqItem?: InputMaybe<FaqItemUpdateManyWithNestedWhereInput>;
  FaqSetItem?: InputMaybe<FaqSetItemUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
  SiteSetting?: InputMaybe<SiteSettingUpdateManyWithNestedWhereInput>;
  Tooltip?: InputMaybe<TooltipUpdateManyWithNestedWhereInput>;
};

export type TextParentUpdateOneInlineInput = {
  /** Connect existing TextParent document */
  connect?: InputMaybe<TextParentWhereUniqueInput>;
  /** Create and connect one TextParent document */
  create?: InputMaybe<TextParentCreateInput>;
  /** Delete currently connected TextParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TextParent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TextParent document */
  update?: InputMaybe<TextParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TextParent document */
  upsert?: InputMaybe<TextParentUpsertWithNestedWhereUniqueInput>;
};

export type TextParentUpdateWithNestedWhereUniqueInput = {
  Alert?: InputMaybe<AlertUpdateWithNestedWhereUniqueInput>;
  ContentBlock?: InputMaybe<ContentBlockUpdateWithNestedWhereUniqueInput>;
  FaqItem?: InputMaybe<FaqItemUpdateWithNestedWhereUniqueInput>;
  FaqSetItem?: InputMaybe<FaqSetItemUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
  SiteSetting?: InputMaybe<SiteSettingUpdateWithNestedWhereUniqueInput>;
  Tooltip?: InputMaybe<TooltipUpdateWithNestedWhereUniqueInput>;
};

export type TextParentUpsertWithNestedWhereUniqueInput = {
  Alert?: InputMaybe<AlertUpsertWithNestedWhereUniqueInput>;
  ContentBlock?: InputMaybe<ContentBlockUpsertWithNestedWhereUniqueInput>;
  FaqItem?: InputMaybe<FaqItemUpsertWithNestedWhereUniqueInput>;
  FaqSetItem?: InputMaybe<FaqSetItemUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
  SiteSetting?: InputMaybe<SiteSettingUpsertWithNestedWhereUniqueInput>;
  Tooltip?: InputMaybe<TooltipUpsertWithNestedWhereUniqueInput>;
};

export type TextParentWhereInput = {
  Alert?: InputMaybe<AlertWhereInput>;
  ContentBlock?: InputMaybe<ContentBlockWhereInput>;
  FaqItem?: InputMaybe<FaqItemWhereInput>;
  FaqSetItem?: InputMaybe<FaqSetItemWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
  SiteSetting?: InputMaybe<SiteSettingWhereInput>;
  Tooltip?: InputMaybe<TooltipWhereInput>;
};

export type TextParentWhereUniqueInput = {
  Alert?: InputMaybe<AlertWhereUniqueInput>;
  ContentBlock?: InputMaybe<ContentBlockWhereUniqueInput>;
  FaqItem?: InputMaybe<FaqItemWhereUniqueInput>;
  FaqSetItem?: InputMaybe<FaqSetItemWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
  SiteSetting?: InputMaybe<SiteSettingWhereUniqueInput>;
  Tooltip?: InputMaybe<TooltipWhereUniqueInput>;
};

export type TextUpdateInput = {
  color?: InputMaybe<EdsColor>;
  /** html input for default locale (en) */
  html?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<TextUpdateLocalizationsInput>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<EdsTextVariant>;
};

export type TextUpdateLocalizationDataInput = {
  html?: InputMaybe<Scalars['String']['input']>;
};

export type TextUpdateLocalizationInput = {
  data: TextUpdateLocalizationDataInput;
  locale: Locale;
};

export type TextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TextUpsertLocalizationInput>>;
};

export type TextUpdateManyInlineInput = {
  /** Create and connect multiple Text component instances */
  create?: InputMaybe<Array<TextCreateWithPositionInput>>;
  /** Delete multiple Text documents */
  delete?: InputMaybe<Array<TextWhereUniqueInput>>;
  /** Update multiple Text component instances */
  update?: InputMaybe<Array<TextUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Text component instances */
  upsert?: InputMaybe<Array<TextUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TextUpdateManyInput = {
  color?: InputMaybe<EdsColor>;
  /** html input for default locale (en) */
  html?: InputMaybe<Scalars['String']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TextUpdateManyLocalizationsInput>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<EdsTextVariant>;
};

export type TextUpdateManyLocalizationDataInput = {
  html?: InputMaybe<Scalars['String']['input']>;
};

export type TextUpdateManyLocalizationInput = {
  data: TextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TextUpdateManyLocalizationInput>>;
};

export type TextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextUpdateManyInput;
  /** Document search */
  where: TextWhereInput;
};

export type TextUpdateOneInlineInput = {
  /** Create and connect one Text document */
  create?: InputMaybe<TextCreateInput>;
  /** Delete currently connected Text document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Text document */
  update?: InputMaybe<TextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Text document */
  upsert?: InputMaybe<TextUpsertWithNestedWhereUniqueInput>;
};

export type TextUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TextUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TextWhereUniqueInput;
};

export type TextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextUpdateInput;
  /** Unique document search */
  where: TextWhereUniqueInput;
};

export type TextUpsertInput = {
  /** Create document if it didn't exist */
  create: TextCreateInput;
  /** Update document if it exists */
  update: TextUpdateInput;
};

export type TextUpsertLocalizationInput = {
  create: TextCreateLocalizationDataInput;
  locale: Locale;
  update: TextUpdateLocalizationDataInput;
};

export type TextUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TextUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TextWhereUniqueInput;
};

export type TextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextUpsertInput;
  /** Unique document search */
  where: TextWhereUniqueInput;
};

/** Identifies documents */
export type TextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<EdsColor>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<EdsColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<EdsColor>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<EdsColor>>>;
  html?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  html_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  html_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  html_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  html_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  html_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  html_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  html_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  html_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  html_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  ukey?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ukey_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ukey_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ukey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ukey_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ukey_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ukey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ukey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ukey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ukey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  variant?: InputMaybe<EdsTextVariant>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<EdsTextVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<EdsTextVariant>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<EdsTextVariant>>>;
};

/** References Text record uniquely */
export type TextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Tooltip = Entity & {
  __typename?: 'Tooltip';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Add image below label */
  image?: Maybe<Asset>;
  /** Used to label this element in Hygraph UI lists. This field doesn't get rendered to the page. */
  internalDescription?: Maybe<Scalars['String']['output']>;
  label: Array<Text>;
  /** Defaults to "top" */
  side?: Maybe<EdsTooltipSide>;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TooltipImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type TooltipLabelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextWhereInput>;
};

export type TooltipConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TooltipWhereUniqueInput;
};

/** A connection to a list of items. */
export type TooltipConnection = {
  __typename?: 'TooltipConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TooltipEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TooltipCreateInput = {
  image?: InputMaybe<AssetCreateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<TextCreateManyInlineInput>;
  side?: InputMaybe<EdsTooltipSide>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TooltipCreateManyInlineInput = {
  /** Create and connect multiple existing Tooltip documents */
  create?: InputMaybe<Array<TooltipCreateInput>>;
};

export type TooltipCreateOneInlineInput = {
  /** Create and connect one Tooltip document */
  create?: InputMaybe<TooltipCreateInput>;
};

export type TooltipCreateWithPositionInput = {
  /** Document to create */
  data: TooltipCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type TooltipEdge = {
  __typename?: 'TooltipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Tooltip;
};

/** Identifies documents */
export type TooltipManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TooltipWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TooltipWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TooltipWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_every?: InputMaybe<TextWhereInput>;
  label_none?: InputMaybe<TextWhereInput>;
  label_some?: InputMaybe<TextWhereInput>;
  side?: InputMaybe<EdsTooltipSide>;
  /** All values that are contained in given list. */
  side_in?: InputMaybe<Array<InputMaybe<EdsTooltipSide>>>;
  /** Any other value that exists and is not equal to the given value. */
  side_not?: InputMaybe<EdsTooltipSide>;
  /** All values that are not contained in given list. */
  side_not_in?: InputMaybe<Array<InputMaybe<EdsTooltipSide>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum TooltipOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalDescriptionAsc = 'internalDescription_ASC',
  InternalDescriptionDesc = 'internalDescription_DESC',
  SideAsc = 'side_ASC',
  SideDesc = 'side_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type TooltipParent = SectionContent;

export type TooltipParentConnectInput = {
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type TooltipParentCreateInput = {
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type TooltipParentCreateManyInlineInput = {
  /** Create and connect multiple existing TooltipParent documents */
  create?: InputMaybe<Array<TooltipParentCreateInput>>;
};

export type TooltipParentCreateOneInlineInput = {
  /** Create and connect one TooltipParent document */
  create?: InputMaybe<TooltipParentCreateInput>;
};

export type TooltipParentCreateWithPositionInput = {
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type TooltipParentUpdateInput = {
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type TooltipParentUpdateManyInlineInput = {
  /** Create and connect multiple TooltipParent component instances */
  create?: InputMaybe<Array<TooltipParentCreateWithPositionInput>>;
  /** Delete multiple TooltipParent documents */
  delete?: InputMaybe<Array<TooltipParentWhereUniqueInput>>;
  /** Update multiple TooltipParent component instances */
  update?: InputMaybe<Array<TooltipParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple TooltipParent component instances */
  upsert?: InputMaybe<Array<TooltipParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TooltipParentUpdateManyWithNestedWhereInput = {
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type TooltipParentUpdateOneInlineInput = {
  /** Create and connect one TooltipParent document */
  create?: InputMaybe<TooltipParentCreateInput>;
  /** Delete currently connected TooltipParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TooltipParent document */
  update?: InputMaybe<TooltipParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TooltipParent document */
  upsert?: InputMaybe<TooltipParentUpsertWithNestedWhereUniqueInput>;
};

export type TooltipParentUpdateWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type TooltipParentUpdateWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type TooltipParentUpsertWithNestedWhereUniqueAndPositionInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type TooltipParentUpsertWithNestedWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type TooltipParentWhereInput = {
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type TooltipParentWhereUniqueInput = {
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type TooltipUpdateInput = {
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<TextUpdateManyInlineInput>;
  side?: InputMaybe<EdsTooltipSide>;
};

export type TooltipUpdateManyInlineInput = {
  /** Create and connect multiple Tooltip component instances */
  create?: InputMaybe<Array<TooltipCreateWithPositionInput>>;
  /** Delete multiple Tooltip documents */
  delete?: InputMaybe<Array<TooltipWhereUniqueInput>>;
  /** Update multiple Tooltip component instances */
  update?: InputMaybe<Array<TooltipUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Tooltip component instances */
  upsert?: InputMaybe<Array<TooltipUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type TooltipUpdateManyInput = {
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<EdsTooltipSide>;
};

export type TooltipUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TooltipUpdateManyInput;
  /** Document search */
  where: TooltipWhereInput;
};

export type TooltipUpdateOneInlineInput = {
  /** Create and connect one Tooltip document */
  create?: InputMaybe<TooltipCreateInput>;
  /** Delete currently connected Tooltip document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Tooltip document */
  update?: InputMaybe<TooltipUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Tooltip document */
  upsert?: InputMaybe<TooltipUpsertWithNestedWhereUniqueInput>;
};

export type TooltipUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<TooltipUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TooltipWhereUniqueInput;
};

export type TooltipUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TooltipUpdateInput;
  /** Unique document search */
  where: TooltipWhereUniqueInput;
};

export type TooltipUpsertInput = {
  /** Create document if it didn't exist */
  create: TooltipCreateInput;
  /** Update document if it exists */
  update: TooltipUpdateInput;
};

export type TooltipUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<TooltipUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: TooltipWhereUniqueInput;
};

export type TooltipUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TooltipUpsertInput;
  /** Unique document search */
  where: TooltipWhereUniqueInput;
};

/** Identifies documents */
export type TooltipWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TooltipWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TooltipWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TooltipWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  internalDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  internalDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  internalDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  internalDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  internalDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  internalDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  internalDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  internalDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  internalDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  internalDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_every?: InputMaybe<TextWhereInput>;
  label_none?: InputMaybe<TextWhereInput>;
  label_some?: InputMaybe<TextWhereInput>;
  side?: InputMaybe<EdsTooltipSide>;
  /** All values that are contained in given list. */
  side_in?: InputMaybe<Array<InputMaybe<EdsTooltipSide>>>;
  /** Any other value that exists and is not equal to the given value. */
  side_not?: InputMaybe<EdsTooltipSide>;
  /** All values that are not contained in given list. */
  side_not_in?: InputMaybe<Array<InputMaybe<EdsTooltipSide>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Tooltip record uniquely */
export type TooltipWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  AppToken = 'APP_TOKEN',
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

export type Video = Entity & {
  __typename?: 'Video';
  /** This root level localizable field is required for Hygraph Connector to Smartling to work :upside_down_face: */
  dummyLocalization?: Maybe<Scalars['String']['output']>;
  fallbackImage: Asset;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Video>;
  media: Asset;
  /** System stage field */
  stage: Stage;
  /** System updatedAt field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type VideoFallbackImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type VideoMediaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type VideoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};

export type VideoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: VideoWhereUniqueInput;
};

/** A connection to a list of items. */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<VideoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type VideoCreateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  fallbackImage: AssetCreateOneInlineInput;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<VideoCreateLocalizationsInput>;
  media: AssetCreateOneInlineInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VideoCreateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VideoCreateLocalizationInput = {
  /** Localization input */
  data: VideoCreateLocalizationDataInput;
  locale: Locale;
};

export type VideoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<VideoCreateLocalizationInput>>;
};

export type VideoCreateManyInlineInput = {
  /** Create and connect multiple existing Video documents */
  create?: InputMaybe<Array<VideoCreateInput>>;
};

export type VideoCreateOneInlineInput = {
  /** Create and connect one Video document */
  create?: InputMaybe<VideoCreateInput>;
};

export type VideoCreateWithPositionInput = {
  /** Document to create */
  data: VideoCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type VideoEdge = {
  __typename?: 'VideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Video;
};

/** Identifies documents */
export type VideoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  fallbackImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum VideoOrderByInput {
  DummyLocalizationAsc = 'dummyLocalization_ASC',
  DummyLocalizationDesc = 'dummyLocalization_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type VideoParent = FaqAsset | SectionContent;

export type VideoParentConnectInput = {
  FaqAsset?: InputMaybe<FaqAssetConnectInput>;
  SectionContent?: InputMaybe<SectionContentConnectInput>;
};

export type VideoParentCreateInput = {
  FaqAsset?: InputMaybe<FaqAssetCreateInput>;
  SectionContent?: InputMaybe<SectionContentCreateInput>;
};

export type VideoParentCreateManyInlineInput = {
  /** Create and connect multiple existing VideoParent documents */
  create?: InputMaybe<Array<VideoParentCreateInput>>;
};

export type VideoParentCreateOneInlineInput = {
  /** Create and connect one VideoParent document */
  create?: InputMaybe<VideoParentCreateInput>;
};

export type VideoParentCreateWithPositionInput = {
  FaqAsset?: InputMaybe<FaqAssetCreateWithPositionInput>;
  SectionContent?: InputMaybe<SectionContentCreateWithPositionInput>;
};

export type VideoParentUpdateInput = {
  FaqAsset?: InputMaybe<FaqAssetUpdateInput>;
  SectionContent?: InputMaybe<SectionContentUpdateInput>;
};

export type VideoParentUpdateManyInlineInput = {
  /** Create and connect multiple VideoParent component instances */
  create?: InputMaybe<Array<VideoParentCreateWithPositionInput>>;
  /** Delete multiple VideoParent documents */
  delete?: InputMaybe<Array<VideoParentWhereUniqueInput>>;
  /** Update multiple VideoParent component instances */
  update?: InputMaybe<Array<VideoParentUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple VideoParent component instances */
  upsert?: InputMaybe<Array<VideoParentUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VideoParentUpdateManyWithNestedWhereInput = {
  FaqAsset?: InputMaybe<FaqAssetUpdateManyWithNestedWhereInput>;
  SectionContent?: InputMaybe<SectionContentUpdateManyWithNestedWhereInput>;
};

export type VideoParentUpdateOneInlineInput = {
  /** Create and connect one VideoParent document */
  create?: InputMaybe<VideoParentCreateInput>;
  /** Delete currently connected VideoParent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single VideoParent document */
  update?: InputMaybe<VideoParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single VideoParent document */
  upsert?: InputMaybe<VideoParentUpsertWithNestedWhereUniqueInput>;
};

export type VideoParentUpdateWithNestedWhereUniqueAndPositionInput = {
  FaqAsset?: InputMaybe<FaqAssetUpdateWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueAndPositionInput>;
};

export type VideoParentUpdateWithNestedWhereUniqueInput = {
  FaqAsset?: InputMaybe<FaqAssetUpdateWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpdateWithNestedWhereUniqueInput>;
};

export type VideoParentUpsertWithNestedWhereUniqueAndPositionInput = {
  FaqAsset?: InputMaybe<FaqAssetUpsertWithNestedWhereUniqueAndPositionInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueAndPositionInput>;
};

export type VideoParentUpsertWithNestedWhereUniqueInput = {
  FaqAsset?: InputMaybe<FaqAssetUpsertWithNestedWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentUpsertWithNestedWhereUniqueInput>;
};

export type VideoParentWhereInput = {
  FaqAsset?: InputMaybe<FaqAssetWhereInput>;
  SectionContent?: InputMaybe<SectionContentWhereInput>;
};

export type VideoParentWhereUniqueInput = {
  FaqAsset?: InputMaybe<FaqAssetWhereUniqueInput>;
  SectionContent?: InputMaybe<SectionContentWhereUniqueInput>;
};

export type VideoUpdateInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  fallbackImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<VideoUpdateLocalizationsInput>;
  media?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type VideoUpdateLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUpdateLocalizationInput = {
  data: VideoUpdateLocalizationDataInput;
  locale: Locale;
};

export type VideoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<VideoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<VideoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<VideoUpsertLocalizationInput>>;
};

export type VideoUpdateManyInlineInput = {
  /** Create and connect multiple Video component instances */
  create?: InputMaybe<Array<VideoCreateWithPositionInput>>;
  /** Delete multiple Video documents */
  delete?: InputMaybe<Array<VideoWhereUniqueInput>>;
  /** Update multiple Video component instances */
  update?: InputMaybe<Array<VideoUpdateWithNestedWhereUniqueAndPositionInput>>;
  /** Upsert multiple Video component instances */
  upsert?: InputMaybe<Array<VideoUpsertWithNestedWhereUniqueAndPositionInput>>;
};

export type VideoUpdateManyInput = {
  /** dummyLocalization input for default locale (en) */
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<VideoUpdateManyLocalizationsInput>;
};

export type VideoUpdateManyLocalizationDataInput = {
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
};

export type VideoUpdateManyLocalizationInput = {
  data: VideoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type VideoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<VideoUpdateManyLocalizationInput>>;
};

export type VideoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: VideoUpdateManyInput;
  /** Document search */
  where: VideoWhereInput;
};

export type VideoUpdateOneInlineInput = {
  /** Create and connect one Video document */
  create?: InputMaybe<VideoCreateInput>;
  /** Delete currently connected Video document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Video document */
  update?: InputMaybe<VideoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Video document */
  upsert?: InputMaybe<VideoUpsertWithNestedWhereUniqueInput>;
};

export type VideoUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<VideoUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoWhereUniqueInput;
};

export type VideoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: VideoUpdateInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

export type VideoUpsertInput = {
  /** Create document if it didn't exist */
  create: VideoCreateInput;
  /** Update document if it exists */
  update: VideoUpdateInput;
};

export type VideoUpsertLocalizationInput = {
  create: VideoCreateLocalizationDataInput;
  locale: Locale;
  update: VideoUpdateLocalizationDataInput;
};

export type VideoUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<VideoUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: VideoWhereUniqueInput;
};

export type VideoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: VideoUpsertInput;
  /** Unique document search */
  where: VideoWhereUniqueInput;
};

/** Identifies documents */
export type VideoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<VideoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<VideoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  dummyLocalization?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dummyLocalization_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dummyLocalization_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dummyLocalization_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dummyLocalization_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dummyLocalization_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dummyLocalization_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dummyLocalization_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dummyLocalization_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dummyLocalization_starts_with?: InputMaybe<Scalars['String']['input']>;
  fallbackImage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** References Video record uniquely */
export type VideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum _FilterKind {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR',
  Contains = 'contains',
  ContainsAll = 'contains_all',
  ContainsNone = 'contains_none',
  ContainsSome = 'contains_some',
  DescendantsOf = 'descendants_of',
  EndsWith = 'ends_with',
  Eq = 'eq',
  EqNot = 'eq_not',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in',
  JsonPathExists = 'json_path_exists',
  JsonValueRecursive = 'json_value_recursive',
  Lt = 'lt',
  Lte = 'lte',
  NotContains = 'not_contains',
  NotEndsWith = 'not_ends_with',
  NotIn = 'not_in',
  NotStartsWith = 'not_starts_with',
  RelationalEvery = 'relational_every',
  RelationalNone = 'relational_none',
  RelationalSingle = 'relational_single',
  RelationalSome = 'relational_some',
  Search = 'search',
  StartsWith = 'starts_with',
  UnionEmpty = 'union_empty',
  UnionEvery = 'union_every',
  UnionNone = 'union_none',
  UnionSingle = 'union_single',
  UnionSome = 'union_some'
}

export enum _MutationInputFieldKind {
  Enum = 'enum',
  Relation = 'relation',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Scalar = 'scalar',
  Union = 'union',
  Virtual = 'virtual'
}

export enum _MutationKind {
  Create = 'create',
  Delete = 'delete',
  DeleteMany = 'deleteMany',
  Publish = 'publish',
  PublishMany = 'publishMany',
  SchedulePublish = 'schedulePublish',
  ScheduleUnpublish = 'scheduleUnpublish',
  Unpublish = 'unpublish',
  UnpublishMany = 'unpublishMany',
  Update = 'update',
  UpdateMany = 'updateMany',
  Upsert = 'upsert'
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum _RelationInputCardinality {
  Many = 'many',
  One = 'one'
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update'
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Combined = 'combined',
  Localization = 'localization'
}

export type BaseColorFieldsFragment = { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } };

export type AssetLeafFieldsFragment = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null };

export type BaseAssetFieldsFragment = { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null };

export type BaseRichTextFieldsFragment = { __typename: 'RichText', raw: any, html: string };

export type ConfigCatalogOfferFieldsFragment = { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null };

export type ConfigAgeRatingFieldsFragment = { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null };

export type ConfigContentFieldsFragment = { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null };

export type ConfigSeoMetaTagsFieldsFragment = { __typename: 'ConfigSeoMetaTags', id: string, title?: string | null, description?: string | null, socialTitle?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null };

export type AlertFieldsFragment = { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> };

export type ButtonFieldsFragment = { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null };

export type LinkFieldsFragment = { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null };

export type TextFieldsFragment = { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant };

export type TooltipFieldsFragment = { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null };

export type CardLinkFieldsFragment = { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } };

export type CardLinksFieldsFragment = { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> };

export type CatalogOfferCardsFieldsFragment = { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> };

export type CkeditorTextFieldsFragment = { __typename: 'CkeditorText', ckText?: string | null };

export type ContentBlockFieldsFragment = { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null };

export type FaqAssetFieldsFragment = { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null };

export type FaqItemFieldsFragment = { __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null };

export type ImageTagFieldsFragment = { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null };

export type ProductDisclaimerFieldsFragment = { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null };

export type VideoFieldsFragment = { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } };

export type PageHeroSectionFieldsFragment = { __typename: 'CommonPageHeroSection', id: string, createdAt: any, updatedAt: any, slug: string, refSections: Array<{ __typename?: 'CommonSection', section?:
      | { __typename: 'SectionContent', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, masthead?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null, components: Array<
          | { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }
          | { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null }
          | { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
          | { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> }
          | { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> }
          | { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }
          | { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
          | { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null }
          | { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null }
          | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
          | { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }
          | { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
          | { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
        > }
      | { __typename: 'SectionFaq', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, asset?: { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null } | null, faq?: { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> } | null }
      | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
     | null }>, metaTags?: { __typename: 'ConfigSeoMetaTags', id: string, title?: string | null, description?: string | null, socialTitle?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PageHeroSectionMetadataFieldsFragment = { __typename: 'CommonPageHeroSection', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename: 'ConfigSeoMetaTags', id: string, title?: string | null, description?: string | null, socialTitle?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null };

export type PageHeroSectionEntitiesFragment = { __typename: 'CommonPageHeroSection', id: string, createdAt: any, updatedAt: any, slug: string, refSections: Array<{ __typename?: 'CommonSection', section?:
      | { __typename: 'SectionContent', id: string, stage: Stage }
      | { __typename: 'SectionFaq', id: string, stage: Stage }
      | { __typename: 'SectionSideBySide', id: string, stage: Stage }
     | null }> };

export type SitemapPageFieldsFragment = { __typename: 'CommonPageHeroSection', id: string, slug: string, updatedAt: any, metaTags?: { __typename?: 'ConfigSeoMetaTags', id: string, noIndex?: boolean | null } | null };

type CommonEntityFields_Alert_Fragment = { __typename: 'Alert', id: string, stage: Stage };

type CommonEntityFields_Asset_Fragment = { __typename: 'Asset', id: string, stage: Stage };

type CommonEntityFields_Button_Fragment = { __typename: 'Button', id: string, stage: Stage };

type CommonEntityFields_CardLink_Fragment = { __typename: 'CardLink', id: string, stage: Stage };

type CommonEntityFields_CardLinks_Fragment = { __typename: 'CardLinks', id: string, stage: Stage };

type CommonEntityFields_CatalogOfferCards_Fragment = { __typename: 'CatalogOfferCards', id: string, stage: Stage };

type CommonEntityFields_CkeditorText_Fragment = { __typename: 'CkeditorText', id: string, stage: Stage };

type CommonEntityFields_CommonEulaKey_Fragment = { __typename: 'CommonEulaKey', id: string, stage: Stage };

type CommonEntityFields_CommonFaq_Fragment = { __typename: 'CommonFaq', id: string, stage: Stage };

type CommonEntityFields_CommonPageHeroSection_Fragment = { __typename: 'CommonPageHeroSection', id: string, stage: Stage };

type CommonEntityFields_CommonSection_Fragment = { __typename: 'CommonSection', id: string, stage: Stage };

type CommonEntityFields_ConfigAgeRating_Fragment = { __typename: 'ConfigAgeRating', id: string, stage: Stage };

type CommonEntityFields_ConfigCatalogOffer_Fragment = { __typename: 'ConfigCatalogOffer', id: string, stage: Stage };

type CommonEntityFields_ConfigContent_Fragment = { __typename: 'ConfigContent', id: string, stage: Stage };

type CommonEntityFields_ConfigSeoMetaTags_Fragment = { __typename: 'ConfigSeoMetaTags', id: string, stage: Stage };

type CommonEntityFields_ContentBlock_Fragment = { __typename: 'ContentBlock', id: string, stage: Stage };

type CommonEntityFields_Cta_Fragment = { __typename: 'Cta', id: string, stage: Stage };

type CommonEntityFields_FaqAsset_Fragment = { __typename: 'FaqAsset', id: string, stage: Stage };

type CommonEntityFields_FaqItem_Fragment = { __typename: 'FaqItem', id: string, stage: Stage };

type CommonEntityFields_FaqSet_Fragment = { __typename: 'FaqSet', id: string, stage: Stage };

type CommonEntityFields_FaqSetItem_Fragment = { __typename: 'FaqSetItem', id: string, stage: Stage };

type CommonEntityFields_ImageTag_Fragment = { __typename: 'ImageTag', id: string, stage: Stage };

type CommonEntityFields_Link_Fragment = { __typename: 'Link', id: string, stage: Stage };

type CommonEntityFields_ProductDisclaimer_Fragment = { __typename: 'ProductDisclaimer', id: string, stage: Stage };

type CommonEntityFields_ScheduledOperation_Fragment = { __typename: 'ScheduledOperation', id: string, stage: Stage };

type CommonEntityFields_ScheduledRelease_Fragment = { __typename: 'ScheduledRelease', id: string, stage: Stage };

type CommonEntityFields_SectionContent_Fragment = { __typename: 'SectionContent', id: string, stage: Stage };

type CommonEntityFields_SectionFaq_Fragment = { __typename: 'SectionFaq', id: string, stage: Stage };

type CommonEntityFields_SectionSideBySide_Fragment = { __typename: 'SectionSideBySide', id: string, stage: Stage };

type CommonEntityFields_SiteSetting_Fragment = { __typename: 'SiteSetting', id: string, stage: Stage };

type CommonEntityFields_Text_Fragment = { __typename: 'Text', id: string, stage: Stage };

type CommonEntityFields_Tooltip_Fragment = { __typename: 'Tooltip', id: string, stage: Stage };

type CommonEntityFields_User_Fragment = { __typename: 'User', id: string, stage: Stage };

type CommonEntityFields_Video_Fragment = { __typename: 'Video', id: string, stage: Stage };

export type CommonEntityFieldsFragment =
  | CommonEntityFields_Alert_Fragment
  | CommonEntityFields_Asset_Fragment
  | CommonEntityFields_Button_Fragment
  | CommonEntityFields_CardLink_Fragment
  | CommonEntityFields_CardLinks_Fragment
  | CommonEntityFields_CatalogOfferCards_Fragment
  | CommonEntityFields_CkeditorText_Fragment
  | CommonEntityFields_CommonEulaKey_Fragment
  | CommonEntityFields_CommonFaq_Fragment
  | CommonEntityFields_CommonPageHeroSection_Fragment
  | CommonEntityFields_CommonSection_Fragment
  | CommonEntityFields_ConfigAgeRating_Fragment
  | CommonEntityFields_ConfigCatalogOffer_Fragment
  | CommonEntityFields_ConfigContent_Fragment
  | CommonEntityFields_ConfigSeoMetaTags_Fragment
  | CommonEntityFields_ContentBlock_Fragment
  | CommonEntityFields_Cta_Fragment
  | CommonEntityFields_FaqAsset_Fragment
  | CommonEntityFields_FaqItem_Fragment
  | CommonEntityFields_FaqSet_Fragment
  | CommonEntityFields_FaqSetItem_Fragment
  | CommonEntityFields_ImageTag_Fragment
  | CommonEntityFields_Link_Fragment
  | CommonEntityFields_ProductDisclaimer_Fragment
  | CommonEntityFields_ScheduledOperation_Fragment
  | CommonEntityFields_ScheduledRelease_Fragment
  | CommonEntityFields_SectionContent_Fragment
  | CommonEntityFields_SectionFaq_Fragment
  | CommonEntityFields_SectionSideBySide_Fragment
  | CommonEntityFields_SiteSetting_Fragment
  | CommonEntityFields_Text_Fragment
  | CommonEntityFields_Tooltip_Fragment
  | CommonEntityFields_User_Fragment
  | CommonEntityFields_Video_Fragment
;

export type RefFaqFieldsFragment = { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> };

export type RefSectionFieldsFragment = { __typename?: 'CommonSection', section?:
    | { __typename: 'SectionContent', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, masthead?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null, components: Array<
        | { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }
        | { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null }
        | { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
        | { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> }
        | { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> }
        | { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }
        | { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
        | { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null }
        | { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null }
        | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
        | { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }
        | { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
        | { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
      > }
    | { __typename: 'SectionFaq', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, asset?: { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null } | null, faq?: { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> } | null }
    | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
   | null };

export type RefSectionEntitiesFragment = { __typename?: 'CommonSection', section?:
    | { __typename: 'SectionContent', id: string, stage: Stage }
    | { __typename: 'SectionFaq', id: string, stage: Stage }
    | { __typename: 'SectionSideBySide', id: string, stage: Stage }
   | null };

export type SectionFaqFieldsFragment = { __typename: 'SectionFaq', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, asset?: { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null } | null, faq?: { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> } | null };

export type SectionContentFieldsFragment = { __typename: 'SectionContent', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, masthead?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null, components: Array<
    | { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }
    | { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null }
    | { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
    | { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> }
    | { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> }
    | { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }
    | { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
    | { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null }
    | { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null }
    | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
    | { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }
    | { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
    | { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
  > };

export type SectionSideBySideFieldsFragment = { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null };

type PageSections_SectionContent_Fragment = { __typename: 'SectionContent', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, masthead?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null, components: Array<
    | { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }
    | { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null }
    | { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
    | { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> }
    | { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> }
    | { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }
    | { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
    | { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null }
    | { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null }
    | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
    | { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }
    | { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
    | { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
  > };

type PageSections_SectionFaq_Fragment = { __typename: 'SectionFaq', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, asset?: { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null } | null, faq?: { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> } | null };

type PageSections_SectionSideBySide_Fragment = { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null };

export type PageSectionsFragment =
  | PageSections_SectionContent_Fragment
  | PageSections_SectionFaq_Fragment
  | PageSections_SectionSideBySide_Fragment
;

export type SiteSettingFieldsFragment = { __typename: 'SiteSetting', redeemDisabled?: boolean | null, siteBannerEnabled: boolean, siteBannerStatus?: EdsStatus | null, siteBannerIcon?: EdsIcon | null, siteBannerMessage?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null };

export type PageSectionsQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type PageSectionsQuery = { __typename?: 'Query', entities?: Array<
    | { __typename?: 'Alert' }
    | { __typename?: 'Asset' }
    | { __typename?: 'Button' }
    | { __typename?: 'CardLink' }
    | { __typename?: 'CardLinks' }
    | { __typename?: 'CatalogOfferCards' }
    | { __typename?: 'CkeditorText' }
    | { __typename?: 'CommonEulaKey' }
    | { __typename?: 'CommonFaq' }
    | { __typename?: 'CommonPageHeroSection' }
    | { __typename?: 'CommonSection' }
    | { __typename?: 'ConfigAgeRating' }
    | { __typename?: 'ConfigCatalogOffer' }
    | { __typename?: 'ConfigContent' }
    | { __typename?: 'ConfigSeoMetaTags' }
    | { __typename?: 'ContentBlock' }
    | { __typename?: 'Cta' }
    | { __typename?: 'FaqAsset' }
    | { __typename?: 'FaqItem' }
    | { __typename?: 'FaqSet' }
    | { __typename?: 'FaqSetItem' }
    | { __typename?: 'ImageTag' }
    | { __typename?: 'Link' }
    | { __typename?: 'ProductDisclaimer' }
    | { __typename?: 'ScheduledOperation' }
    | { __typename?: 'ScheduledRelease' }
    | { __typename: 'SectionContent', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, masthead?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null, components: Array<
        | { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }
        | { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null }
        | { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
        | { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> }
        | { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> }
        | { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }
        | { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
        | { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null }
        | { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null }
        | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
        | { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }
        | { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
        | { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
      > }
    | { __typename: 'SectionFaq', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, asset?: { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null } | null, faq?: { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> } | null }
    | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
    | { __typename?: 'SiteSetting' }
    | { __typename?: 'Text' }
    | { __typename?: 'Tooltip' }
    | { __typename?: 'User' }
    | { __typename?: 'Video' }
  > | null };

export type PageSectionContentQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type PageSectionContentQuery = { __typename?: 'Query', entities?: Array<
    | { __typename?: 'Alert' }
    | { __typename?: 'Asset' }
    | { __typename?: 'Button' }
    | { __typename?: 'CardLink' }
    | { __typename?: 'CardLinks' }
    | { __typename?: 'CatalogOfferCards' }
    | { __typename?: 'CkeditorText' }
    | { __typename?: 'CommonEulaKey' }
    | { __typename?: 'CommonFaq' }
    | { __typename?: 'CommonPageHeroSection' }
    | { __typename?: 'CommonSection' }
    | { __typename?: 'ConfigAgeRating' }
    | { __typename?: 'ConfigCatalogOffer' }
    | { __typename?: 'ConfigContent' }
    | { __typename?: 'ConfigSeoMetaTags' }
    | { __typename?: 'ContentBlock' }
    | { __typename?: 'Cta' }
    | { __typename?: 'FaqAsset' }
    | { __typename?: 'FaqItem' }
    | { __typename?: 'FaqSet' }
    | { __typename?: 'FaqSetItem' }
    | { __typename?: 'ImageTag' }
    | { __typename?: 'Link' }
    | { __typename?: 'ProductDisclaimer' }
    | { __typename?: 'ScheduledOperation' }
    | { __typename?: 'ScheduledRelease' }
    | { __typename: 'SectionContent', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, masthead?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null, components: Array<
        | { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }
        | { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null }
        | { __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
        | { __typename: 'CardLinks', items: Array<{ __typename: 'CardLink', title: string, description: string, cardLink: string, asset: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }> }
        | { __typename: 'CatalogOfferCards', ukey: string, variant?: CatalogOfferCardVariant | null, checkout?: boolean | null, sandboxId: string, offers: Array<{ __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }> }
        | { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null }
        | { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
        | { __typename: 'Link', relativePath?: string | null, useRelativePath?: boolean | null, ukey: string, linkLabel: string, linkHref?: string | null }
        | { __typename: 'ProductDisclaimer', disclaimer: { __typename: 'Alert', hide?: boolean | null, alertVariant: EdsAlertVariant, alertStatus?: EdsStatus | null, alertTitle?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, alertMessage: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }> }, ageRating?: { __typename: 'ConfigAgeRating', itemId?: string | null, catalogOffer?: { __typename: 'ConfigCatalogOffer', offerId: string, overrideOfferFields?: boolean | null, offerTitle?: string | null, offerDesc?: string | null } | null } | null }
        | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
        | { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }
        | { __typename: 'Tooltip', side?: EdsTooltipSide | null, textLabel: Array<{ __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant }>, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null }
        | { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } }
      > }
    | { __typename?: 'SectionFaq' }
    | { __typename?: 'SectionSideBySide' }
    | { __typename?: 'SiteSetting' }
    | { __typename?: 'Text' }
    | { __typename?: 'Tooltip' }
    | { __typename?: 'User' }
    | { __typename?: 'Video' }
  > | null };

export type PageSectionFaqQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type PageSectionFaqQuery = { __typename?: 'Query', entities?: Array<
    | { __typename?: 'Alert' }
    | { __typename?: 'Asset' }
    | { __typename?: 'Button' }
    | { __typename?: 'CardLink' }
    | { __typename?: 'CardLinks' }
    | { __typename?: 'CatalogOfferCards' }
    | { __typename?: 'CkeditorText' }
    | { __typename?: 'CommonEulaKey' }
    | { __typename?: 'CommonFaq' }
    | { __typename?: 'CommonPageHeroSection' }
    | { __typename?: 'CommonSection' }
    | { __typename?: 'ConfigAgeRating' }
    | { __typename?: 'ConfigCatalogOffer' }
    | { __typename?: 'ConfigContent' }
    | { __typename?: 'ConfigSeoMetaTags' }
    | { __typename?: 'ContentBlock' }
    | { __typename?: 'Cta' }
    | { __typename?: 'FaqAsset' }
    | { __typename?: 'FaqItem' }
    | { __typename?: 'FaqSet' }
    | { __typename?: 'FaqSetItem' }
    | { __typename?: 'ImageTag' }
    | { __typename?: 'Link' }
    | { __typename?: 'ProductDisclaimer' }
    | { __typename?: 'ScheduledOperation' }
    | { __typename?: 'ScheduledRelease' }
    | { __typename?: 'SectionContent' }
    | { __typename: 'SectionFaq', config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, asset?: { __typename: 'FaqAsset', title?: string | null, asset?: { __typename: 'Video', media: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null }, fallbackImage: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } } | null, desc?: { __typename: 'RichText', raw: any, html: string } | null } | null, faq?: { __typename: 'CommonFaq', title: string, items: Array<{ __typename: 'FaqItem', question: string, defaultOpen?: boolean | null, hidden?: boolean | null, answer?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> } | null }
    | { __typename?: 'SectionSideBySide' }
    | { __typename?: 'SiteSetting' }
    | { __typename?: 'Text' }
    | { __typename?: 'Tooltip' }
    | { __typename?: 'User' }
    | { __typename?: 'Video' }
  > | null };

export type PageSectionSideBySideQueryVariables = Exact<{
  entities: Array<EntityWhereInput> | EntityWhereInput;
  locale?: InputMaybe<Array<Locale> | Locale>;
}>;


export type PageSectionSideBySideQuery = { __typename?: 'Query', entities?: Array<
    | { __typename?: 'Alert' }
    | { __typename?: 'Asset' }
    | { __typename?: 'Button' }
    | { __typename?: 'CardLink' }
    | { __typename?: 'CardLinks' }
    | { __typename?: 'CatalogOfferCards' }
    | { __typename?: 'CkeditorText' }
    | { __typename?: 'CommonEulaKey' }
    | { __typename?: 'CommonFaq' }
    | { __typename?: 'CommonPageHeroSection' }
    | { __typename?: 'CommonSection' }
    | { __typename?: 'ConfigAgeRating' }
    | { __typename?: 'ConfigCatalogOffer' }
    | { __typename?: 'ConfigContent' }
    | { __typename?: 'ConfigSeoMetaTags' }
    | { __typename?: 'ContentBlock' }
    | { __typename?: 'Cta' }
    | { __typename?: 'FaqAsset' }
    | { __typename?: 'FaqItem' }
    | { __typename?: 'FaqSet' }
    | { __typename?: 'FaqSetItem' }
    | { __typename?: 'ImageTag' }
    | { __typename?: 'Link' }
    | { __typename?: 'ProductDisclaimer' }
    | { __typename?: 'ScheduledOperation' }
    | { __typename?: 'ScheduledRelease' }
    | { __typename?: 'SectionContent' }
    | { __typename?: 'SectionFaq' }
    | { __typename: 'SectionSideBySide', formVariant: FormVariant, config?: { __typename: 'ConfigContent', sectionId?: string | null, backgroundColor?: { __typename: 'Color', hex: any, rgba: { __typename?: 'RGBA', r: any, g: any, b: any, a: any } } | null, backgroundImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, image?: { __typename: 'ImageTag', imgLabel?: string | null, imgLink?: string | null, image?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string, mobileImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null, fallbackImage?: { __typename: 'Asset', id: string, url: string, width?: number | null, height?: number | null, fileName: string, mimeType?: string | null, size?: number | null, altText?: string | null, optUrl: string } | null } | null } | null, content?: { __typename: 'ContentBlock', id: string, heading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, subheading?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null, button?: { __typename: 'Button', icon?: EdsIcon | null, iconPosition?: EdsIconPosition | null, size?: EdsSize | null, ukey: string, btnLabel: string, btnHref?: string | null, btnVariant?: EdsButtonVariant | null } | null } | null }
    | { __typename?: 'SiteSetting' }
    | { __typename?: 'Text' }
    | { __typename?: 'Tooltip' }
    | { __typename?: 'User' }
    | { __typename?: 'Video' }
  > | null };

export type CommonPageHeroSectionMetadataQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CommonPageHeroSectionMetadataQuery = { __typename?: 'Query', commonPageHeroSection?: { __typename: 'CommonPageHeroSection', id: string, createdAt: any, updatedAt: any, slug: string, metaTags?: { __typename: 'ConfigSeoMetaTags', id: string, title?: string | null, description?: string | null, socialTitle?: string | null, socialDescription?: string | null, noIndex?: boolean | null, noFollow?: boolean | null, openGraphImage?: { __typename?: 'Asset', url: string, width?: number | null, height?: number | null } | null } | null } | null };

export type CommonPageHeroSectionEntitiesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
  slug: Scalars['String']['input'];
}>;


export type CommonPageHeroSectionEntitiesQuery = { __typename?: 'Query', commonPageHeroSection?: { __typename: 'CommonPageHeroSection', id: string, createdAt: any, updatedAt: any, slug: string, refSections: Array<{ __typename?: 'CommonSection', section?:
        | { __typename: 'SectionContent', id: string, stage: Stage }
        | { __typename: 'SectionFaq', id: string, stage: Stage }
        | { __typename: 'SectionSideBySide', id: string, stage: Stage }
       | null }> } | null };

export type SitemapPagesQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
}>;


export type SitemapPagesQuery = { __typename?: 'Query', commonPageHeroSections: Array<{ __typename: 'CommonPageHeroSection', id: string, slug: string, updatedAt: any, metaTags?: { __typename?: 'ConfigSeoMetaTags', id: string, noIndex?: boolean | null } | null }> };

export type SiteSettingQueryVariables = Exact<{
  locale: Array<Locale> | Locale;
}>;


export type SiteSettingQuery = { __typename?: 'Query', siteSettings: Array<{ __typename: 'SiteSetting', redeemDisabled?: boolean | null, siteBannerEnabled: boolean, siteBannerStatus?: EdsStatus | null, siteBannerIcon?: EdsIcon | null, siteBannerMessage?: { __typename: 'Text', html: string, color: EdsColor, ukey: string, textVariant: EdsTextVariant } | null }> };
